/* eslint-disable */
(function () {
    'use strict';
    try {
        if (typeof document < 'u') {
            var t = document.createElement('style');
            (t.appendChild(
                document.createTextNode(
                    '@import"https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap";._root_1s9hm_1{display:flex;justify-content:space-between;align-items:center;border:1px solid #222222;padding:8px 16px;border-radius:8px;gap:8px;cursor:pointer;max-width:429px}._root_1s9hm_1._dark_1s9hm_12{color:#fff;border:1px solid white;background:#000}._text_1s9hm_18{font-size:16px;font-style:normal;font-weight:700;line-height:20px}._link_1s9hm_25{display:flex;align-items:center;gap:8px;font-size:14px;font-style:normal;font-weight:400;line-height:24px}._root_16fmr_1{display:flex;justify-content:space-between;align-items:center;padding:8px 16px;border-radius:8px;cursor:pointer;max-width:429px}._root_16fmr_1._dark_16fmr_10{color:#fff;background:#000}._text_16fmr_15{font-size:16px;font-style:normal;font-weight:700;line-height:20px}._link_16fmr_22{display:flex;align-items:center;gap:8px;font-size:14px;font-style:normal;font-weight:400;line-height:24px}._root_1u9kw_1{display:flex;justify-content:space-between;align-items:center;padding:8px 16px;border-radius:8px;cursor:pointer;max-width:429px;border:1px solid #222222}._root_1u9kw_1._dark_1u9kw_11{color:#fff;background:#000;border:1px solid white}._text_1u9kw_17{font-size:16px;font-style:normal;font-weight:700;line-height:20px}._link_1u9kw_24{display:flex;align-items:center;gap:8px;font-size:14px;font-style:normal;font-weight:400;line-height:24px}._root_1cs5x_1{display:flex;justify-content:space-between;max-width:249px;width:auto;padding:16px;border:1px solid #222222;border-radius:16px;gap:16px;color:#222;cursor:pointer}._root_1cs5x_1._dark_1cs5x_13{color:#fff;border:1px solid white;background:#000}._container_1cs5x_19{display:flex;flex-direction:column;gap:4px}._text_1cs5x_25{font-size:18px;font-style:normal;font-weight:700;line-height:20px}._sumPay_1cs5x_32{font-size:14px;font-style:normal;font-weight:400;line-height:20px}._link_1cs5x_39{font-size:14px;font-style:italic;font-weight:400;line-height:20px;text-decoration-line:underline}._root_1a58k_1{color:#525252;flex:1}._root_1a58k_1._dark_1a58k_5{color:#fff}._line_1a58k_9{border-radius:8px;height:6px;background:#ddd}._sum_1a58k_15{font-size:16px;font-style:normal;font-weight:800;line-height:24px}._active_1a58k_22{color:#222}._active_1a58k_22 ._line_1a58k_9{background:#7bcd00}._root_w28u7_1{max-width:388px;padding:16px;border:1px solid #222222;border-radius:24px;color:#222;cursor:pointer}._root_w28u7_1._dark_w28u7_9{color:#fff;border:1px solid white;background:#000}._root_w28u7_1._dark_w28u7_9 ._icon_w28u7_14{color:#fff}._title_container_w28u7_18{display:flex;justify-content:space-between;margin-bottom:12px;font-size:18px;font-style:normal;font-weight:700;line-height:20px}._title_w28u7_18,._schedule_w28u7_33{display:flex;gap:8px}._wide_15mzm_1{max-width:100%}._root_1hact_1{position:fixed;inset:0;z-index:100;overflow:auto;-webkit-overflow-scrolling:touch;background-color:#3a4259b3;display:flex;align-items:center;justify-content:center;font-family:Source Sans Pro,Arial,Helvetica,sans-serif}._root_1hact_1._dark_1hact_16 ._inner_1hact_16,._root_1hact_1._dark_1hact_16 ._description_1hact_17,._root_1hact_1._dark_1hact_16 ._title_1hact_18,._root_1hact_1._dark_1hact_16 ._header_1hact_19,._root_1hact_1._dark_1hact_16 ._content_1hact_20,._root_1hact_1._dark_1hact_16 ._buttons-inner_1hact_21{background:#444;color:#fff}._header_1hact_19{display:flex;justify-content:center;flex-direction:column;flex-wrap:wrap;text-align:left;font-size:20px;font-style:normal;font-weight:700;line-height:28px;color:#222;margin-bottom:32px}._title_1hact_18{font-size:28px;font-style:normal;font-weight:700;line-height:36px}._description_1hact_17{font-size:20px;font-style:normal;font-weight:400;line-height:28px;margin-top:16px;color:#222}._inner_1hact_16{position:relative;padding:40px 64px;background:#fff;box-shadow:0 16px 48px #495c8829;flex:0 1 auto;border-radius:32px;max-width:600px;box-sizing:border-box}._container_1hact_67{position:relative;display:flex;justify-content:center}._content_1hact_20{font-weight:400;font-size:14px;line-height:20px;color:#525252;margin-top:32px}._buttons-inner_1hact_21{margin-left:-16px;margin-right:-16px;width:100%;color:#222}._footer_1hact_88{display:flex;align-items:center;justify-content:center}._close_1hact_94{position:absolute;top:24px;right:24px;cursor:pointer}@media (max-width: 768px){._root_1hact_1{display:flex;flex-direction:column;justify-content:flex-end}._inner_1hact_16{padding:24px 16px;border-radius:16px 16px 0 0}._header_1hact_19{margin-bottom:24px}}._link_bih1d_1{display:flex;align-items:center;justify-content:center;gap:8px;font-size:16px;font-style:normal;font-weight:400;line-height:24px;margin-top:32px;text-decoration:none;cursor:pointer;color:#222}._link_bih1d_1._white_bih1d_15{color:#fff}._widget_bih1d_19{padding:0;border:0!important;max-width:100%;background:transparent!important;margin-bottom:32px}.bnpl-widget{font-family:Source Sans Pro,Arial,Helvetica,sans-serif;box-sizing:border-box}'
                )
            ),
                document.head.appendChild(t));
        }
    } catch (e) {
        console.error('vite-plugin-css-injected-by-js', e);
    }
})();
var oi = {};
/**
 * @vue/shared v3.4.15
 * (c) 2018-present Yuxi (Evan) You and Vue contributors
 * @license MIT
 **/
function Ke(e, t) {
    const n = new Set(e.split(','));
    return t ? (r) => n.has(r.toLowerCase()) : (r) => n.has(r);
}
const Z = oi.NODE_ENV !== 'production' ? Object.freeze({}) : {},
    Rt = oi.NODE_ENV !== 'production' ? Object.freeze([]) : [],
    ae = () => {},
    ii = () => !1,
    fn = (e) =>
        e.charCodeAt(0) === 111 &&
        e.charCodeAt(1) === 110 && // uppercase letter
        (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97),
    Pn = (e) => e.startsWith('onUpdate:'),
    se = Object.assign,
    Wr = (e, t) => {
        const n = e.indexOf(t);
        n > -1 && e.splice(n, 1);
    },
    Ts = Object.prototype.hasOwnProperty,
    H = (e, t) => Ts.call(e, t),
    M = Array.isArray,
    yt = (e) => Hn(e) === '[object Map]',
    si = (e) => Hn(e) === '[object Set]',
    S = (e) => typeof e == 'function',
    re = (e) => typeof e == 'string',
    Bt = (e) => typeof e == 'symbol',
    ee = (e) => e !== null && typeof e == 'object',
    Lr = (e) => (ee(e) || S(e)) && S(e.then) && S(e.catch),
    ai = Object.prototype.toString,
    Hn = (e) => ai.call(e),
    Ur = (e) => Hn(e).slice(8, -1),
    li = (e) => Hn(e) === '[object Object]',
    jr = (e) => re(e) && e !== 'NaN' && e[0] !== '-' && '' + parseInt(e, 10) === e,
    Dn = /* @__PURE__ */ Ke(
        // the leading comma is intentional so empty string "" is also included
        ',key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted'
    ),
    xs = /* @__PURE__ */ Ke('bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo'),
    Gn = (e) => {
        const t = /* @__PURE__ */ Object.create(null);
        return (n) => t[n] || (t[n] = e(n));
    },
    Vs = /-(\w)/g,
    Ue = Gn((e) => e.replace(Vs, (t, n) => (n ? n.toUpperCase() : ''))),
    Ms = /\B([A-Z])/g,
    st = Gn((e) => e.replace(Ms, '-$1').toLowerCase()),
    $t = Gn((e) => e.charAt(0).toUpperCase() + e.slice(1)),
    mt = Gn((e) => (e ? `on${$t(e)}` : '')),
    at = (e, t) => !Object.is(e, t),
    Xt = (e, t) => {
        for (let n = 0; n < e.length; n++) e[n](t);
    },
    Sn = (e, t, n) => {
        Object.defineProperty(e, t, {
            configurable: !0,
            enumerable: !1,
            value: n,
        });
    },
    Ps = (e) => {
        const t = parseFloat(e);
        return isNaN(t) ? e : t;
    };
let po;
const Hr = () =>
    po ||
    (po =
        typeof globalThis < 'u'
            ? globalThis
            : typeof self < 'u'
              ? self
              : typeof window < 'u'
                ? window
                : typeof global < 'u'
                  ? global
                  : {});
function Gr(e) {
    if (M(e)) {
        const t = {};
        for (let n = 0; n < e.length; n++) {
            const r = e[n],
                o = re(r) ? As(r) : Gr(r);
            if (o) for (const i in o) t[i] = o[i];
        }
        return t;
    } else if (re(e) || ee(e)) return e;
}
const Ss = /;(?![^(]*\))/g,
    ks = /:([^]+)/,
    Is = /\/\*[^]*?\*\//g;
function As(e) {
    const t = {};
    return (
        e
            .replace(Is, '')
            .split(Ss)
            .forEach((n) => {
                if (n) {
                    const r = n.split(ks);
                    r.length > 1 && (t[r[0].trim()] = r[1].trim());
                }
            }),
        t
    );
}
function U(e) {
    let t = '';
    if (re(e)) t = e;
    else if (M(e))
        for (let n = 0; n < e.length; n++) {
            const r = U(e[n]);
            r && (t += r + ' ');
        }
    else if (ee(e)) for (const n in e) e[n] && (t += n + ' ');
    return t.trim();
}
const Fs =
        'html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot',
    Rs =
        'svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view',
    Ws =
        'annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics',
    Ls = /* @__PURE__ */ Ke(Fs),
    Us = /* @__PURE__ */ Ke(Rs),
    js = /* @__PURE__ */ Ke(Ws),
    Hs = 'itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly',
    Gs = /* @__PURE__ */ Ke(Hs);
function ui(e) {
    return !!e || e === '';
}
const jt = (e) =>
        re(e)
            ? e
            : e == null
              ? ''
              : M(e) || (ee(e) && (e.toString === ai || !S(e.toString)))
                ? JSON.stringify(e, ci, 2)
                : String(e),
    ci = (e, t) =>
        t && t.__v_isRef
            ? ci(e, t.value)
            : yt(t)
              ? {
                    [`Map(${t.size})`]: [...t.entries()].reduce((n, [r, o], i) => ((n[ur(r, i) + ' =>'] = o), n), {}),
                }
              : si(t)
                ? {
                      [`Set(${t.size})`]: [...t.values()].map((n) => ur(n)),
                  }
                : Bt(t)
                  ? ur(t)
                  : ee(t) && !M(t) && !li(t)
                    ? String(t)
                    : t,
    ur = (e, t = '') => {
        var n;
        return Bt(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e;
    };
var he = {};
function _r(e, ...t) {
    console.warn(`[Vue warn] ${e}`, ...t);
}
let xe;
class Bs {
    constructor(t = !1) {
        ((this.detached = t),
            (this._active = !0),
            (this.effects = []),
            (this.cleanups = []),
            (this.parent = xe),
            !t && xe && (this.index = (xe.scopes || (xe.scopes = [])).push(this) - 1));
    }
    get active() {
        return this._active;
    }
    run(t) {
        if (this._active) {
            const n = xe;
            try {
                return ((xe = this), t());
            } finally {
                xe = n;
            }
        } else he.NODE_ENV !== 'production' && _r('cannot run an inactive effect scope.');
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    on() {
        xe = this;
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    off() {
        xe = this.parent;
    }
    stop(t) {
        if (this._active) {
            let n, r;
            for (n = 0, r = this.effects.length; n < r; n++) this.effects[n].stop();
            for (n = 0, r = this.cleanups.length; n < r; n++) this.cleanups[n]();
            if (this.scopes) for (n = 0, r = this.scopes.length; n < r; n++) this.scopes[n].stop(!0);
            if (!this.detached && this.parent && !t) {
                const o = this.parent.scopes.pop();
                o && o !== this && ((this.parent.scopes[this.index] = o), (o.index = this.index));
            }
            ((this.parent = void 0), (this._active = !1));
        }
    }
}
function Ys(e, t = xe) {
    t && t.active && t.effects.push(e);
}
function qs() {
    return xe;
}
let bt;
class Br {
    constructor(t, n, r, o) {
        ((this.fn = t),
            (this.trigger = n),
            (this.scheduler = r),
            (this.active = !0),
            (this.deps = []),
            (this._dirtyLevel = 2),
            (this._trackId = 0),
            (this._runnings = 0),
            (this._shouldSchedule = !1),
            (this._depsLength = 0),
            Ys(this, o));
    }
    get dirty() {
        if (this._dirtyLevel === 1) {
            ft();
            for (let t = 0; t < this._depsLength; t++) {
                const n = this.deps[t];
                if (n.computed && (Ks(n.computed), this._dirtyLevel >= 2)) break;
            }
            (this._dirtyLevel < 2 && (this._dirtyLevel = 0), dt());
        }
        return this._dirtyLevel >= 2;
    }
    set dirty(t) {
        this._dirtyLevel = t ? 2 : 0;
    }
    run() {
        if (((this._dirtyLevel = 0), !this.active)) return this.fn();
        let t = ot,
            n = bt;
        try {
            return ((ot = !0), (bt = this), this._runnings++, ho(this), this.fn());
        } finally {
            (mo(this), this._runnings--, (bt = n), (ot = t));
        }
    }
    stop() {
        var t;
        this.active && (ho(this), mo(this), (t = this.onStop) == null || t.call(this), (this.active = !1));
    }
}
function Ks(e) {
    return e.value;
}
function ho(e) {
    (e._trackId++, (e._depsLength = 0));
}
function mo(e) {
    if (e.deps && e.deps.length > e._depsLength) {
        for (let t = e._depsLength; t < e.deps.length; t++) fi(e.deps[t], e);
        e.deps.length = e._depsLength;
    }
}
function fi(e, t) {
    const n = e.get(t);
    n !== void 0 && t._trackId !== n && (e.delete(t), e.size === 0 && e.cleanup());
}
let ot = !0,
    yr = 0;
const di = [];
function ft() {
    (di.push(ot), (ot = !1));
}
function dt() {
    const e = di.pop();
    ot = e === void 0 ? !0 : e;
}
function Yr() {
    yr++;
}
function qr() {
    for (yr--; !yr && br.length;) br.shift()();
}
function pi(e, t, n) {
    var r;
    if (t.get(e) !== e._trackId) {
        t.set(e, e._trackId);
        const o = e.deps[e._depsLength];
        (o !== t ? (o && fi(o, e), (e.deps[e._depsLength++] = t)) : e._depsLength++,
            he.NODE_ENV !== 'production' && ((r = e.onTrack) == null || r.call(e, se({effect: e}, n))));
    }
}
const br = [];
function hi(e, t, n) {
    var r;
    Yr();
    for (const o of e.keys())
        if (o._dirtyLevel < t && e.get(o) === o._trackId) {
            const i = o._dirtyLevel;
            ((o._dirtyLevel = t),
                i === 0 &&
                    ((o._shouldSchedule = !0),
                    he.NODE_ENV !== 'production' && ((r = o.onTrigger) == null || r.call(o, se({effect: o}, n))),
                    o.trigger()));
        }
    (mi(e), qr());
}
function mi(e) {
    for (const t of e.keys())
        t.scheduler &&
            t._shouldSchedule &&
            (!t._runnings || t.allowRecurse) &&
            e.get(t) === t._trackId &&
            ((t._shouldSchedule = !1), br.push(t.scheduler));
}
const gi = (e, t) => {
        const n = /* @__PURE__ */ new Map();
        return ((n.cleanup = e), (n.computed = t), n);
    },
    wr = /* @__PURE__ */ new WeakMap(),
    wt = Symbol(he.NODE_ENV !== 'production' ? 'iterate' : ''),
    Er = Symbol(he.NODE_ENV !== 'production' ? 'Map key iterate' : '');
function me(e, t, n) {
    if (ot && bt) {
        let r = wr.get(e);
        r || wr.set(e, (r = /* @__PURE__ */ new Map()));
        let o = r.get(n);
        (o || r.set(n, (o = gi(() => r.delete(n)))),
            pi(
                bt,
                o,
                he.NODE_ENV !== 'production'
                    ? {
                          target: e,
                          type: t,
                          key: n,
                      }
                    : void 0
            ));
    }
}
function Le(e, t, n, r, o, i) {
    const s = wr.get(e);
    if (!s) return;
    let a = [];
    if (t === 'clear') a = [...s.values()];
    else if (n === 'length' && M(e)) {
        const u = Number(r);
        s.forEach((d, h) => {
            (h === 'length' || (!Bt(h) && h >= u)) && a.push(d);
        });
    } else
        switch ((n !== void 0 && a.push(s.get(n)), t)) {
            case 'add':
                M(e) ? jr(n) && a.push(s.get('length')) : (a.push(s.get(wt)), yt(e) && a.push(s.get(Er)));
                break;
            case 'delete':
                M(e) || (a.push(s.get(wt)), yt(e) && a.push(s.get(Er)));
                break;
            case 'set':
                yt(e) && a.push(s.get(wt));
                break;
        }
    Yr();
    for (const u of a)
        u &&
            hi(
                u,
                2,
                he.NODE_ENV !== 'production'
                    ? {
                          target: e,
                          type: t,
                          key: n,
                          newValue: r,
                          oldValue: o,
                          oldTarget: i,
                      }
                    : void 0
            );
    qr();
}
const Xs = /* @__PURE__ */ Ke('__proto__,__v_isRef,__isVue'),
    vi = new Set(
        /* @__PURE__ */ Object.getOwnPropertyNames(Symbol)
            .filter((e) => e !== 'arguments' && e !== 'caller')
            .map((e) => Symbol[e])
            .filter(Bt)
    ),
    go = /* @__PURE__ */ zs();
function zs() {
    const e = {};
    return (
        ['includes', 'indexOf', 'lastIndexOf'].forEach((t) => {
            e[t] = function (...n) {
                const r = R(this);
                for (let i = 0, s = this.length; i < s; i++) me(r, 'get', i + '');
                const o = r[t](...n);
                return o === -1 || o === !1 ? r[t](...n.map(R)) : o;
            };
        }),
        ['push', 'pop', 'shift', 'unshift', 'splice'].forEach((t) => {
            e[t] = function (...n) {
                (ft(), Yr());
                const r = R(this)[t].apply(this, n);
                return (qr(), dt(), r);
            };
        }),
        e
    );
}
function Js(e) {
    const t = R(this);
    return (me(t, 'has', e), t.hasOwnProperty(e));
}
class _i {
    constructor(t = !1, n = !1) {
        ((this._isReadonly = t), (this._shallow = n));
    }
    get(t, n, r) {
        const o = this._isReadonly,
            i = this._shallow;
        if (n === '__v_isReactive') return !o;
        if (n === '__v_isReadonly') return o;
        if (n === '__v_isShallow') return i;
        if (n === '__v_raw')
            return r === (o ? (i ? Di : Oi) : i ? Ni : Ei).get(t) || // receiver is not the reactive proxy, but has the same prototype
                // this means the reciever is a user proxy of the reactive proxy
                Object.getPrototypeOf(t) === Object.getPrototypeOf(r)
                ? t
                : void 0;
        const s = M(t);
        if (!o) {
            if (s && H(go, n)) return Reflect.get(go, n, r);
            if (n === 'hasOwnProperty') return Js;
        }
        const a = Reflect.get(t, n, r);
        return (Bt(n) ? vi.has(n) : Xs(n)) || (o || me(t, 'get', n), i)
            ? a
            : ge(a)
              ? s && jr(n)
                  ? a
                  : a.value
              : ee(a)
                ? o
                    ? $i(a)
                    : Yt(a)
                : a;
    }
}
class yi extends _i {
    constructor(t = !1) {
        super(!1, t);
    }
    set(t, n, r, o) {
        let i = t[n];
        if (!this._shallow) {
            const u = lt(i);
            if ((!kn(r) && !lt(r) && ((i = R(i)), (r = R(r))), !M(t) && ge(i) && !ge(r)))
                return u ? !1 : ((i.value = r), !0);
        }
        const s = M(t) && jr(n) ? Number(n) < t.length : H(t, n),
            a = Reflect.set(t, n, r, o);
        return (t === R(o) && (s ? at(r, i) && Le(t, 'set', n, r, i) : Le(t, 'add', n, r)), a);
    }
    deleteProperty(t, n) {
        const r = H(t, n),
            o = t[n],
            i = Reflect.deleteProperty(t, n);
        return (i && r && Le(t, 'delete', n, void 0, o), i);
    }
    has(t, n) {
        const r = Reflect.has(t, n);
        return ((!Bt(n) || !vi.has(n)) && me(t, 'has', n), r);
    }
    ownKeys(t) {
        return (me(t, 'iterate', M(t) ? 'length' : wt), Reflect.ownKeys(t));
    }
}
class bi extends _i {
    constructor(t = !1) {
        super(!0, t);
    }
    set(t, n) {
        return (
            he.NODE_ENV !== 'production' && _r(`Set operation on key "${String(n)}" failed: target is readonly.`, t),
            !0
        );
    }
    deleteProperty(t, n) {
        return (
            he.NODE_ENV !== 'production' && _r(`Delete operation on key "${String(n)}" failed: target is readonly.`, t),
            !0
        );
    }
}
const Qs = /* @__PURE__ */ new yi(),
    Zs = /* @__PURE__ */ new bi(),
    ea = /* @__PURE__ */ new yi(!0),
    ta = /* @__PURE__ */ new bi(!0),
    Kr = (e) => e,
    Bn = (e) => Reflect.getPrototypeOf(e);
function _n(e, t, n = !1, r = !1) {
    e = e.__v_raw;
    const o = R(e),
        i = R(t);
    n || (at(t, i) && me(o, 'get', t), me(o, 'get', i));
    const {has: s} = Bn(o),
        a = r ? Kr : n ? Xr : an;
    if (s.call(o, t)) return a(e.get(t));
    if (s.call(o, i)) return a(e.get(i));
    e !== o && e.get(t);
}
function yn(e, t = !1) {
    const n = this.__v_raw,
        r = R(n),
        o = R(e);
    return (t || (at(e, o) && me(r, 'has', e), me(r, 'has', o)), e === o ? n.has(e) : n.has(e) || n.has(o));
}
function bn(e, t = !1) {
    return ((e = e.__v_raw), !t && me(R(e), 'iterate', wt), Reflect.get(e, 'size', e));
}
function vo(e) {
    e = R(e);
    const t = R(this);
    return (Bn(t).has.call(t, e) || (t.add(e), Le(t, 'add', e, e)), this);
}
function _o(e, t) {
    t = R(t);
    const n = R(this),
        {has: r, get: o} = Bn(n);
    let i = r.call(n, e);
    i ? he.NODE_ENV !== 'production' && wi(n, r, e) : ((e = R(e)), (i = r.call(n, e)));
    const s = o.call(n, e);
    return (n.set(e, t), i ? at(t, s) && Le(n, 'set', e, t, s) : Le(n, 'add', e, t), this);
}
function yo(e) {
    const t = R(this),
        {has: n, get: r} = Bn(t);
    let o = n.call(t, e);
    o ? he.NODE_ENV !== 'production' && wi(t, n, e) : ((e = R(e)), (o = n.call(t, e)));
    const i = r ? r.call(t, e) : void 0,
        s = t.delete(e);
    return (o && Le(t, 'delete', e, void 0, i), s);
}
function bo() {
    const e = R(this),
        t = e.size !== 0,
        n = he.NODE_ENV !== 'production' ? (yt(e) ? new Map(e) : new Set(e)) : void 0,
        r = e.clear();
    return (t && Le(e, 'clear', void 0, void 0, n), r);
}
function wn(e, t) {
    return function (r, o) {
        const i = this,
            s = i.__v_raw,
            a = R(s),
            u = t ? Kr : e ? Xr : an;
        return (!e && me(a, 'iterate', wt), s.forEach((d, h) => r.call(o, u(d), u(h), i)));
    };
}
function En(e, t, n) {
    return function (...r) {
        const o = this.__v_raw,
            i = R(o),
            s = yt(i),
            a = e === 'entries' || (e === Symbol.iterator && s),
            u = e === 'keys' && s,
            d = o[e](...r),
            h = n ? Kr : t ? Xr : an;
        return (
            !t && me(i, 'iterate', u ? Er : wt),
            {
                // iterator protocol
                next() {
                    const {value: c, done: m} = d.next();
                    return m
                        ? {value: c, done: m}
                        : {
                              value: a ? [h(c[0]), h(c[1])] : h(c),
                              done: m,
                          };
                },
                // iterable protocol
                [Symbol.iterator]() {
                    return this;
                },
            }
        );
    };
}
function Je(e) {
    return function (...t) {
        if (he.NODE_ENV !== 'production') {
            const n = t[0] ? `on key "${t[0]}" ` : '';
            console.warn(`${$t(e)} operation ${n}failed: target is readonly.`, R(this));
        }
        return e === 'delete' ? !1 : e === 'clear' ? void 0 : this;
    };
}
function na() {
    const e = {
            get(i) {
                return _n(this, i);
            },
            get size() {
                return bn(this);
            },
            has: yn,
            add: vo,
            set: _o,
            delete: yo,
            clear: bo,
            forEach: wn(!1, !1),
        },
        t = {
            get(i) {
                return _n(this, i, !1, !0);
            },
            get size() {
                return bn(this);
            },
            has: yn,
            add: vo,
            set: _o,
            delete: yo,
            clear: bo,
            forEach: wn(!1, !0),
        },
        n = {
            get(i) {
                return _n(this, i, !0);
            },
            get size() {
                return bn(this, !0);
            },
            has(i) {
                return yn.call(this, i, !0);
            },
            add: Je('add'),
            set: Je('set'),
            delete: Je('delete'),
            clear: Je('clear'),
            forEach: wn(!0, !1),
        },
        r = {
            get(i) {
                return _n(this, i, !0, !0);
            },
            get size() {
                return bn(this, !0);
            },
            has(i) {
                return yn.call(this, i, !0);
            },
            add: Je('add'),
            set: Je('set'),
            delete: Je('delete'),
            clear: Je('clear'),
            forEach: wn(!0, !0),
        };
    return (
        ['keys', 'values', 'entries', Symbol.iterator].forEach((i) => {
            ((e[i] = En(i, !1, !1)), (n[i] = En(i, !0, !1)), (t[i] = En(i, !1, !0)), (r[i] = En(i, !0, !0)));
        }),
        [e, n, t, r]
    );
}
const [ra, oa, ia, sa] = /* @__PURE__ */ na();
function Yn(e, t) {
    const n = t ? (e ? sa : ia) : e ? oa : ra;
    return (r, o, i) =>
        o === '__v_isReactive'
            ? !e
            : o === '__v_isReadonly'
              ? e
              : o === '__v_raw'
                ? r
                : Reflect.get(H(n, o) && o in r ? n : r, o, i);
}
const aa = {
        get: /* @__PURE__ */ Yn(!1, !1),
    },
    la = {
        get: /* @__PURE__ */ Yn(!1, !0),
    },
    ua = {
        get: /* @__PURE__ */ Yn(!0, !1),
    },
    ca = {
        get: /* @__PURE__ */ Yn(!0, !0),
    };
function wi(e, t, n) {
    const r = R(n);
    if (r !== n && t.call(e, r)) {
        const o = Ur(e);
        console.warn(
            `Reactive ${o} contains both the raw and reactive versions of the same object${o === 'Map' ? ' as keys' : ''}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
        );
    }
}
const Ei = /* @__PURE__ */ new WeakMap(),
    Ni = /* @__PURE__ */ new WeakMap(),
    Oi = /* @__PURE__ */ new WeakMap(),
    Di = /* @__PURE__ */ new WeakMap();
function fa(e) {
    switch (e) {
        case 'Object':
        case 'Array':
            return 1;
        case 'Map':
        case 'Set':
        case 'WeakMap':
        case 'WeakSet':
            return 2;
        default:
            return 0;
    }
}
function da(e) {
    return e.__v_skip || !Object.isExtensible(e) ? 0 : fa(Ur(e));
}
function Yt(e) {
    return lt(e) ? e : qn(e, !1, Qs, aa, Ei);
}
function pa(e) {
    return qn(e, !1, ea, la, Ni);
}
function $i(e) {
    return qn(e, !0, Zs, ua, Oi);
}
function Ft(e) {
    return qn(e, !0, ta, ca, Di);
}
function qn(e, t, n, r, o) {
    if (!ee(e)) return (he.NODE_ENV !== 'production' && console.warn(`value cannot be made reactive: ${String(e)}`), e);
    if (e.__v_raw && !(t && e.__v_isReactive)) return e;
    const i = o.get(e);
    if (i) return i;
    const s = da(e);
    if (s === 0) return e;
    const a = new Proxy(e, s === 2 ? r : n);
    return (o.set(e, a), a);
}
function Et(e) {
    return lt(e) ? Et(e.__v_raw) : !!(e && e.__v_isReactive);
}
function lt(e) {
    return !!(e && e.__v_isReadonly);
}
function kn(e) {
    return !!(e && e.__v_isShallow);
}
function Nr(e) {
    return Et(e) || lt(e);
}
function R(e) {
    const t = e && e.__v_raw;
    return t ? R(t) : e;
}
function Ci(e) {
    return (Sn(e, '__v_skip', !0), e);
}
const an = (e) => (ee(e) ? Yt(e) : e),
    Xr = (e) => (ee(e) ? $i(e) : e);
class Ti {
    constructor(t, n, r, o) {
        ((this._setter = n),
            (this.dep = void 0),
            (this.__v_isRef = !0),
            (this.__v_isReadonly = !1),
            (this.effect = new Br(
                () => t(this._value),
                () => $n(this, 1),
                () => this.dep && mi(this.dep)
            )),
            (this.effect.computed = this),
            (this.effect.active = this._cacheable = !o),
            (this.__v_isReadonly = r));
    }
    get value() {
        const t = R(this);
        return (
            (!t._cacheable || t.effect.dirty) && at(t._value, (t._value = t.effect.run())) && $n(t, 2),
            xi(t),
            t.effect._dirtyLevel >= 1 && $n(t, 1),
            t._value
        );
    }
    set value(t) {
        this._setter(t);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(t) {
        this.effect.dirty = t;
    }
    // #endregion
}
function ha(e, t, n = !1) {
    let r, o;
    const i = S(e);
    i
        ? ((r = e),
          (o =
              he.NODE_ENV !== 'production'
                  ? () => {
                        console.warn('Write operation failed: computed value is readonly');
                    }
                  : ae))
        : ((r = e.get), (o = e.set));
    const s = new Ti(r, o, i || !o, n);
    return (
        he.NODE_ENV !== 'production' && t && !n && ((s.effect.onTrack = t.onTrack), (s.effect.onTrigger = t.onTrigger)),
        s
    );
}
function xi(e) {
    ot &&
        bt &&
        ((e = R(e)),
        pi(
            bt,
            e.dep || (e.dep = gi(() => (e.dep = void 0), e instanceof Ti ? e : void 0)),
            he.NODE_ENV !== 'production'
                ? {
                      target: e,
                      type: 'get',
                      key: 'value',
                  }
                : void 0
        ));
}
function $n(e, t = 2, n) {
    e = R(e);
    const r = e.dep;
    r &&
        hi(
            r,
            t,
            he.NODE_ENV !== 'production'
                ? {
                      target: e,
                      type: 'set',
                      key: 'value',
                      newValue: n,
                  }
                : void 0
        );
}
function ge(e) {
    return !!(e && e.__v_isRef === !0);
}
function Vi(e) {
    return ma(e, !1);
}
function ma(e, t) {
    return ge(e) ? e : new ga(e, t);
}
class ga {
    constructor(t, n) {
        ((this.__v_isShallow = n),
            (this.dep = void 0),
            (this.__v_isRef = !0),
            (this._rawValue = n ? t : R(t)),
            (this._value = n ? t : an(t)));
    }
    get value() {
        return (xi(this), this._value);
    }
    set value(t) {
        const n = this.__v_isShallow || kn(t) || lt(t);
        ((t = n ? t : R(t)),
            at(t, this._rawValue) && ((this._rawValue = t), (this._value = n ? t : an(t)), $n(this, 2, t)));
    }
}
function Mi(e) {
    return ge(e) ? e.value : e;
}
const va = {
    get: (e, t, n) => Mi(Reflect.get(e, t, n)),
    set: (e, t, n, r) => {
        const o = e[t];
        return ge(o) && !ge(n) ? ((o.value = n), !0) : Reflect.set(e, t, n, r);
    },
};
function Pi(e) {
    return Et(e) ? e : new Proxy(e, va);
}
var p = {};
const Nt = [];
function Cn(e) {
    Nt.push(e);
}
function Tn() {
    Nt.pop();
}
function w(e, ...t) {
    ft();
    const n = Nt.length ? Nt[Nt.length - 1].component : null,
        r = n && n.appContext.config.warnHandler,
        o = _a();
    if (r)
        qe(r, n, 11, [
            e + t.join(''),
            n && n.proxy,
            o.map(({vnode: i}) => `at <${tr(n, i.type)}>`).join(`
`),
            o,
        ]);
    else {
        const i = [`[Vue warn]: ${e}`, ...t];
        (o.length &&
            i.push(
                `
`,
                ...ya(o)
            ),
            console.warn(...i));
    }
    dt();
}
function _a() {
    let e = Nt[Nt.length - 1];
    if (!e) return [];
    const t = [];
    for (; e;) {
        const n = t[0];
        n && n.vnode === e
            ? n.recurseCount++
            : t.push({
                  vnode: e,
                  recurseCount: 0,
              });
        const r = e.component && e.component.parent;
        e = r && r.vnode;
    }
    return t;
}
function ya(e) {
    const t = [];
    return (
        e.forEach((n, r) => {
            t.push(
                ...(r === 0
                    ? []
                    : [
                          `
`,
                      ]),
                ...ba(n)
            );
        }),
        t
    );
}
function ba({vnode: e, recurseCount: t}) {
    const n = t > 0 ? `... (${t} recursive calls)` : '',
        r = e.component ? e.component.parent == null : !1,
        o = ` at <${tr(e.component, e.type, r)}`,
        i = '>' + n;
    return e.props ? [o, ...wa(e.props), i] : [o + i];
}
function wa(e) {
    const t = [],
        n = Object.keys(e);
    return (
        n.slice(0, 3).forEach((r) => {
            t.push(...Si(r, e[r]));
        }),
        n.length > 3 && t.push(' ...'),
        t
    );
}
function Si(e, t, n) {
    return re(t)
        ? ((t = JSON.stringify(t)), n ? t : [`${e}=${t}`])
        : typeof t == 'number' || typeof t == 'boolean' || t == null
          ? n
              ? t
              : [`${e}=${t}`]
          : ge(t)
            ? ((t = Si(e, R(t.value), !0)), n ? t : [`${e}=Ref<`, t, '>'])
            : S(t)
              ? [`${e}=fn${t.name ? `<${t.name}>` : ''}`]
              : ((t = R(t)), n ? t : [`${e}=`, t]);
}
const zr = {
    sp: 'serverPrefetch hook',
    bc: 'beforeCreate hook',
    c: 'created hook',
    bm: 'beforeMount hook',
    m: 'mounted hook',
    bu: 'beforeUpdate hook',
    u: 'updated',
    bum: 'beforeUnmount hook',
    um: 'unmounted hook',
    a: 'activated hook',
    da: 'deactivated hook',
    ec: 'errorCaptured hook',
    rtc: 'renderTracked hook',
    rtg: 'renderTriggered hook',
    0: 'setup function',
    1: 'render function',
    2: 'watcher getter',
    3: 'watcher callback',
    4: 'watcher cleanup function',
    5: 'native event handler',
    6: 'component event handler',
    7: 'vnode hook',
    8: 'directive hook',
    9: 'transition hook',
    10: 'app errorHandler',
    11: 'app warnHandler',
    12: 'ref function',
    13: 'async component loader',
    14: 'scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core .',
};
function qe(e, t, n, r) {
    let o;
    try {
        o = r ? e(...r) : e();
    } catch (i) {
        dn(i, t, n);
    }
    return o;
}
function Pe(e, t, n, r) {
    if (S(e)) {
        const i = qe(e, t, n, r);
        return (
            i &&
                Lr(i) &&
                i.catch((s) => {
                    dn(s, t, n);
                }),
            i
        );
    }
    const o = [];
    for (let i = 0; i < e.length; i++) o.push(Pe(e[i], t, n, r));
    return o;
}
function dn(e, t, n, r = !0) {
    const o = t ? t.vnode : null;
    if (t) {
        let i = t.parent;
        const s = t.proxy,
            a = p.NODE_ENV !== 'production' ? zr[n] : `https://vuejs.org/error-reference/#runtime-${n}`;
        for (; i;) {
            const d = i.ec;
            if (d) {
                for (let h = 0; h < d.length; h++) if (d[h](e, s, a) === !1) return;
            }
            i = i.parent;
        }
        const u = t.appContext.config.errorHandler;
        if (u) {
            qe(u, null, 10, [e, s, a]);
            return;
        }
    }
    Ea(e, n, o, r);
}
function Ea(e, t, n, r = !0) {
    if (p.NODE_ENV !== 'production') {
        const o = zr[t];
        if ((n && Cn(n), w(`Unhandled error${o ? ` during execution of ${o}` : ''}`), n && Tn(), r)) throw e;
        console.error(e);
    } else console.error(e);
}
let ln = !1,
    Or = !1;
const ve = [];
let Ae = 0;
const Wt = [];
let Ye = null,
    et = 0;
const ki = /* @__PURE__ */ Promise.resolve();
let Jr = null;
const Na = 100;
function Oa(e) {
    const t = Jr || ki;
    return e ? t.then(this ? e.bind(this) : e) : t;
}
function Da(e) {
    let t = Ae + 1,
        n = ve.length;
    for (; t < n;) {
        const r = (t + n) >>> 1,
            o = ve[r],
            i = un(o);
        i < e || (i === e && o.pre) ? (t = r + 1) : (n = r);
    }
    return t;
}
function Kn(e) {
    (!ve.length || !ve.includes(e, ln && e.allowRecurse ? Ae + 1 : Ae)) &&
        (e.id == null ? ve.push(e) : ve.splice(Da(e.id), 0, e), Ii());
}
function Ii() {
    !ln && !Or && ((Or = !0), (Jr = ki.then(Ri)));
}
function $a(e) {
    const t = ve.indexOf(e);
    t > Ae && ve.splice(t, 1);
}
function Ai(e) {
    (M(e) ? Wt.push(...e) : (!Ye || !Ye.includes(e, e.allowRecurse ? et + 1 : et)) && Wt.push(e), Ii());
}
function wo(e, t, n = ln ? Ae + 1 : 0) {
    for (p.NODE_ENV !== 'production' && (t = t || /* @__PURE__ */ new Map()); n < ve.length; n++) {
        const r = ve[n];
        if (r && r.pre) {
            if ((e && r.id !== e.uid) || (p.NODE_ENV !== 'production' && Qr(t, r))) continue;
            (ve.splice(n, 1), n--, r());
        }
    }
}
function Fi(e) {
    if (Wt.length) {
        const t = [...new Set(Wt)].sort((n, r) => un(n) - un(r));
        if (((Wt.length = 0), Ye)) {
            Ye.push(...t);
            return;
        }
        for (Ye = t, p.NODE_ENV !== 'production' && (e = e || /* @__PURE__ */ new Map()), et = 0; et < Ye.length; et++)
            (p.NODE_ENV !== 'production' && Qr(e, Ye[et])) || Ye[et]();
        ((Ye = null), (et = 0));
    }
}
const un = (e) => (e.id == null ? 1 / 0 : e.id),
    Ca = (e, t) => {
        const n = un(e) - un(t);
        if (n === 0) {
            if (e.pre && !t.pre) return -1;
            if (t.pre && !e.pre) return 1;
        }
        return n;
    };
function Ri(e) {
    ((Or = !1), (ln = !0), p.NODE_ENV !== 'production' && (e = e || /* @__PURE__ */ new Map()), ve.sort(Ca));
    const t = p.NODE_ENV !== 'production' ? (n) => Qr(e, n) : ae;
    try {
        for (Ae = 0; Ae < ve.length; Ae++) {
            const n = ve[Ae];
            if (n && n.active !== !1) {
                if (p.NODE_ENV !== 'production' && t(n)) continue;
                qe(n, null, 14);
            }
        }
    } finally {
        ((Ae = 0), (ve.length = 0), Fi(e), (ln = !1), (Jr = null), (ve.length || Wt.length) && Ri(e));
    }
}
function Qr(e, t) {
    if (!e.has(t)) e.set(t, 1);
    else {
        const n = e.get(t);
        if (n > Na) {
            const r = t.ownerInstance,
                o = r && so(r.type);
            return (
                dn(
                    `Maximum recursive updates exceeded${o ? ` in component <${o}>` : ''}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
                    null,
                    10
                ),
                !0
            );
        } else e.set(t, n + 1);
    }
}
let it = !1;
const It = /* @__PURE__ */ new Set();
p.NODE_ENV !== 'production' &&
    (Hr().__VUE_HMR_RUNTIME__ = {
        createRecord: cr(Wi),
        rerender: cr(Va),
        reload: cr(Ma),
    });
const Ct = /* @__PURE__ */ new Map();
function Ta(e) {
    const t = e.type.__hmrId;
    let n = Ct.get(t);
    (n || (Wi(t, e.type), (n = Ct.get(t))), n.instances.add(e));
}
function xa(e) {
    Ct.get(e.type.__hmrId).instances.delete(e);
}
function Wi(e, t) {
    return Ct.has(e)
        ? !1
        : (Ct.set(e, {
              initialDef: nn(t),
              instances: /* @__PURE__ */ new Set(),
          }),
          !0);
}
function nn(e) {
    return vs(e) ? e.__vccOpts : e;
}
function Va(e, t) {
    const n = Ct.get(e);
    n &&
        ((n.initialDef.render = t),
        [...n.instances].forEach((r) => {
            (t && ((r.render = t), (nn(r.type).render = t)),
                (r.renderCache = []),
                (it = !0),
                (r.effect.dirty = !0),
                r.update(),
                (it = !1));
        }));
}
function Ma(e, t) {
    const n = Ct.get(e);
    if (!n) return;
    ((t = nn(t)), Eo(n.initialDef, t));
    const r = [...n.instances];
    for (const o of r) {
        const i = nn(o.type);
        (It.has(i) || (i !== n.initialDef && Eo(i, t), It.add(i)),
            o.appContext.propsCache.delete(o.type),
            o.appContext.emitsCache.delete(o.type),
            o.appContext.optionsCache.delete(o.type),
            o.ceReload
                ? (It.add(i), o.ceReload(t.styles), It.delete(i))
                : o.parent
                  ? ((o.parent.effect.dirty = !0), Kn(o.parent.update))
                  : o.appContext.reload
                    ? o.appContext.reload()
                    : typeof window < 'u'
                      ? window.location.reload()
                      : console.warn('[HMR] Root or manually mounted instance modified. Full reload required.'));
    }
    Ai(() => {
        for (const o of r) It.delete(nn(o.type));
    });
}
function Eo(e, t) {
    se(e, t);
    for (const n in e) n !== '__file' && !(n in t) && delete e[n];
}
function cr(e) {
    return (t, n) => {
        try {
            return e(t, n);
        } catch (r) {
            (console.error(r),
                console.warn('[HMR] Something went wrong during Vue component hot-reload. Full reload required.'));
        }
    };
}
let Fe,
    en = [],
    Dr = !1;
function pn(e, ...t) {
    Fe ? Fe.emit(e, ...t) : Dr || en.push({event: e, args: t});
}
function Li(e, t) {
    var n, r;
    ((Fe = e),
        Fe
            ? ((Fe.enabled = !0), en.forEach(({event: o, args: i}) => Fe.emit(o, ...i)), (en = []))
            : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window <
                    'u' && // some envs mock window but not fully
                window.HTMLElement && // also exclude jsdom
                !((r = (n = window.navigator) == null ? void 0 : n.userAgent) != null && r.includes('jsdom'))
              ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((i) => {
                    Li(i, t);
                }),
                setTimeout(() => {
                    Fe || ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null), (Dr = !0), (en = []));
                }, 3e3))
              : ((Dr = !0), (en = [])));
}
function Pa(e, t) {
    pn('app:init', e, t, {
        Fragment: Oe,
        Text: hn,
        Comment: De,
        Static: Vn,
    });
}
function Sa(e) {
    pn('app:unmount', e);
}
const ka = /* @__PURE__ */ Zr(
        'component:added'
        /* COMPONENT_ADDED */
    ),
    Ui = /* @__PURE__ */ Zr(
        'component:updated'
        /* COMPONENT_UPDATED */
    ),
    Ia = /* @__PURE__ */ Zr(
        'component:removed'
        /* COMPONENT_REMOVED */
    ),
    Aa = (e) => {
        Fe &&
            typeof Fe.cleanupBuffer == 'function' && // remove the component if it wasn't buffered
            !Fe.cleanupBuffer(e) &&
            Ia(e);
    };
function Zr(e) {
    return (t) => {
        pn(e, t.appContext.app, t.uid, t.parent ? t.parent.uid : void 0, t);
    };
}
const Fa = /* @__PURE__ */ ji(
        'perf:start'
        /* PERFORMANCE_START */
    ),
    Ra = /* @__PURE__ */ ji(
        'perf:end'
        /* PERFORMANCE_END */
    );
function ji(e) {
    return (t, n, r) => {
        pn(e, t.appContext.app, t.uid, t, n, r);
    };
}
function Wa(e, t, n) {
    pn('component:emit', e.appContext.app, e, t, n);
}
function La(e, t, ...n) {
    if (e.isUnmounted) return;
    const r = e.vnode.props || Z;
    if (p.NODE_ENV !== 'production') {
        const {
            emitsOptions: h,
            propsOptions: [c],
        } = e;
        if (h)
            if (!(t in h))
                (!c || !(mt(t) in c)) &&
                    w(
                        `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${mt(t)}" prop.`
                    );
            else {
                const m = h[t];
                S(m) && (m(...n) || w(`Invalid event arguments: event validation failed for event "${t}".`));
            }
    }
    let o = n;
    const i = t.startsWith('update:'),
        s = i && t.slice(7);
    if (s && s in r) {
        const h = `${s === 'modelValue' ? 'model' : s}Modifiers`,
            {number: c, trim: m} = r[h] || Z;
        (m && (o = n.map((N) => (re(N) ? N.trim() : N))), c && (o = n.map(Ps)));
    }
    if ((p.NODE_ENV !== 'production' && Wa(e, t, o), p.NODE_ENV !== 'production')) {
        const h = t.toLowerCase();
        h !== t &&
            r[mt(h)] &&
            w(
                `Event "${h}" is emitted in component ${tr(
                    e,
                    e.type
                )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${st(
                    t
                )}" instead of "${t}".`
            );
    }
    let a,
        u =
            r[(a = mt(t))] || // also try camelCase event handler (#2249)
            r[(a = mt(Ue(t)))];
    (!u && i && (u = r[(a = mt(st(t)))]), u && Pe(u, e, 6, o));
    const d = r[a + 'Once'];
    if (d) {
        if (!e.emitted) e.emitted = {};
        else if (e.emitted[a]) return;
        ((e.emitted[a] = !0), Pe(d, e, 6, o));
    }
}
function Hi(e, t, n = !1) {
    const r = t.emitsCache,
        o = r.get(e);
    if (o !== void 0) return o;
    const i = e.emits;
    let s = {},
        a = !1;
    if (!S(e)) {
        const u = (d) => {
            const h = Hi(d, t, !0);
            h && ((a = !0), se(s, h));
        };
        (!n && t.mixins.length && t.mixins.forEach(u), e.extends && u(e.extends), e.mixins && e.mixins.forEach(u));
    }
    return !i && !a
        ? (ee(e) && r.set(e, null), null)
        : (M(i) ? i.forEach((u) => (s[u] = null)) : se(s, i), ee(e) && r.set(e, s), s);
}
function Xn(e, t) {
    return !e || !fn(t)
        ? !1
        : ((t = t.slice(2).replace(/Once$/, '')), H(e, t[0].toLowerCase() + t.slice(1)) || H(e, st(t)) || H(e, t));
}
let le = null,
    Gi = null;
function In(e) {
    const t = le;
    return ((le = e), (Gi = (e && e.type.__scopeId) || null), t);
}
function At(e, t = le, n) {
    if (!t || e._n) return e;
    const r = (...o) => {
        r._d && Fo(-1);
        const i = In(t);
        let s;
        try {
            s = e(...o);
        } finally {
            (In(i), r._d && Fo(1));
        }
        return (p.NODE_ENV !== 'production' && Ui(t), s);
    };
    return ((r._n = !0), (r._c = !0), (r._d = !0), r);
}
let $r = !1;
function An() {
    $r = !0;
}
function fr(e) {
    const {
        type: t,
        vnode: n,
        proxy: r,
        withProxy: o,
        props: i,
        propsOptions: [s],
        slots: a,
        attrs: u,
        emit: d,
        render: h,
        renderCache: c,
        data: m,
        setupState: N,
        ctx: T,
        inheritAttrs: P,
    } = e;
    let L, X;
    const j = In(e);
    p.NODE_ENV !== 'production' && ($r = !1);
    try {
        if (n.shapeFlag & 4) {
            const B = o || r,
                Y =
                    p.NODE_ENV !== 'production' && N.__isScriptSetup
                        ? new Proxy(B, {
                              get(C, K, Q) {
                                  return (
                                      w(
                                          `Property '${String(
                                              K
                                          )}' was accessed via 'this'. Avoid using 'this' in templates.`
                                      ),
                                      Reflect.get(C, K, Q)
                                  );
                              },
                          })
                        : B;
            ((L = Ve(h.call(Y, B, c, i, N, m, T))), (X = u));
        } else {
            const B = t;
            (p.NODE_ENV !== 'production' && u === i && An(),
                (L = Ve(
                    B.length > 1
                        ? B(
                              i,
                              p.NODE_ENV !== 'production'
                                  ? {
                                        get attrs() {
                                            return (An(), u);
                                        },
                                        slots: a,
                                        emit: d,
                                    }
                                  : {attrs: u, slots: a, emit: d}
                          )
                        : B(
                              i,
                              null
                              /* we know it doesn't need it */
                          )
                )),
                (X = t.props ? u : Ua(u)));
        }
    } catch (B) {
        ((sn.length = 0), dn(B, e, 1), (L = pe(De)));
    }
    let A = L,
        F;
    if ((p.NODE_ENV !== 'production' && L.patchFlag > 0 && L.patchFlag & 2048 && ([A, F] = Bi(L)), X && P !== !1)) {
        const B = Object.keys(X),
            {shapeFlag: Y} = A;
        if (B.length) {
            if (Y & 7) (s && B.some(Pn) && (X = ja(X, s)), (A = ct(A, X)));
            else if (p.NODE_ENV !== 'production' && !$r && A.type !== De) {
                const C = Object.keys(u),
                    K = [],
                    Q = [];
                for (let ue = 0, ye = C.length; ue < ye; ue++) {
                    const Ce = C[ue];
                    fn(Ce) ? Pn(Ce) || K.push(Ce[2].toLowerCase() + Ce.slice(3)) : Q.push(Ce);
                }
                (Q.length &&
                    w(
                        `Extraneous non-props attributes (${Q.join(', ')}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes.`
                    ),
                    K.length &&
                        w(
                            `Extraneous non-emits event listeners (${K.join(', ')}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
                        ));
            }
        }
    }
    return (
        n.dirs &&
            (p.NODE_ENV !== 'production' &&
                !No(A) &&
                w(
                    'Runtime directive used on component with non-element root node. The directives will not function as intended.'
                ),
            (A = ct(A)),
            (A.dirs = A.dirs ? A.dirs.concat(n.dirs) : n.dirs)),
        n.transition &&
            (p.NODE_ENV !== 'production' &&
                !No(A) &&
                w('Component inside <Transition> renders non-element root node that cannot be animated.'),
            (A.transition = n.transition)),
        p.NODE_ENV !== 'production' && F ? F(A) : (L = A),
        In(j),
        L
    );
}
const Bi = (e) => {
    const t = e.children,
        n = e.dynamicChildren,
        r = eo(t, !1);
    if (r) {
        if (p.NODE_ENV !== 'production' && r.patchFlag > 0 && r.patchFlag & 2048) return Bi(r);
    } else return [e, void 0];
    const o = t.indexOf(r),
        i = n ? n.indexOf(r) : -1,
        s = (a) => {
            ((t[o] = a), n && (i > -1 ? (n[i] = a) : a.patchFlag > 0 && (e.dynamicChildren = [...n, a])));
        };
    return [Ve(r), s];
};
function eo(e, t = !0) {
    let n;
    for (let r = 0; r < e.length; r++) {
        const o = e[r];
        if (Jn(o)) {
            if (o.type !== De || o.children === 'v-if') {
                if (n) return;
                if (((n = o), p.NODE_ENV !== 'production' && t && n.patchFlag > 0 && n.patchFlag & 2048))
                    return eo(n.children);
            }
        } else return;
    }
    return n;
}
const Ua = (e) => {
        let t;
        for (const n in e) (n === 'class' || n === 'style' || fn(n)) && ((t || (t = {}))[n] = e[n]);
        return t;
    },
    ja = (e, t) => {
        const n = {};
        for (const r in e) (!Pn(r) || !(r.slice(9) in t)) && (n[r] = e[r]);
        return n;
    },
    No = (e) => e.shapeFlag & 7 || e.type === De;
function Ha(e, t, n) {
    const {props: r, children: o, component: i} = e,
        {props: s, children: a, patchFlag: u} = t,
        d = i.emitsOptions;
    if ((p.NODE_ENV !== 'production' && (o || a) && it) || t.dirs || t.transition) return !0;
    if (n && u >= 0) {
        if (u & 1024) return !0;
        if (u & 16) return r ? Oo(r, s, d) : !!s;
        if (u & 8) {
            const h = t.dynamicProps;
            for (let c = 0; c < h.length; c++) {
                const m = h[c];
                if (s[m] !== r[m] && !Xn(d, m)) return !0;
            }
        }
    } else return (o || a) && (!a || !a.$stable) ? !0 : r === s ? !1 : r ? (s ? Oo(r, s, d) : !0) : !!s;
    return !1;
}
function Oo(e, t, n) {
    const r = Object.keys(t);
    if (r.length !== Object.keys(e).length) return !0;
    for (let o = 0; o < r.length; o++) {
        const i = r[o];
        if (t[i] !== e[i] && !Xn(n, i)) return !0;
    }
    return !1;
}
function Ga({vnode: e, parent: t}, n) {
    for (; t;) {
        const r = t.subTree;
        if ((r.suspense && r.suspense.activeBranch === e && (r.el = e.el), r === e))
            (((e = t.vnode).el = n), (t = t.parent));
        else break;
    }
}
const Cr = 'components',
    Ba = 'directives',
    Yi = Symbol.for('v-ndc');
function Ya(e) {
    return re(e) ? qi(Cr, e, !1) || e : e || Yi;
}
function qa(e) {
    return qi(Ba, e);
}
function qi(e, t, n = !0, r = !1) {
    const o = le || de;
    if (o) {
        const i = o.type;
        if (e === Cr) {
            const a = so(i, !1);
            if (a && (a === t || a === Ue(t) || a === $t(Ue(t)))) return i;
        }
        const s =
            // local registration
            // check instance[type] first which is resolved for options API
            Do(o[e] || i[e], t) || // global registration
            Do(o.appContext[e], t);
        if (!s && r) return i;
        if (p.NODE_ENV !== 'production' && n && !s) {
            const a =
                e === Cr
                    ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.`
                    : '';
            w(`Failed to resolve ${e.slice(0, -1)}: ${t}${a}`);
        }
        return s;
    } else p.NODE_ENV !== 'production' && w(`resolve${$t(e.slice(0, -1))} can only be used in render() or setup().`);
}
function Do(e, t) {
    return e && (e[t] || e[Ue(t)] || e[$t(Ue(t))]);
}
const Ka = (e) => e.__isSuspense;
function Xa(e, t) {
    t && t.pendingBranch ? (M(e) ? t.effects.push(...e) : t.effects.push(e)) : Ai(e);
}
const za = Symbol.for('v-scx'),
    Ja = () => {
        {
            const e = xn(za);
            return (
                e ||
                    (p.NODE_ENV !== 'production' &&
                        w(
                            'Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build.'
                        )),
                e
            );
        }
    },
    Nn = {};
function dr(e, t, n) {
    return (
        p.NODE_ENV !== 'production' &&
            !S(t) &&
            w(
                '`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature.'
            ),
        Ki(e, t, n)
    );
}
function Ki(e, t, {immediate: n, deep: r, flush: o, once: i, onTrack: s, onTrigger: a} = Z) {
    if (t && i) {
        const C = t;
        t = (...K) => {
            (C(...K), Y());
        };
    }
    (p.NODE_ENV !== 'production' &&
        r !== void 0 &&
        typeof r == 'number' &&
        w(
            'watch() "deep" option with number value will be used as watch depth in future versions. Please use a boolean instead to avoid potential breakage.'
        ),
        p.NODE_ENV !== 'production' &&
            !t &&
            (n !== void 0 &&
                w(
                    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
                ),
            r !== void 0 &&
                w(
                    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
                ),
            i !== void 0 &&
                w(
                    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
                )));
    const u = (C) => {
            w(
                'Invalid watch source: ',
                C,
                'A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.'
            );
        },
        d = de,
        h = (C) =>
            r === !0
                ? C
                : // for deep: false, only traverse root-level properties
                  vt(C, r === !1 ? 1 : void 0);
    let c,
        m = !1,
        N = !1;
    if (
        (ge(e)
            ? ((c = () => e.value), (m = kn(e)))
            : Et(e)
              ? ((c = () => h(e)), (m = !0))
              : M(e)
                ? ((N = !0),
                  (m = e.some((C) => Et(C) || kn(C))),
                  (c = () =>
                      e.map((C) => {
                          if (ge(C)) return C.value;
                          if (Et(C)) return h(C);
                          if (S(C)) return qe(C, d, 2);
                          p.NODE_ENV !== 'production' && u(C);
                      })))
                : S(e)
                  ? t
                      ? (c = () => qe(e, d, 2))
                      : (c = () => (T && T(), Pe(e, d, 3, [P])))
                  : ((c = ae), p.NODE_ENV !== 'production' && u(e)),
        t && r)
    ) {
        const C = c;
        c = () => vt(C());
    }
    let T,
        P = (C) => {
            T = F.onStop = () => {
                (qe(C, d, 4), (T = F.onStop = void 0));
            };
        },
        L;
    if (Zn)
        if (((P = ae), t ? n && Pe(t, d, 3, [c(), N ? [] : void 0, P]) : c(), o === 'sync')) {
            const C = Ja();
            L = C.__watcherHandles || (C.__watcherHandles = []);
        } else return ae;
    let X = N ? new Array(e.length).fill(Nn) : Nn;
    const j = () => {
        if (!(!F.active || !F.dirty))
            if (t) {
                const C = F.run();
                (r || m || (N ? C.some((K, Q) => at(K, X[Q])) : at(C, X))) &&
                    (T && T(),
                    Pe(t, d, 3, [
                        C,
                        // pass undefined as the old value when it's changed for the first time
                        X === Nn ? void 0 : N && X[0] === Nn ? [] : X,
                        P,
                    ]),
                    (X = C));
            } else F.run();
    };
    j.allowRecurse = !!t;
    let A;
    o === 'sync'
        ? (A = j)
        : o === 'post'
          ? (A = () => Ne(j, d && d.suspense))
          : ((j.pre = !0), d && (j.id = d.uid), (A = () => Kn(j)));
    const F = new Br(c, ae, A),
        B = qs(),
        Y = () => {
            (F.stop(), B && Wr(B.effects, F));
        };
    return (
        p.NODE_ENV !== 'production' && ((F.onTrack = s), (F.onTrigger = a)),
        t ? (n ? j() : (X = F.run())) : o === 'post' ? Ne(F.run.bind(F), d && d.suspense) : F.run(),
        L && L.push(Y),
        Y
    );
}
function Qa(e, t, n) {
    const r = this.proxy,
        o = re(e) ? (e.includes('.') ? Xi(r, e) : () => r[e]) : e.bind(r, r);
    let i;
    S(t) ? (i = t) : ((i = t.handler), (n = t));
    const s = mn(this),
        a = Ki(o, i.bind(r), n);
    return (s(), a);
}
function Xi(e, t) {
    const n = t.split('.');
    return () => {
        let r = e;
        for (let o = 0; o < n.length && r; o++) r = r[n[o]];
        return r;
    };
}
function vt(e, t, n = 0, r) {
    if (!ee(e) || e.__v_skip) return e;
    if (t && t > 0) {
        if (n >= t) return e;
        n++;
    }
    if (((r = r || /* @__PURE__ */ new Set()), r.has(e))) return e;
    if ((r.add(e), ge(e))) vt(e.value, t, n, r);
    else if (M(e)) for (let o = 0; o < e.length; o++) vt(e[o], t, n, r);
    else if (si(e) || yt(e))
        e.forEach((o) => {
            vt(o, t, n, r);
        });
    else if (li(e)) for (const o in e) vt(e[o], t, n, r);
    return e;
}
function zi(e) {
    xs(e) && w('Do not use built-in directive ids as custom directive id: ' + e);
}
function Za(e, t) {
    if (le === null)
        return (p.NODE_ENV !== 'production' && w('withDirectives can only be used inside render functions.'), e);
    const n = er(le) || le.proxy,
        r = e.dirs || (e.dirs = []);
    for (let o = 0; o < t.length; o++) {
        let [i, s, a, u = Z] = t[o];
        i &&
            (S(i) &&
                (i = {
                    mounted: i,
                    updated: i,
                }),
            i.deep && vt(s),
            r.push({
                dir: i,
                instance: n,
                value: s,
                oldValue: void 0,
                arg: a,
                modifiers: u,
            }));
    }
    return e;
}
function pt(e, t, n, r) {
    const o = e.dirs,
        i = t && t.dirs;
    for (let s = 0; s < o.length; s++) {
        const a = o[s];
        i && (a.oldValue = i[s].value);
        let u = a.dir[r];
        u && (ft(), Pe(u, n, 8, [e.el, a, e, t]), dt());
    }
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function el(e, t) {
    return S(e)
        ? // #8326: extend call and options.name access are considered side-effects
          // by Rollup, so we have to wrap it in a pure-annotated IIFE.
          se({name: e.name}, t, {setup: e})
        : e;
}
const rn = (e) => !!e.type.__asyncLoader,
    to = (e) => e.type.__isKeepAlive;
function tl(e, t) {
    Ji(e, 'a', t);
}
function nl(e, t) {
    Ji(e, 'da', t);
}
function Ji(e, t, n = de) {
    const r =
        e.__wdc ||
        (e.__wdc = () => {
            let o = n;
            for (; o;) {
                if (o.isDeactivated) return;
                o = o.parent;
            }
            return e();
        });
    if ((zn(t, r, n), n)) {
        let o = n.parent;
        for (; o && o.parent;) (to(o.parent.vnode) && rl(r, t, n, o), (o = o.parent));
    }
}
function rl(e, t, n, r) {
    const o = zn(
        t,
        e,
        r,
        !0
        /* prepend */
    );
    Qi(() => {
        Wr(r[t], o);
    }, n);
}
function zn(e, t, n = de, r = !1) {
    if (n) {
        const o = n[e] || (n[e] = []),
            i =
                t.__weh ||
                (t.__weh = (...s) => {
                    if (n.isUnmounted) return;
                    ft();
                    const a = mn(n),
                        u = Pe(t, n, e, s);
                    return (a(), dt(), u);
                });
        return (r ? o.unshift(i) : o.push(i), i);
    } else if (p.NODE_ENV !== 'production') {
        const o = mt(zr[e].replace(/ hook$/, ''));
        w(
            `${o} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
        );
    }
}
const Xe =
        (e) =>
        (t, n = de) =>
            // post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
            (!Zn || e === 'sp') && zn(e, (...r) => t(...r), n),
    ol = Xe('bm'),
    il = Xe('m'),
    sl = Xe('bu'),
    al = Xe('u'),
    ll = Xe('bum'),
    Qi = Xe('um'),
    ul = Xe('sp'),
    cl = Xe('rtg'),
    fl = Xe('rtc');
function dl(e, t = de) {
    zn('ec', e, t);
}
function pl(e, t, n, r) {
    let o;
    const i = n && n[r];
    if (M(e) || re(e)) {
        o = new Array(e.length);
        for (let s = 0, a = e.length; s < a; s++) o[s] = t(e[s], s, void 0, i && i[s]);
    } else if (typeof e == 'number') {
        (p.NODE_ENV !== 'production' &&
            !Number.isInteger(e) &&
            w(`The v-for range expect an integer value but got ${e}.`),
            (o = new Array(e)));
        for (let s = 0; s < e; s++) o[s] = t(s + 1, s, void 0, i && i[s]);
    } else if (ee(e))
        if (e[Symbol.iterator]) o = Array.from(e, (s, a) => t(s, a, void 0, i && i[a]));
        else {
            const s = Object.keys(e);
            o = new Array(s.length);
            for (let a = 0, u = s.length; a < u; a++) {
                const d = s[a];
                o[a] = t(e[d], d, a, i && i[a]);
            }
        }
    else o = [];
    return (n && (n[r] = o), o);
}
function hl(e, t) {
    for (let n = 0; n < t.length; n++) {
        const r = t[n];
        if (M(r)) for (let o = 0; o < r.length; o++) e[r[o].name] = r[o].fn;
        else
            r &&
                (e[r.name] = r.key
                    ? (...o) => {
                          const i = r.fn(...o);
                          return (i && (i.key = r.key), i);
                      }
                    : r.fn);
    }
    return e;
}
function zt(e, t, n = {}, r, o) {
    if (le.isCE || (le.parent && rn(le.parent) && le.parent.isCE))
        return (t !== 'default' && (n.name = t), pe('slot', n, r && r()));
    let i = e[t];
    (p.NODE_ENV !== 'production' &&
        i &&
        i.length > 1 &&
        (w(
            'SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.'
        ),
        (i = () => [])),
        i && i._c && (i._d = !1),
        te());
    const s = i && Zi(i(n)),
        a = ut(
            Oe,
            {
                key:
                    n.key || // slot content array of a dynamic conditional slot may have a branch
                    // key attached in the `createSlots` helper, respect that
                    (s && s.key) ||
                    `_${t}`,
            },
            s || (r ? r() : []),
            s && e._ === 1 ? 64 : -2
        );
    return (!o && a.scopeId && (a.slotScopeIds = [a.scopeId + '-s']), i && i._c && (i._d = !0), a);
}
function Zi(e) {
    return e.some((t) => (Jn(t) ? !(t.type === De || (t.type === Oe && !Zi(t.children))) : !0)) ? e : null;
}
const Tr = (e) => (e ? (ms(e) ? er(e) || e.proxy : Tr(e.parent)) : null),
    Ot =
        // Move PURE marker to new line to workaround compiler discarding it
        // due to type annotation
        /* @__PURE__ */ se(/* @__PURE__ */ Object.create(null), {
            $: (e) => e,
            $el: (e) => e.vnode.el,
            $data: (e) => e.data,
            $props: (e) => (p.NODE_ENV !== 'production' ? Ft(e.props) : e.props),
            $attrs: (e) => (p.NODE_ENV !== 'production' ? Ft(e.attrs) : e.attrs),
            $slots: (e) => (p.NODE_ENV !== 'production' ? Ft(e.slots) : e.slots),
            $refs: (e) => (p.NODE_ENV !== 'production' ? Ft(e.refs) : e.refs),
            $parent: (e) => Tr(e.parent),
            $root: (e) => Tr(e.root),
            $emit: (e) => e.emit,
            $options: (e) => ro(e),
            $forceUpdate: (e) =>
                e.f ||
                (e.f = () => {
                    ((e.effect.dirty = !0), Kn(e.update));
                }),
            $nextTick: (e) => e.n || (e.n = Oa.bind(e.proxy)),
            $watch: (e) => Qa.bind(e),
        }),
    no = (e) => e === '_' || e === '$',
    pr = (e, t) => e !== Z && !e.__isScriptSetup && H(e, t),
    es = {
        get({_: e}, t) {
            const {ctx: n, setupState: r, data: o, props: i, accessCache: s, type: a, appContext: u} = e;
            if (p.NODE_ENV !== 'production' && t === '__isVue') return !0;
            let d;
            if (t[0] !== '$') {
                const N = s[t];
                if (N !== void 0)
                    switch (N) {
                        case 1:
                            return r[t];
                        case 2:
                            return o[t];
                        case 4:
                            return n[t];
                        case 3:
                            return i[t];
                    }
                else {
                    if (pr(r, t)) return ((s[t] = 1), r[t]);
                    if (o !== Z && H(o, t)) return ((s[t] = 2), o[t]);
                    if (
                        // only cache other properties when instance has declared (thus stable)
                        // props
                        (d = e.propsOptions[0]) &&
                        H(d, t)
                    )
                        return ((s[t] = 3), i[t]);
                    if (n !== Z && H(n, t)) return ((s[t] = 4), n[t]);
                    xr && (s[t] = 0);
                }
            }
            const h = Ot[t];
            let c, m;
            if (h)
                return (
                    t === '$attrs'
                        ? (me(e, 'get', t), p.NODE_ENV !== 'production' && An())
                        : p.NODE_ENV !== 'production' && t === '$slots' && me(e, 'get', t),
                    h(e)
                );
            if (
                // css module (injected by vue-loader)
                (c = a.__cssModules) &&
                (c = c[t])
            )
                return c;
            if (n !== Z && H(n, t)) return ((s[t] = 4), n[t]);
            if (
                // global properties
                ((m = u.config.globalProperties), H(m, t))
            )
                return m[t];
            p.NODE_ENV !== 'production' &&
                le &&
                (!re(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
                    // to infinite warning loop
                    t.indexOf('__v') !== 0) &&
                (o !== Z && no(t[0]) && H(o, t)
                    ? w(
                          `Property ${JSON.stringify(
                              t
                          )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
                      )
                    : e === le &&
                      w(`Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`));
        },
        set({_: e}, t, n) {
            const {data: r, setupState: o, ctx: i} = e;
            return pr(o, t)
                ? ((o[t] = n), !0)
                : p.NODE_ENV !== 'production' && o.__isScriptSetup && H(o, t)
                  ? (w(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1)
                  : r !== Z && H(r, t)
                    ? ((r[t] = n), !0)
                    : H(e.props, t)
                      ? (p.NODE_ENV !== 'production' && w(`Attempting to mutate prop "${t}". Props are readonly.`), !1)
                      : t[0] === '$' && t.slice(1) in e
                        ? (p.NODE_ENV !== 'production' &&
                              w(
                                  `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
                              ),
                          !1)
                        : (p.NODE_ENV !== 'production' && t in e.appContext.config.globalProperties
                              ? Object.defineProperty(i, t, {
                                    enumerable: !0,
                                    configurable: !0,
                                    value: n,
                                })
                              : (i[t] = n),
                          !0);
        },
        has({_: {data: e, setupState: t, accessCache: n, ctx: r, appContext: o, propsOptions: i}}, s) {
            let a;
            return (
                !!n[s] ||
                (e !== Z && H(e, s)) ||
                pr(t, s) ||
                ((a = i[0]) && H(a, s)) ||
                H(r, s) ||
                H(Ot, s) ||
                H(o.config.globalProperties, s)
            );
        },
        defineProperty(e, t, n) {
            return (
                n.get != null ? (e._.accessCache[t] = 0) : H(n, 'value') && this.set(e, t, n.value, null),
                Reflect.defineProperty(e, t, n)
            );
        },
    };
p.NODE_ENV !== 'production' &&
    (es.ownKeys = (e) => (
        w(
            'Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.'
        ),
        Reflect.ownKeys(e)
    ));
function ml(e) {
    const t = {};
    return (
        Object.defineProperty(t, '_', {
            configurable: !0,
            enumerable: !1,
            get: () => e,
        }),
        Object.keys(Ot).forEach((n) => {
            Object.defineProperty(t, n, {
                configurable: !0,
                enumerable: !1,
                get: () => Ot[n](e),
                // intercepted by the proxy so no need for implementation,
                // but needed to prevent set errors
                set: ae,
            });
        }),
        t
    );
}
function gl(e) {
    const {
        ctx: t,
        propsOptions: [n],
    } = e;
    n &&
        Object.keys(n).forEach((r) => {
            Object.defineProperty(t, r, {
                enumerable: !0,
                configurable: !0,
                get: () => e.props[r],
                set: ae,
            });
        });
}
function vl(e) {
    const {ctx: t, setupState: n} = e;
    Object.keys(R(n)).forEach((r) => {
        if (!n.__isScriptSetup) {
            if (no(r[0])) {
                w(
                    `setup() return property ${JSON.stringify(
                        r
                    )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
                );
                return;
            }
            Object.defineProperty(t, r, {
                enumerable: !0,
                configurable: !0,
                get: () => n[r],
                set: ae,
            });
        }
    });
}
function $o(e) {
    return M(e) ? e.reduce((t, n) => ((t[n] = null), t), {}) : e;
}
function _l() {
    const e = /* @__PURE__ */ Object.create(null);
    return (t, n) => {
        e[n] ? w(`${t} property "${n}" is already defined in ${e[n]}.`) : (e[n] = t);
    };
}
let xr = !0;
function yl(e) {
    const t = ro(e),
        n = e.proxy,
        r = e.ctx;
    ((xr = !1), t.beforeCreate && Co(t.beforeCreate, e, 'bc'));
    const {
            // state
            data: o,
            computed: i,
            methods: s,
            watch: a,
            provide: u,
            inject: d,
            // lifecycle
            created: h,
            beforeMount: c,
            mounted: m,
            beforeUpdate: N,
            updated: T,
            activated: P,
            deactivated: L,
            beforeDestroy: X,
            beforeUnmount: j,
            destroyed: A,
            unmounted: F,
            render: B,
            renderTracked: Y,
            renderTriggered: C,
            errorCaptured: K,
            serverPrefetch: Q,
            // public API
            expose: ue,
            inheritAttrs: ye,
            // assets
            components: Ce,
            directives: Vt,
            filters: gn,
        } = t,
        ie = p.NODE_ENV !== 'production' ? _l() : null;
    if (p.NODE_ENV !== 'production') {
        const [W] = e.propsOptions;
        if (W) for (const q in W) ie('Props', q);
    }
    if ((d && bl(d, r, ie), s))
        for (const W in s) {
            const q = s[W];
            S(q)
                ? (p.NODE_ENV !== 'production'
                      ? Object.defineProperty(r, W, {
                            value: q.bind(n),
                            configurable: !0,
                            enumerable: !0,
                            writable: !0,
                        })
                      : (r[W] = q.bind(n)),
                  p.NODE_ENV !== 'production' && ie('Methods', W))
                : p.NODE_ENV !== 'production' &&
                  w(
                      `Method "${W}" has type "${typeof q}" in the component definition. Did you reference the function correctly?`
                  );
        }
    if (o) {
        p.NODE_ENV !== 'production' &&
            !S(o) &&
            w('The data option must be a function. Plain object usage is no longer supported.');
        const W = o.call(n, n);
        if (
            (p.NODE_ENV !== 'production' &&
                Lr(W) &&
                w(
                    'data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.'
                ),
            !ee(W))
        )
            p.NODE_ENV !== 'production' && w('data() should return an object.');
        else if (((e.data = Yt(W)), p.NODE_ENV !== 'production'))
            for (const q in W)
                (ie('Data', q),
                    no(q[0]) ||
                        Object.defineProperty(r, q, {
                            configurable: !0,
                            enumerable: !0,
                            get: () => W[q],
                            set: ae,
                        }));
    }
    if (((xr = !0), i))
        for (const W in i) {
            const q = i[W],
                Se = S(q) ? q.bind(n, n) : S(q.get) ? q.get.bind(n, n) : ae;
            p.NODE_ENV !== 'production' && Se === ae && w(`Computed property "${W}" has no getter.`);
            const or =
                    !S(q) && S(q.set)
                        ? q.set.bind(n)
                        : p.NODE_ENV !== 'production'
                          ? () => {
                                w(`Write operation failed: computed property "${W}" is readonly.`);
                            }
                          : ae,
                qt = Tt({
                    get: Se,
                    set: or,
                });
            (Object.defineProperty(r, W, {
                enumerable: !0,
                configurable: !0,
                get: () => qt.value,
                set: (Mt) => (qt.value = Mt),
            }),
                p.NODE_ENV !== 'production' && ie('Computed', W));
        }
    if (a) for (const W in a) ts(a[W], r, n, W);
    if (u) {
        const W = S(u) ? u.call(n) : u;
        Reflect.ownKeys(W).forEach((q) => {
            $l(q, W[q]);
        });
    }
    h && Co(h, e, 'c');
    function oe(W, q) {
        M(q) ? q.forEach((Se) => W(Se.bind(n))) : q && W(q.bind(n));
    }
    if (
        (oe(ol, c),
        oe(il, m),
        oe(sl, N),
        oe(al, T),
        oe(tl, P),
        oe(nl, L),
        oe(dl, K),
        oe(fl, Y),
        oe(cl, C),
        oe(ll, j),
        oe(Qi, F),
        oe(ul, Q),
        M(ue))
    )
        if (ue.length) {
            const W = e.exposed || (e.exposed = {});
            ue.forEach((q) => {
                Object.defineProperty(W, q, {
                    get: () => n[q],
                    set: (Se) => (n[q] = Se),
                });
            });
        } else e.exposed || (e.exposed = {});
    (B && e.render === ae && (e.render = B),
        ye != null && (e.inheritAttrs = ye),
        Ce && (e.components = Ce),
        Vt && (e.directives = Vt));
}
function bl(e, t, n = ae) {
    M(e) && (e = Vr(e));
    for (const r in e) {
        const o = e[r];
        let i;
        (ee(o) ? ('default' in o ? (i = xn(o.from || r, o.default, !0)) : (i = xn(o.from || r))) : (i = xn(o)),
            ge(i)
                ? Object.defineProperty(t, r, {
                      enumerable: !0,
                      configurable: !0,
                      get: () => i.value,
                      set: (s) => (i.value = s),
                  })
                : (t[r] = i),
            p.NODE_ENV !== 'production' && n('Inject', r));
    }
}
function Co(e, t, n) {
    Pe(M(e) ? e.map((r) => r.bind(t.proxy)) : e.bind(t.proxy), t, n);
}
function ts(e, t, n, r) {
    const o = r.includes('.') ? Xi(n, r) : () => n[r];
    if (re(e)) {
        const i = t[e];
        S(i) ? dr(o, i) : p.NODE_ENV !== 'production' && w(`Invalid watch handler specified by key "${e}"`, i);
    } else if (S(e)) dr(o, e.bind(n));
    else if (ee(e))
        if (M(e)) e.forEach((i) => ts(i, t, n, r));
        else {
            const i = S(e.handler) ? e.handler.bind(n) : t[e.handler];
            S(i)
                ? dr(o, i, e)
                : p.NODE_ENV !== 'production' && w(`Invalid watch handler specified by key "${e.handler}"`, i);
        }
    else p.NODE_ENV !== 'production' && w(`Invalid watch option: "${r}"`, e);
}
function ro(e) {
    const t = e.type,
        {mixins: n, extends: r} = t,
        {
            mixins: o,
            optionsCache: i,
            config: {optionMergeStrategies: s},
        } = e.appContext,
        a = i.get(t);
    let u;
    return (
        a
            ? (u = a)
            : !o.length && !n && !r
              ? (u = t)
              : ((u = {}), o.length && o.forEach((d) => Fn(u, d, s, !0)), Fn(u, t, s)),
        ee(t) && i.set(t, u),
        u
    );
}
function Fn(e, t, n, r = !1) {
    const {mixins: o, extends: i} = t;
    (i && Fn(e, i, n, !0), o && o.forEach((s) => Fn(e, s, n, !0)));
    for (const s in t)
        if (r && s === 'expose')
            p.NODE_ENV !== 'production' &&
                w(
                    '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
                );
        else {
            const a = wl[s] || (n && n[s]);
            e[s] = a ? a(e[s], t[s]) : t[s];
        }
    return e;
}
const wl = {
    data: To,
    props: xo,
    emits: xo,
    // objects
    methods: tn,
    computed: tn,
    // lifecycle
    beforeCreate: Ee,
    created: Ee,
    beforeMount: Ee,
    mounted: Ee,
    beforeUpdate: Ee,
    updated: Ee,
    beforeDestroy: Ee,
    beforeUnmount: Ee,
    destroyed: Ee,
    unmounted: Ee,
    activated: Ee,
    deactivated: Ee,
    errorCaptured: Ee,
    serverPrefetch: Ee,
    // assets
    components: tn,
    directives: tn,
    // watch
    watch: Nl,
    // provide / inject
    provide: To,
    inject: El,
};
function To(e, t) {
    return t
        ? e
            ? function () {
                  return se(S(e) ? e.call(this, this) : e, S(t) ? t.call(this, this) : t);
              }
            : t
        : e;
}
function El(e, t) {
    return tn(Vr(e), Vr(t));
}
function Vr(e) {
    if (M(e)) {
        const t = {};
        for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
        return t;
    }
    return e;
}
function Ee(e, t) {
    return e ? [...new Set([].concat(e, t))] : t;
}
function tn(e, t) {
    return e ? se(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function xo(e, t) {
    return e
        ? M(e) && M(t)
            ? [.../* @__PURE__ */ new Set([...e, ...t])]
            : se(/* @__PURE__ */ Object.create(null), $o(e), $o(t ?? {}))
        : t;
}
function Nl(e, t) {
    if (!e) return t;
    if (!t) return e;
    const n = se(/* @__PURE__ */ Object.create(null), e);
    for (const r in t) n[r] = Ee(e[r], t[r]);
    return n;
}
function ns() {
    return {
        app: null,
        config: {
            isNativeTag: ii,
            performance: !1,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {},
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap(),
    };
}
let Ol = 0;
function Dl(e, t) {
    return function (r, o = null) {
        (S(r) || (r = se({}, r)),
            o != null &&
                !ee(o) &&
                (p.NODE_ENV !== 'production' && w('root props passed to app.mount() must be an object.'), (o = null)));
        const i = ns(),
            s = /* @__PURE__ */ new WeakSet();
        let a = !1;
        const u = (i.app = {
            _uid: Ol++,
            _component: r,
            _props: o,
            _container: null,
            _context: i,
            _instance: null,
            version: Uo,
            get config() {
                return i.config;
            },
            set config(d) {
                p.NODE_ENV !== 'production' && w('app.config cannot be replaced. Modify individual options instead.');
            },
            use(d, ...h) {
                return (
                    s.has(d)
                        ? p.NODE_ENV !== 'production' && w('Plugin has already been applied to target app.')
                        : d && S(d.install)
                          ? (s.add(d), d.install(u, ...h))
                          : S(d)
                            ? (s.add(d), d(u, ...h))
                            : p.NODE_ENV !== 'production' &&
                              w('A plugin must either be a function or an object with an "install" function.'),
                    u
                );
            },
            mixin(d) {
                return (
                    i.mixins.includes(d)
                        ? p.NODE_ENV !== 'production' &&
                          w('Mixin has already been applied to target app' + (d.name ? `: ${d.name}` : ''))
                        : i.mixins.push(d),
                    u
                );
            },
            component(d, h) {
                return (
                    p.NODE_ENV !== 'production' && Ar(d, i.config),
                    h
                        ? (p.NODE_ENV !== 'production' &&
                              i.components[d] &&
                              w(`Component "${d}" has already been registered in target app.`),
                          (i.components[d] = h),
                          u)
                        : i.components[d]
                );
            },
            directive(d, h) {
                return (
                    p.NODE_ENV !== 'production' && zi(d),
                    h
                        ? (p.NODE_ENV !== 'production' &&
                              i.directives[d] &&
                              w(`Directive "${d}" has already been registered in target app.`),
                          (i.directives[d] = h),
                          u)
                        : i.directives[d]
                );
            },
            mount(d, h, c) {
                if (a)
                    p.NODE_ENV !== 'production' &&
                        w(
                            'App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`'
                        );
                else {
                    p.NODE_ENV !== 'production' &&
                        d.__vue_app__ &&
                        w(
                            'There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first.'
                        );
                    const m = pe(r, o);
                    return (
                        (m.appContext = i),
                        c === !0 ? (c = 'svg') : c === !1 && (c = void 0),
                        p.NODE_ENV !== 'production' &&
                            (i.reload = () => {
                                e(ct(m), d, c);
                            }),
                        h && t ? t(m, d) : e(m, d, c),
                        (a = !0),
                        (u._container = d),
                        (d.__vue_app__ = u),
                        p.NODE_ENV !== 'production' && ((u._instance = m.component), Pa(u, Uo)),
                        er(m.component) || m.component.proxy
                    );
                }
            },
            unmount() {
                a
                    ? (e(null, u._container),
                      p.NODE_ENV !== 'production' && ((u._instance = null), Sa(u)),
                      delete u._container.__vue_app__)
                    : p.NODE_ENV !== 'production' && w('Cannot unmount an app that is not mounted.');
            },
            provide(d, h) {
                return (
                    p.NODE_ENV !== 'production' &&
                        d in i.provides &&
                        w(
                            `App already provides property with key "${String(d)}". It will be overwritten with the new value.`
                        ),
                    (i.provides[d] = h),
                    u
                );
            },
            runWithContext(d) {
                Rn = u;
                try {
                    return d();
                } finally {
                    Rn = null;
                }
            },
        });
        return u;
    };
}
let Rn = null;
function $l(e, t) {
    if (!de) p.NODE_ENV !== 'production' && w('provide() can only be used inside setup().');
    else {
        let n = de.provides;
        const r = de.parent && de.parent.provides;
        (r === n && (n = de.provides = Object.create(r)), (n[e] = t));
    }
}
function xn(e, t, n = !1) {
    const r = de || le;
    if (r || Rn) {
        const o = r
            ? r.parent == null
                ? r.vnode.appContext && r.vnode.appContext.provides
                : r.parent.provides
            : Rn._context.provides;
        if (o && e in o) return o[e];
        if (arguments.length > 1) return n && S(t) ? t.call(r && r.proxy) : t;
        p.NODE_ENV !== 'production' && w(`injection "${String(e)}" not found.`);
    } else p.NODE_ENV !== 'production' && w('inject() can only be used inside setup() or functional components.');
}
function Cl(e, t, n, r = !1) {
    const o = {},
        i = {};
    (Sn(i, Qn, 1), (e.propsDefaults = /* @__PURE__ */ Object.create(null)), rs(e, t, o, i));
    for (const s in e.propsOptions[0]) s in o || (o[s] = void 0);
    (p.NODE_ENV !== 'production' && is(t || {}, o, e),
        n ? (e.props = r ? o : pa(o)) : e.type.props ? (e.props = o) : (e.props = i),
        (e.attrs = i));
}
function Tl(e) {
    for (; e;) {
        if (e.type.__hmrId) return !0;
        e = e.parent;
    }
}
function xl(e, t, n, r) {
    const {
            props: o,
            attrs: i,
            vnode: {patchFlag: s},
        } = e,
        a = R(o),
        [u] = e.propsOptions;
    let d = !1;
    if (
        // always force full diff in dev
        // - #1942 if hmr is enabled with sfc component
        // - vite#872 non-sfc component used by sfc component
        !(p.NODE_ENV !== 'production' && Tl(e)) &&
        (r || s > 0) &&
        !(s & 16)
    ) {
        if (s & 8) {
            const h = e.vnode.dynamicProps;
            for (let c = 0; c < h.length; c++) {
                let m = h[c];
                if (Xn(e.emitsOptions, m)) continue;
                const N = t[m];
                if (u)
                    if (H(i, m)) N !== i[m] && ((i[m] = N), (d = !0));
                    else {
                        const T = Ue(m);
                        o[T] = Mr(u, a, T, N, e, !1);
                    }
                else N !== i[m] && ((i[m] = N), (d = !0));
            }
        }
    } else {
        rs(e, t, o, i) && (d = !0);
        let h;
        for (const c in a)
            (!t || // for camelCase
                (!H(t, c) && // it's possible the original props was passed in as kebab-case
                    // and converted to camelCase (#955)
                    ((h = st(c)) === c || !H(t, h)))) &&
                (u
                    ? n && // for camelCase
                      (n[c] !== void 0 || // for kebab-case
                          n[h] !== void 0) &&
                      (o[c] = Mr(u, a, c, void 0, e, !0))
                    : delete o[c]);
        if (i !== a) for (const c in i) (!t || !H(t, c)) && (delete i[c], (d = !0));
    }
    (d && Le(e, 'set', '$attrs'), p.NODE_ENV !== 'production' && is(t || {}, o, e));
}
function rs(e, t, n, r) {
    const [o, i] = e.propsOptions;
    let s = !1,
        a;
    if (t)
        for (let u in t) {
            if (Dn(u)) continue;
            const d = t[u];
            let h;
            o && H(o, (h = Ue(u)))
                ? !i || !i.includes(h)
                    ? (n[h] = d)
                    : ((a || (a = {}))[h] = d)
                : Xn(e.emitsOptions, u) || ((!(u in r) || d !== r[u]) && ((r[u] = d), (s = !0)));
        }
    if (i) {
        const u = R(n),
            d = a || Z;
        for (let h = 0; h < i.length; h++) {
            const c = i[h];
            n[c] = Mr(o, u, c, d[c], e, !H(d, c));
        }
    }
    return s;
}
function Mr(e, t, n, r, o, i) {
    const s = e[n];
    if (s != null) {
        const a = H(s, 'default');
        if (a && r === void 0) {
            const u = s.default;
            if (s.type !== Function && !s.skipFactory && S(u)) {
                const {propsDefaults: d} = o;
                if (n in d) r = d[n];
                else {
                    const h = mn(o);
                    ((r = d[n] = u.call(null, t)), h());
                }
            } else r = u;
        }
        s[0] &&
            /* shouldCast */
            (i && !a
                ? (r = !1)
                : s[1] &&
                  /* shouldCastTrue */
                  (r === '' || r === st(n)) &&
                  (r = !0));
    }
    return r;
}
function os(e, t, n = !1) {
    const r = t.propsCache,
        o = r.get(e);
    if (o) return o;
    const i = e.props,
        s = {},
        a = [];
    let u = !1;
    if (!S(e)) {
        const h = (c) => {
            u = !0;
            const [m, N] = os(c, t, !0);
            (se(s, m), N && a.push(...N));
        };
        (!n && t.mixins.length && t.mixins.forEach(h), e.extends && h(e.extends), e.mixins && e.mixins.forEach(h));
    }
    if (!i && !u) return (ee(e) && r.set(e, Rt), Rt);
    if (M(i))
        for (let h = 0; h < i.length; h++) {
            p.NODE_ENV !== 'production' && !re(i[h]) && w('props must be strings when using array syntax.', i[h]);
            const c = Ue(i[h]);
            Vo(c) && (s[c] = Z);
        }
    else if (i) {
        p.NODE_ENV !== 'production' && !ee(i) && w('invalid props options', i);
        for (const h in i) {
            const c = Ue(h);
            if (Vo(c)) {
                const m = i[h],
                    N = (s[c] = M(m) || S(m) ? {type: m} : se({}, m));
                if (N) {
                    const T = Po(Boolean, N.type),
                        P = Po(String, N.type);
                    ((N[0] = T > -1),
                        /* shouldCast */
                        (N[1] = P < 0 || T < P),
                        /* shouldCastTrue */
                        (T > -1 || H(N, 'default')) && a.push(c));
                }
            }
        }
    }
    const d = [s, a];
    return (ee(e) && r.set(e, d), d);
}
function Vo(e) {
    return e[0] !== '$'
        ? !0
        : (p.NODE_ENV !== 'production' && w(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function Pr(e) {
    const t = e && e.toString().match(/^\s*(function|class) (\w+)/);
    return t ? t[2] : e === null ? 'null' : '';
}
function Mo(e, t) {
    return Pr(e) === Pr(t);
}
function Po(e, t) {
    return M(t) ? t.findIndex((n) => Mo(n, e)) : S(t) && Mo(t, e) ? 0 : -1;
}
function is(e, t, n) {
    const r = R(t),
        o = n.propsOptions[0];
    for (const i in o) {
        let s = o[i];
        s != null && Vl(i, r[i], s, p.NODE_ENV !== 'production' ? Ft(r) : r, !H(e, i) && !H(e, st(i)));
    }
}
function Vl(e, t, n, r, o) {
    const {type: i, required: s, validator: a, skipCheck: u} = n;
    if (s && o) {
        w('Missing required prop: "' + e + '"');
        return;
    }
    if (!(t == null && !s)) {
        if (i != null && i !== !0 && !u) {
            let d = !1;
            const h = M(i) ? i : [i],
                c = [];
            for (let m = 0; m < h.length && !d; m++) {
                const {valid: N, expectedType: T} = Pl(t, h[m]);
                (c.push(T || ''), (d = N));
            }
            if (!d) {
                w(Sl(e, t, c));
                return;
            }
        }
        a && !a(t, r) && w('Invalid prop: custom validator check failed for prop "' + e + '".');
    }
}
const Ml = /* @__PURE__ */ Ke('String,Number,Boolean,Function,Symbol,BigInt');
function Pl(e, t) {
    let n;
    const r = Pr(t);
    if (Ml(r)) {
        const o = typeof e;
        ((n = o === r.toLowerCase()), !n && o === 'object' && (n = e instanceof t));
    } else
        r === 'Object'
            ? (n = ee(e))
            : r === 'Array'
              ? (n = M(e))
              : r === 'null'
                ? (n = e === null)
                : (n = e instanceof t);
    return {
        valid: n,
        expectedType: r,
    };
}
function Sl(e, t, n) {
    if (n.length === 0)
        return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
    let r = `Invalid prop: type check failed for prop "${e}". Expected ${n.map($t).join(' | ')}`;
    const o = n[0],
        i = Ur(t),
        s = So(t, o),
        a = So(t, i);
    return (
        n.length === 1 && ko(o) && !kl(o, i) && (r += ` with value ${s}`),
        (r += `, got ${i} `),
        ko(i) && (r += `with value ${a}.`),
        r
    );
}
function So(e, t) {
    return t === 'String' ? `"${e}"` : t === 'Number' ? `${Number(e)}` : `${e}`;
}
function ko(e) {
    return ['string', 'number', 'boolean'].some((n) => e.toLowerCase() === n);
}
function kl(...e) {
    return e.some((t) => t.toLowerCase() === 'boolean');
}
const ss = (e) => e[0] === '_' || e === '$stable',
    oo = (e) => (M(e) ? e.map(Ve) : [Ve(e)]),
    Il = (e, t, n) => {
        if (t._n) return t;
        const r = At(
            (...o) => (
                p.NODE_ENV !== 'production' &&
                    de &&
                    (!n || n.root === de.root) &&
                    w(
                        `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
                    ),
                oo(t(...o))
            ),
            n
        );
        return ((r._c = !1), r);
    },
    as = (e, t, n) => {
        const r = e._ctx;
        for (const o in e) {
            if (ss(o)) continue;
            const i = e[o];
            if (S(i)) t[o] = Il(o, i, r);
            else if (i != null) {
                p.NODE_ENV !== 'production' &&
                    w(`Non-function value encountered for slot "${o}". Prefer function slots for better performance.`);
                const s = oo(i);
                t[o] = () => s;
            }
        }
    },
    ls = (e, t) => {
        p.NODE_ENV !== 'production' &&
            !to(e.vnode) &&
            w('Non-function value encountered for default slot. Prefer function slots for better performance.');
        const n = oo(t);
        e.slots.default = () => n;
    },
    Al = (e, t) => {
        if (e.vnode.shapeFlag & 32) {
            const n = t._;
            n ? ((e.slots = R(t)), Sn(t, '_', n)) : as(t, (e.slots = {}));
        } else ((e.slots = {}), t && ls(e, t));
        Sn(e.slots, Qn, 1);
    },
    Fl = (e, t, n) => {
        const {vnode: r, slots: o} = e;
        let i = !0,
            s = Z;
        if (r.shapeFlag & 32) {
            const a = t._;
            (a
                ? p.NODE_ENV !== 'production' && it
                    ? (se(o, t), Le(e, 'set', '$slots'))
                    : n && a === 1
                      ? (i = !1)
                      : (se(o, t), !n && a === 1 && delete o._)
                : ((i = !t.$stable), as(t, o)),
                (s = t));
        } else t && (ls(e, t), (s = {default: 1}));
        if (i) for (const a in o) !ss(a) && s[a] == null && delete o[a];
    };
function Sr(e, t, n, r, o = !1) {
    if (M(e)) {
        e.forEach((m, N) => Sr(m, t && (M(t) ? t[N] : t), n, r, o));
        return;
    }
    if (rn(r) && !o) return;
    const i = r.shapeFlag & 4 ? er(r.component) || r.component.proxy : r.el,
        s = o ? null : i,
        {i: a, r: u} = e;
    if (p.NODE_ENV !== 'production' && !a) {
        w(
            'Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.'
        );
        return;
    }
    const d = t && t.r,
        h = a.refs === Z ? (a.refs = {}) : a.refs,
        c = a.setupState;
    if ((d != null && d !== u && (re(d) ? ((h[d] = null), H(c, d) && (c[d] = null)) : ge(d) && (d.value = null)), S(u)))
        qe(u, a, 12, [s, h]);
    else {
        const m = re(u),
            N = ge(u),
            T = e.f;
        if (m || N) {
            const P = () => {
                if (T) {
                    const L = m ? (H(c, u) ? c[u] : h[u]) : u.value;
                    o
                        ? M(L) && Wr(L, i)
                        : M(L)
                          ? L.includes(i) || L.push(i)
                          : m
                            ? ((h[u] = [i]), H(c, u) && (c[u] = h[u]))
                            : ((u.value = [i]), e.k && (h[e.k] = u.value));
                } else
                    m
                        ? ((h[u] = s), H(c, u) && (c[u] = s))
                        : N
                          ? ((u.value = s), e.k && (h[e.k] = s))
                          : p.NODE_ENV !== 'production' && w('Invalid template ref type:', u, `(${typeof u})`);
            };
            o || T ? P() : ((P.id = -1), Ne(P, n));
        } else p.NODE_ENV !== 'production' && w('Invalid template ref type:', u, `(${typeof u})`);
    }
}
let Jt, rt;
function Ge(e, t) {
    (e.appContext.config.performance && Wn() && rt.mark(`vue-${t}-${e.uid}`),
        p.NODE_ENV !== 'production' && Fa(e, t, Wn() ? rt.now() : Date.now()));
}
function Be(e, t) {
    if (e.appContext.config.performance && Wn()) {
        const n = `vue-${t}-${e.uid}`,
            r = n + ':end';
        (rt.mark(r), rt.measure(`<${tr(e, e.type)}> ${t}`, n, r), rt.clearMarks(n), rt.clearMarks(r));
    }
    p.NODE_ENV !== 'production' && Ra(e, t, Wn() ? rt.now() : Date.now());
}
function Wn() {
    return (
        Jt !== void 0 ||
            (typeof window < 'u' && window.performance ? ((Jt = !0), (rt = window.performance)) : (Jt = !1)),
        Jt
    );
}
function Rl() {
    const e = [];
    if (p.NODE_ENV !== 'production' && e.length) {
        const t = e.length > 1;
        console.warn(
            `Feature flag${t ? 's' : ''} ${e.join(', ')} ${t ? 'are' : 'is'} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
        );
    }
}
const Ne = Xa;
function Wl(e) {
    return Ll(e);
}
function Ll(e, t) {
    Rl();
    const n = Hr();
    ((n.__VUE__ = !0), p.NODE_ENV !== 'production' && Li(n.__VUE_DEVTOOLS_GLOBAL_HOOK__, n));
    const {
            insert: r,
            remove: o,
            patchProp: i,
            createElement: s,
            createText: a,
            createComment: u,
            setText: d,
            setElementText: h,
            parentNode: c,
            nextSibling: m,
            setScopeId: N = ae,
            insertStaticContent: T,
        } = e,
        P = (
            l,
            f,
            g,
            v = null,
            _ = null,
            E = null,
            D = void 0,
            b = null,
            O = p.NODE_ENV !== 'production' && it ? !1 : !!f.dynamicChildren
        ) => {
            if (l === f) return;
            (l && !Qt(l, f) && ((v = vn(l)), ze(l, _, E, !0), (l = null)),
                f.patchFlag === -2 && ((O = !1), (f.dynamicChildren = null)));
            const {type: y, ref: $, shapeFlag: V} = f;
            switch (y) {
                case hn:
                    L(l, f, g, v);
                    break;
                case De:
                    X(l, f, g, v);
                    break;
                case Vn:
                    l == null ? j(f, g, v, D) : p.NODE_ENV !== 'production' && A(l, f, g, D);
                    break;
                case Oe:
                    Vt(l, f, g, v, _, E, D, b, O);
                    break;
                default:
                    V & 1
                        ? Y(l, f, g, v, _, E, D, b, O)
                        : V & 6
                          ? gn(l, f, g, v, _, E, D, b, O)
                          : V & 64 || V & 128
                            ? y.process(l, f, g, v, _, E, D, b, O, Pt)
                            : p.NODE_ENV !== 'production' && w('Invalid VNode type:', y, `(${typeof y})`);
            }
            $ != null && _ && Sr($, l && l.ref, E, f || l, !f);
        },
        L = (l, f, g, v) => {
            if (l == null) r((f.el = a(f.children)), g, v);
            else {
                const _ = (f.el = l.el);
                f.children !== l.children && d(_, f.children);
            }
        },
        X = (l, f, g, v) => {
            l == null ? r((f.el = u(f.children || '')), g, v) : (f.el = l.el);
        },
        j = (l, f, g, v) => {
            [l.el, l.anchor] = T(l.children, f, g, v, l.el, l.anchor);
        },
        A = (l, f, g, v) => {
            if (f.children !== l.children) {
                const _ = m(l.anchor);
                (B(l), ([f.el, f.anchor] = T(f.children, g, _, v)));
            } else ((f.el = l.el), (f.anchor = l.anchor));
        },
        F = ({el: l, anchor: f}, g, v) => {
            let _;
            for (; l && l !== f;) ((_ = m(l)), r(l, g, v), (l = _));
            r(f, g, v);
        },
        B = ({el: l, anchor: f}) => {
            let g;
            for (; l && l !== f;) ((g = m(l)), o(l), (l = g));
            o(f);
        },
        Y = (l, f, g, v, _, E, D, b, O) => {
            (f.type === 'svg' ? (D = 'svg') : f.type === 'math' && (D = 'mathml'),
                l == null ? C(f, g, v, _, E, D, b, O) : ue(l, f, _, E, D, b, O));
        },
        C = (l, f, g, v, _, E, D, b) => {
            let O, y;
            const {props: $, shapeFlag: V, transition: x, dirs: k} = l;
            if (
                ((O = l.el = s(l.type, E, $ && $.is, $)),
                V & 8 ? h(O, l.children) : V & 16 && Q(l.children, O, null, v, _, hr(l, E), D, b),
                k && pt(l, null, v, 'created'),
                K(O, l, l.scopeId, D, v),
                $)
            ) {
                for (const z in $) z !== 'value' && !Dn(z) && i(O, z, null, $[z], E, l.children, v, _, He);
                ('value' in $ && i(O, 'value', null, $.value, E), (y = $.onVnodeBeforeMount) && Ie(y, v, l));
            }
            (p.NODE_ENV !== 'production' &&
                (Object.defineProperty(O, '__vnode', {
                    value: l,
                    enumerable: !1,
                }),
                Object.defineProperty(O, '__vueParentComponent', {
                    value: v,
                    enumerable: !1,
                })),
                k && pt(l, null, v, 'beforeMount'));
            const G = Ul(_, x);
            (G && x.beforeEnter(O),
                r(O, f, g),
                ((y = $ && $.onVnodeMounted) || G || k) &&
                    Ne(() => {
                        (y && Ie(y, v, l), G && x.enter(O), k && pt(l, null, v, 'mounted'));
                    }, _));
        },
        K = (l, f, g, v, _) => {
            if ((g && N(l, g), v)) for (let E = 0; E < v.length; E++) N(l, v[E]);
            if (_) {
                let E = _.subTree;
                if (
                    (p.NODE_ENV !== 'production' && E.patchFlag > 0 && E.patchFlag & 2048 && (E = eo(E.children) || E),
                    f === E)
                ) {
                    const D = _.vnode;
                    K(l, D, D.scopeId, D.slotScopeIds, _.parent);
                }
            }
        },
        Q = (l, f, g, v, _, E, D, b, O = 0) => {
            for (let y = O; y < l.length; y++) {
                const $ = (l[y] = b ? tt(l[y]) : Ve(l[y]));
                P(null, $, f, g, v, _, E, D, b);
            }
        },
        ue = (l, f, g, v, _, E, D) => {
            const b = (f.el = l.el);
            let {patchFlag: O, dynamicChildren: y, dirs: $} = f;
            O |= l.patchFlag & 16;
            const V = l.props || Z,
                x = f.props || Z;
            let k;
            if (
                (g && ht(g, !1),
                (k = x.onVnodeBeforeUpdate) && Ie(k, g, f, l),
                $ && pt(f, l, g, 'beforeUpdate'),
                g && ht(g, !0),
                p.NODE_ENV !== 'production' && it && ((O = 0), (D = !1), (y = null)),
                y
                    ? (ye(l.dynamicChildren, y, b, g, v, hr(f, _), E), p.NODE_ENV !== 'production' && on(l, f))
                    : D || Se(l, f, b, null, g, v, hr(f, _), E, !1),
                O > 0)
            ) {
                if (O & 16) Ce(b, f, V, x, g, v, _);
                else if (
                    (O & 2 && V.class !== x.class && i(b, 'class', null, x.class, _),
                    O & 4 && i(b, 'style', V.style, x.style, _),
                    O & 8)
                ) {
                    const G = f.dynamicProps;
                    for (let z = 0; z < G.length; z++) {
                        const ne = G[z],
                            ce = V[ne],
                            Te = x[ne];
                        (Te !== ce || ne === 'value') && i(b, ne, ce, Te, _, l.children, g, v, He);
                    }
                }
                O & 1 && l.children !== f.children && h(b, f.children);
            } else !D && y == null && Ce(b, f, V, x, g, v, _);
            ((k = x.onVnodeUpdated) || $) &&
                Ne(() => {
                    (k && Ie(k, g, f, l), $ && pt(f, l, g, 'updated'));
                }, v);
        },
        ye = (l, f, g, v, _, E, D) => {
            for (let b = 0; b < f.length; b++) {
                const O = l[b],
                    y = f[b],
                    $ =
                        // oldVNode may be an errored async setup() component inside Suspense
                        // which will not have a mounted element
                        O.el && // - In the case of a Fragment, we need to provide the actual parent
                        // of the Fragment itself so it can move its children.
                        (O.type === Oe || // - In the case of different nodes, there is going to be a replacement
                            // which also requires the correct parent container
                            !Qt(O, y) || // - In the case of a component, it could contain anything.
                            O.shapeFlag & 70)
                            ? c(O.el)
                            : // In other cases, the parent container is not actually used so we
                              // just pass the block element here to avoid a DOM parentNode call.
                              g;
                P(O, y, $, null, v, _, E, D, !0);
            }
        },
        Ce = (l, f, g, v, _, E, D) => {
            if (g !== v) {
                if (g !== Z) for (const b in g) !Dn(b) && !(b in v) && i(l, b, g[b], null, D, f.children, _, E, He);
                for (const b in v) {
                    if (Dn(b)) continue;
                    const O = v[b],
                        y = g[b];
                    O !== y && b !== 'value' && i(l, b, y, O, D, f.children, _, E, He);
                }
                'value' in v && i(l, 'value', g.value, v.value, D);
            }
        },
        Vt = (l, f, g, v, _, E, D, b, O) => {
            const y = (f.el = l ? l.el : a('')),
                $ = (f.anchor = l ? l.anchor : a(''));
            let {patchFlag: V, dynamicChildren: x, slotScopeIds: k} = f;
            (p.NODE_ENV !== 'production' && // #5523 dev root fragment may inherit directives
                (it || V & 2048) &&
                ((V = 0), (O = !1), (x = null)),
                k && (b = b ? b.concat(k) : k),
                l == null
                    ? (r(y, g, v),
                      r($, g, v),
                      Q(
                          // #10007
                          // such fragment like `<></>` will be compiled into
                          // a fragment which doesn't have a children.
                          // In this case fallback to an empty array
                          f.children || [],
                          g,
                          $,
                          _,
                          E,
                          D,
                          b,
                          O
                      ))
                    : V > 0 &&
                        V & 64 &&
                        x && // #2715 the previous fragment could've been a BAILed one as a result
                        // of renderSlot() with no valid children
                        l.dynamicChildren
                      ? (ye(l.dynamicChildren, x, g, _, E, D, b),
                        p.NODE_ENV !== 'production'
                            ? on(l, f)
                            : // #2080 if the stable fragment has a key, it's a <template v-for> that may
                              //  get moved around. Make sure all root level vnodes inherit el.
                              // #2134 or if it's a component root, it may also get moved around
                              // as the component is being moved.
                              (f.key != null || (_ && f === _.subTree)) &&
                              on(
                                  l,
                                  f,
                                  !0
                                  /* shallow */
                              ))
                      : Se(l, f, g, $, _, E, D, b, O));
        },
        gn = (l, f, g, v, _, E, D, b, O) => {
            ((f.slotScopeIds = b),
                l == null
                    ? f.shapeFlag & 512
                        ? _.ctx.activate(f, g, v, D, O)
                        : ie(f, g, v, _, E, D, O)
                    : oe(l, f, O));
        },
        ie = (l, f, g, v, _, E, D) => {
            const b = (l.component = Zl(l, v, _));
            if (
                (p.NODE_ENV !== 'production' && b.type.__hmrId && Ta(b),
                p.NODE_ENV !== 'production' && (Cn(l), Ge(b, 'mount')),
                to(l) && (b.ctx.renderer = Pt),
                p.NODE_ENV !== 'production' && Ge(b, 'init'),
                tu(b),
                p.NODE_ENV !== 'production' && Be(b, 'init'),
                b.asyncDep)
            ) {
                if ((_ && _.registerDep(b, W), !l.el)) {
                    const O = (b.subTree = pe(De));
                    X(null, O, f, g);
                }
            } else W(b, l, f, g, _, E, D);
            p.NODE_ENV !== 'production' && (Tn(), Be(b, 'mount'));
        },
        oe = (l, f, g) => {
            const v = (f.component = l.component);
            if (Ha(l, f, g))
                if (v.asyncDep && !v.asyncResolved) {
                    (p.NODE_ENV !== 'production' && Cn(f), q(v, f, g), p.NODE_ENV !== 'production' && Tn());
                    return;
                } else ((v.next = f), $a(v.update), (v.effect.dirty = !0), v.update());
            else ((f.el = l.el), (v.vnode = f));
        },
        W = (l, f, g, v, _, E, D) => {
            const b = () => {
                    if (l.isMounted) {
                        let {next: $, bu: V, u: x, parent: k, vnode: G} = l;
                        {
                            const St = us(l);
                            if (St) {
                                ($ && (($.el = G.el), q(l, $, D)),
                                    St.asyncDep.then(() => {
                                        l.isUnmounted || b();
                                    }));
                                return;
                            }
                        }
                        let z = $,
                            ne;
                        (p.NODE_ENV !== 'production' && Cn($ || l.vnode),
                            ht(l, !1),
                            $ ? (($.el = G.el), q(l, $, D)) : ($ = G),
                            V && Xt(V),
                            (ne = $.props && $.props.onVnodeBeforeUpdate) && Ie(ne, k, $, G),
                            ht(l, !0),
                            p.NODE_ENV !== 'production' && Ge(l, 'render'));
                        const ce = fr(l);
                        p.NODE_ENV !== 'production' && Be(l, 'render');
                        const Te = l.subTree;
                        ((l.subTree = ce),
                            p.NODE_ENV !== 'production' && Ge(l, 'patch'),
                            P(
                                Te,
                                ce,
                                // parent may have changed if it's in a teleport
                                c(Te.el),
                                // anchor may have changed if it's in a fragment
                                vn(Te),
                                l,
                                _,
                                E
                            ),
                            p.NODE_ENV !== 'production' && Be(l, 'patch'),
                            ($.el = ce.el),
                            z === null && Ga(l, ce.el),
                            x && Ne(x, _),
                            (ne = $.props && $.props.onVnodeUpdated) && Ne(() => Ie(ne, k, $, G), _),
                            p.NODE_ENV !== 'production' && Ui(l),
                            p.NODE_ENV !== 'production' && Tn());
                    } else {
                        let $;
                        const {el: V, props: x} = f,
                            {bm: k, m: G, parent: z} = l,
                            ne = rn(f);
                        if (
                            (ht(l, !1),
                            k && Xt(k),
                            !ne && ($ = x && x.onVnodeBeforeMount) && Ie($, z, f),
                            ht(l, !0),
                            V && lr)
                        ) {
                            const ce = () => {
                                (p.NODE_ENV !== 'production' && Ge(l, 'render'),
                                    (l.subTree = fr(l)),
                                    p.NODE_ENV !== 'production' && Be(l, 'render'),
                                    p.NODE_ENV !== 'production' && Ge(l, 'hydrate'),
                                    lr(V, l.subTree, l, _, null),
                                    p.NODE_ENV !== 'production' && Be(l, 'hydrate'));
                            };
                            ne
                                ? f.type.__asyncLoader().then(
                                      // note: we are moving the render call into an async callback,
                                      // which means it won't track dependencies - but it's ok because
                                      // a server-rendered async wrapper is already in resolved state
                                      // and it will never need to change.
                                      () => !l.isUnmounted && ce()
                                  )
                                : ce();
                        } else {
                            p.NODE_ENV !== 'production' && Ge(l, 'render');
                            const ce = (l.subTree = fr(l));
                            (p.NODE_ENV !== 'production' && Be(l, 'render'),
                                p.NODE_ENV !== 'production' && Ge(l, 'patch'),
                                P(null, ce, g, v, l, _, E),
                                p.NODE_ENV !== 'production' && Be(l, 'patch'),
                                (f.el = ce.el));
                        }
                        if ((G && Ne(G, _), !ne && ($ = x && x.onVnodeMounted))) {
                            const ce = f;
                            Ne(() => Ie($, z, ce), _);
                        }
                        ((f.shapeFlag & 256 || (z && rn(z.vnode) && z.vnode.shapeFlag & 256)) && l.a && Ne(l.a, _),
                            (l.isMounted = !0),
                            p.NODE_ENV !== 'production' && ka(l),
                            (f = g = v = null));
                    }
                },
                O = (l.effect = new Br(
                    b,
                    ae,
                    () => Kn(y),
                    l.scope
                    // track it in component's effect scope
                )),
                y = (l.update = () => {
                    O.dirty && O.run();
                });
            ((y.id = l.uid),
                ht(l, !0),
                p.NODE_ENV !== 'production' &&
                    ((O.onTrack = l.rtc ? ($) => Xt(l.rtc, $) : void 0),
                    (O.onTrigger = l.rtg ? ($) => Xt(l.rtg, $) : void 0),
                    (y.ownerInstance = l)),
                y());
        },
        q = (l, f, g) => {
            f.component = l;
            const v = l.vnode.props;
            ((l.vnode = f), (l.next = null), xl(l, f.props, v, g), Fl(l, f.children, g), ft(), wo(l), dt());
        },
        Se = (l, f, g, v, _, E, D, b, O = !1) => {
            const y = l && l.children,
                $ = l ? l.shapeFlag : 0,
                V = f.children,
                {patchFlag: x, shapeFlag: k} = f;
            if (x > 0) {
                if (x & 128) {
                    qt(y, V, g, v, _, E, D, b, O);
                    return;
                } else if (x & 256) {
                    or(y, V, g, v, _, E, D, b, O);
                    return;
                }
            }
            k & 8
                ? ($ & 16 && He(y, _, E), V !== y && h(g, V))
                : $ & 16
                  ? k & 16
                      ? qt(y, V, g, v, _, E, D, b, O)
                      : He(y, _, E, !0)
                  : ($ & 8 && h(g, ''), k & 16 && Q(V, g, v, _, E, D, b, O));
        },
        or = (l, f, g, v, _, E, D, b, O) => {
            ((l = l || Rt), (f = f || Rt));
            const y = l.length,
                $ = f.length,
                V = Math.min(y, $);
            let x;
            for (x = 0; x < V; x++) {
                const k = (f[x] = O ? tt(f[x]) : Ve(f[x]));
                P(l[x], k, g, null, _, E, D, b, O);
            }
            y > $ ? He(l, _, E, !0, !1, V) : Q(f, g, v, _, E, D, b, O, V);
        },
        qt = (l, f, g, v, _, E, D, b, O) => {
            let y = 0;
            const $ = f.length;
            let V = l.length - 1,
                x = $ - 1;
            for (; y <= V && y <= x;) {
                const k = l[y],
                    G = (f[y] = O ? tt(f[y]) : Ve(f[y]));
                if (Qt(k, G)) P(k, G, g, null, _, E, D, b, O);
                else break;
                y++;
            }
            for (; y <= V && y <= x;) {
                const k = l[V],
                    G = (f[x] = O ? tt(f[x]) : Ve(f[x]));
                if (Qt(k, G)) P(k, G, g, null, _, E, D, b, O);
                else break;
                (V--, x--);
            }
            if (y > V) {
                if (y <= x) {
                    const k = x + 1,
                        G = k < $ ? f[k].el : v;
                    for (; y <= x;) (P(null, (f[y] = O ? tt(f[y]) : Ve(f[y])), g, G, _, E, D, b, O), y++);
                }
            } else if (y > x) for (; y <= V;) (ze(l[y], _, E, !0), y++);
            else {
                const k = y,
                    G = y,
                    z = /* @__PURE__ */ new Map();
                for (y = G; y <= x; y++) {
                    const be = (f[y] = O ? tt(f[y]) : Ve(f[y]));
                    be.key != null &&
                        (p.NODE_ENV !== 'production' &&
                            z.has(be.key) &&
                            w(
                                'Duplicate keys found during update:',
                                JSON.stringify(be.key),
                                'Make sure keys are unique.'
                            ),
                        z.set(be.key, y));
                }
                let ne,
                    ce = 0;
                const Te = x - G + 1;
                let St = !1,
                    uo = 0;
                const Kt = new Array(Te);
                for (y = 0; y < Te; y++) Kt[y] = 0;
                for (y = k; y <= V; y++) {
                    const be = l[y];
                    if (ce >= Te) {
                        ze(be, _, E, !0);
                        continue;
                    }
                    let ke;
                    if (be.key != null) ke = z.get(be.key);
                    else
                        for (ne = G; ne <= x; ne++)
                            if (Kt[ne - G] === 0 && Qt(be, f[ne])) {
                                ke = ne;
                                break;
                            }
                    ke === void 0
                        ? ze(be, _, E, !0)
                        : ((Kt[ke - G] = y + 1),
                          ke >= uo ? (uo = ke) : (St = !0),
                          P(be, f[ke], g, null, _, E, D, b, O),
                          ce++);
                }
                const co = St ? jl(Kt) : Rt;
                for (ne = co.length - 1, y = Te - 1; y >= 0; y--) {
                    const be = G + y,
                        ke = f[be],
                        fo = be + 1 < $ ? f[be + 1].el : v;
                    Kt[y] === 0
                        ? P(null, ke, g, fo, _, E, D, b, O)
                        : St && (ne < 0 || y !== co[ne] ? Mt(ke, g, fo, 2) : ne--);
                }
            }
        },
        Mt = (l, f, g, v, _ = null) => {
            const {el: E, type: D, transition: b, children: O, shapeFlag: y} = l;
            if (y & 6) {
                Mt(l.component.subTree, f, g, v);
                return;
            }
            if (y & 128) {
                l.suspense.move(f, g, v);
                return;
            }
            if (y & 64) {
                D.move(l, f, g, Pt);
                return;
            }
            if (D === Oe) {
                r(E, f, g);
                for (let V = 0; V < O.length; V++) Mt(O[V], f, g, v);
                r(l.anchor, f, g);
                return;
            }
            if (D === Vn) {
                F(l, f, g);
                return;
            }
            if (v !== 2 && y & 1 && b)
                if (v === 0) (b.beforeEnter(E), r(E, f, g), Ne(() => b.enter(E), _));
                else {
                    const {leave: V, delayLeave: x, afterLeave: k} = b,
                        G = () => r(E, f, g),
                        z = () => {
                            V(E, () => {
                                (G(), k && k());
                            });
                        };
                    x ? x(E, G, z) : z();
                }
            else r(E, f, g);
        },
        ze = (l, f, g, v = !1, _ = !1) => {
            const {type: E, props: D, ref: b, children: O, dynamicChildren: y, shapeFlag: $, patchFlag: V, dirs: x} = l;
            if ((b != null && Sr(b, null, g, l, !0), $ & 256)) {
                f.ctx.deactivate(l);
                return;
            }
            const k = $ & 1 && x,
                G = !rn(l);
            let z;
            if ((G && (z = D && D.onVnodeBeforeUnmount) && Ie(z, f, l), $ & 6)) Cs(l.component, g, v);
            else {
                if ($ & 128) {
                    l.suspense.unmount(g, v);
                    return;
                }
                (k && pt(l, null, f, 'beforeUnmount'),
                    $ & 64
                        ? l.type.remove(l, f, g, _, Pt, v)
                        : y && // #1153: fast path should not be taken for non-stable (v-for) fragments
                            (E !== Oe || (V > 0 && V & 64))
                          ? He(y, f, g, !1, !0)
                          : ((E === Oe && V & 384) || (!_ && $ & 16)) && He(O, f, g),
                    v && ir(l));
            }
            ((G && (z = D && D.onVnodeUnmounted)) || k) &&
                Ne(() => {
                    (z && Ie(z, f, l), k && pt(l, null, f, 'unmounted'));
                }, g);
        },
        ir = (l) => {
            const {type: f, el: g, anchor: v, transition: _} = l;
            if (f === Oe) {
                p.NODE_ENV !== 'production' && l.patchFlag > 0 && l.patchFlag & 2048 && _ && !_.persisted
                    ? l.children.forEach((D) => {
                          D.type === De ? o(D.el) : ir(D);
                      })
                    : $s(g, v);
                return;
            }
            if (f === Vn) {
                B(l);
                return;
            }
            const E = () => {
                (o(g), _ && !_.persisted && _.afterLeave && _.afterLeave());
            };
            if (l.shapeFlag & 1 && _ && !_.persisted) {
                const {leave: D, delayLeave: b} = _,
                    O = () => D(g, E);
                b ? b(l.el, E, O) : O();
            } else E();
        },
        $s = (l, f) => {
            let g;
            for (; l !== f;) ((g = m(l)), o(l), (l = g));
            o(f);
        },
        Cs = (l, f, g) => {
            p.NODE_ENV !== 'production' && l.type.__hmrId && xa(l);
            const {bum: v, scope: _, update: E, subTree: D, um: b} = l;
            (v && Xt(v),
                _.stop(),
                E && ((E.active = !1), ze(D, l, f, g)),
                b && Ne(b, f),
                Ne(() => {
                    l.isUnmounted = !0;
                }, f),
                f &&
                    f.pendingBranch &&
                    !f.isUnmounted &&
                    l.asyncDep &&
                    !l.asyncResolved &&
                    l.suspenseId === f.pendingId &&
                    (f.deps--, f.deps === 0 && f.resolve()),
                p.NODE_ENV !== 'production' && Aa(l));
        },
        He = (l, f, g, v = !1, _ = !1, E = 0) => {
            for (let D = E; D < l.length; D++) ze(l[D], f, g, v, _);
        },
        vn = (l) =>
            l.shapeFlag & 6 ? vn(l.component.subTree) : l.shapeFlag & 128 ? l.suspense.next() : m(l.anchor || l.el);
    let sr = !1;
    const lo = (l, f, g) => {
            (l == null ? f._vnode && ze(f._vnode, null, null, !0) : P(f._vnode || null, l, f, null, null, null, g),
                sr || ((sr = !0), wo(), Fi(), (sr = !1)),
                (f._vnode = l));
        },
        Pt = {
            p: P,
            um: ze,
            m: Mt,
            r: ir,
            mt: ie,
            mc: Q,
            pc: Se,
            pbc: ye,
            n: vn,
            o: e,
        };
    let ar, lr;
    return (
        t && ([ar, lr] = t(Pt)),
        {
            render: lo,
            hydrate: ar,
            createApp: Dl(lo, ar),
        }
    );
}
function hr({type: e, props: t}, n) {
    return (n === 'svg' && e === 'foreignObject') ||
        (n === 'mathml' && e === 'annotation-xml' && t && t.encoding && t.encoding.includes('html'))
        ? void 0
        : n;
}
function ht({effect: e, update: t}, n) {
    e.allowRecurse = t.allowRecurse = n;
}
function Ul(e, t) {
    return (!e || (e && !e.pendingBranch)) && t && !t.persisted;
}
function on(e, t, n = !1) {
    const r = e.children,
        o = t.children;
    if (M(r) && M(o))
        for (let i = 0; i < r.length; i++) {
            const s = r[i];
            let a = o[i];
            (a.shapeFlag & 1 &&
                !a.dynamicChildren &&
                ((a.patchFlag <= 0 || a.patchFlag === 32) && ((a = o[i] = tt(o[i])), (a.el = s.el)), n || on(s, a)),
                a.type === hn && (a.el = s.el),
                p.NODE_ENV !== 'production' && a.type === De && !a.el && (a.el = s.el));
        }
}
function jl(e) {
    const t = e.slice(),
        n = [0];
    let r, o, i, s, a;
    const u = e.length;
    for (r = 0; r < u; r++) {
        const d = e[r];
        if (d !== 0) {
            if (((o = n[n.length - 1]), e[o] < d)) {
                ((t[r] = o), n.push(r));
                continue;
            }
            for (i = 0, s = n.length - 1; i < s;) ((a = (i + s) >> 1), e[n[a]] < d ? (i = a + 1) : (s = a));
            d < e[n[i]] && (i > 0 && (t[r] = n[i - 1]), (n[i] = r));
        }
    }
    for (i = n.length, s = n[i - 1]; i-- > 0;) ((n[i] = s), (s = t[s]));
    return n;
}
function us(e) {
    const t = e.subTree.component;
    if (t) return t.asyncDep && !t.asyncResolved ? t : us(t);
}
const Hl = (e) => e.__isTeleport,
    Lt = (e) => e && (e.disabled || e.disabled === ''),
    Io = (e) => typeof SVGElement < 'u' && e instanceof SVGElement,
    Ao = (e) => typeof MathMLElement == 'function' && e instanceof MathMLElement,
    kr = (e, t) => {
        const n = e && e.to;
        if (re(n))
            if (t) {
                const r = t(n);
                return (
                    r ||
                        (p.NODE_ENV !== 'production' &&
                            w(
                                `Failed to locate Teleport target with selector "${n}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`
                            )),
                    r
                );
            } else
                return (
                    p.NODE_ENV !== 'production' &&
                        w(
                            'Current renderer does not support string target for Teleports. (missing querySelector renderer option)'
                        ),
                    null
                );
        else return (p.NODE_ENV !== 'production' && !n && !Lt(e) && w(`Invalid Teleport target: ${n}`), n);
    },
    Gl = {
        name: 'Teleport',
        __isTeleport: !0,
        process(e, t, n, r, o, i, s, a, u, d) {
            const {
                    mc: h,
                    pc: c,
                    pbc: m,
                    o: {insert: N, querySelector: T, createText: P, createComment: L},
                } = d,
                X = Lt(t.props);
            let {shapeFlag: j, children: A, dynamicChildren: F} = t;
            if ((p.NODE_ENV !== 'production' && it && ((u = !1), (F = null)), e == null)) {
                const B = (t.el = p.NODE_ENV !== 'production' ? L('teleport start') : P('')),
                    Y = (t.anchor = p.NODE_ENV !== 'production' ? L('teleport end') : P(''));
                (N(B, n, r), N(Y, n, r));
                const C = (t.target = kr(t.props, T)),
                    K = (t.targetAnchor = P(''));
                C
                    ? (N(K, C), s === 'svg' || Io(C) ? (s = 'svg') : (s === 'mathml' || Ao(C)) && (s = 'mathml'))
                    : p.NODE_ENV !== 'production' && !X && w('Invalid Teleport target on mount:', C, `(${typeof C})`);
                const Q = (ue, ye) => {
                    j & 16 && h(A, ue, ye, o, i, s, a, u);
                };
                X ? Q(n, Y) : C && Q(C, K);
            } else {
                t.el = e.el;
                const B = (t.anchor = e.anchor),
                    Y = (t.target = e.target),
                    C = (t.targetAnchor = e.targetAnchor),
                    K = Lt(e.props),
                    Q = K ? n : Y,
                    ue = K ? B : C;
                if (
                    (s === 'svg' || Io(Y) ? (s = 'svg') : (s === 'mathml' || Ao(Y)) && (s = 'mathml'),
                    F ? (m(e.dynamicChildren, F, Q, o, i, s, a), on(e, t, !0)) : u || c(e, t, Q, ue, o, i, s, a, !1),
                    X)
                )
                    K
                        ? t.props && e.props && t.props.to !== e.props.to && (t.props.to = e.props.to)
                        : On(t, n, B, d, 1);
                else if ((t.props && t.props.to) !== (e.props && e.props.to)) {
                    const ye = (t.target = kr(t.props, T));
                    ye
                        ? On(t, ye, null, d, 0)
                        : p.NODE_ENV !== 'production' && w('Invalid Teleport target on update:', Y, `(${typeof Y})`);
                } else K && On(t, Y, C, d, 1);
            }
            cs(t);
        },
        remove(e, t, n, r, {um: o, o: {remove: i}}, s) {
            const {shapeFlag: a, children: u, anchor: d, targetAnchor: h, target: c, props: m} = e;
            if ((c && i(h), s && i(d), a & 16)) {
                const N = s || !Lt(m);
                for (let T = 0; T < u.length; T++) {
                    const P = u[T];
                    o(P, t, n, N, !!P.dynamicChildren);
                }
            }
        },
        move: On,
        hydrate: Bl,
    };
function On(e, t, n, {o: {insert: r}, m: o}, i = 2) {
    i === 0 && r(e.targetAnchor, t, n);
    const {el: s, anchor: a, shapeFlag: u, children: d, props: h} = e,
        c = i === 2;
    if ((c && r(s, t, n), (!c || Lt(h)) && u & 16)) for (let m = 0; m < d.length; m++) o(d[m], t, n, 2);
    c && r(a, t, n);
}
function Bl(e, t, n, r, o, i, {o: {nextSibling: s, parentNode: a, querySelector: u}}, d) {
    const h = (t.target = kr(t.props, u));
    if (h) {
        const c = h._lpa || h.firstChild;
        if (t.shapeFlag & 16)
            if (Lt(t.props)) ((t.anchor = d(s(e), t, a(e), n, r, o, i)), (t.targetAnchor = c));
            else {
                t.anchor = s(e);
                let m = c;
                for (; m;)
                    if (((m = s(m)), m && m.nodeType === 8 && m.data === 'teleport anchor')) {
                        ((t.targetAnchor = m), (h._lpa = t.targetAnchor && s(t.targetAnchor)));
                        break;
                    }
                d(c, t, h, n, r, o, i);
            }
        cs(t);
    }
    return t.anchor && s(t.anchor);
}
const Yl = Gl;
function cs(e) {
    const t = e.ctx;
    if (t && t.ut) {
        let n = e.children[0].el;
        for (; n && n !== e.targetAnchor;)
            (n.nodeType === 1 && n.setAttribute('data-v-owner', t.uid), (n = n.nextSibling));
        t.ut();
    }
}
const Oe = Symbol.for('v-fgt'),
    hn = Symbol.for('v-txt'),
    De = Symbol.for('v-cmt'),
    Vn = Symbol.for('v-stc'),
    sn = [];
let Me = null;
function te(e = !1) {
    sn.push((Me = e ? null : []));
}
function ql() {
    (sn.pop(), (Me = sn[sn.length - 1] || null));
}
let cn = 1;
function Fo(e) {
    cn += e;
}
function fs(e) {
    return ((e.dynamicChildren = cn > 0 ? Me || Rt : null), ql(), cn > 0 && Me && Me.push(e), e);
}
function fe(e, t, n, r, o, i) {
    return fs(I(e, t, n, r, o, i, !0));
}
function ut(e, t, n, r, o) {
    return fs(pe(e, t, n, r, o, !0));
}
function Jn(e) {
    return e ? e.__v_isVNode === !0 : !1;
}
function Qt(e, t) {
    return p.NODE_ENV !== 'production' && t.shapeFlag & 6 && It.has(t.type)
        ? ((e.shapeFlag &= -257), (t.shapeFlag &= -513), !1)
        : e.type === t.type && e.key === t.key;
}
const Kl = (...e) => ps(...e),
    Qn = '__vInternal',
    ds = ({key: e}) => e ?? null,
    Mn = ({ref: e, ref_key: t, ref_for: n}) => (
        typeof e == 'number' && (e = '' + e),
        e != null ? (re(e) || ge(e) || S(e) ? {i: le, r: e, k: t, f: !!n} : e) : null
    );
function I(e, t = null, n = null, r = 0, o = null, i = e === Oe ? 0 : 1, s = !1, a = !1) {
    const u = {
        __v_isVNode: !0,
        __v_skip: !0,
        type: e,
        props: t,
        key: t && ds(t),
        ref: t && Mn(t),
        scopeId: Gi,
        slotScopeIds: null,
        children: n,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: i,
        patchFlag: r,
        dynamicProps: o,
        dynamicChildren: null,
        appContext: null,
        ctx: le,
    };
    return (
        a ? (io(u, n), i & 128 && e.normalize(u)) : n && (u.shapeFlag |= re(n) ? 8 : 16),
        p.NODE_ENV !== 'production' &&
            u.key !== u.key &&
            w('VNode created with invalid key (NaN). VNode type:', u.type),
        cn > 0 && // avoid a block node from tracking itself
            !s && // has current parent block
            Me && // presence of a patch flag indicates this node needs patching on updates.
            // component nodes also should always be patched, because even if the
            // component doesn't need to update, it needs to persist the instance on to
            // the next vnode so that it can be properly unmounted later.
            (u.patchFlag > 0 || i & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
            // vnode should not be considered dynamic due to handler caching.
            u.patchFlag !== 32 &&
            Me.push(u),
        u
    );
}
const pe = p.NODE_ENV !== 'production' ? Kl : ps;
function ps(e, t = null, n = null, r = 0, o = null, i = !1) {
    if (
        ((!e || e === Yi) &&
            (p.NODE_ENV !== 'production' && !e && w(`Invalid vnode type when creating vnode: ${e}.`), (e = De)),
        Jn(e))
    ) {
        const a = ct(
            e,
            t,
            !0
            /* mergeRef: true */
        );
        return (
            n && io(a, n),
            cn > 0 && !i && Me && (a.shapeFlag & 6 ? (Me[Me.indexOf(e)] = a) : Me.push(a)),
            (a.patchFlag |= -2),
            a
        );
    }
    if ((vs(e) && (e = e.__vccOpts), t)) {
        t = Xl(t);
        let {class: a, style: u} = t;
        (a && !re(a) && (t.class = U(a)), ee(u) && (Nr(u) && !M(u) && (u = se({}, u)), (t.style = Gr(u))));
    }
    const s = re(e) ? 1 : Ka(e) ? 128 : Hl(e) ? 64 : ee(e) ? 4 : S(e) ? 2 : 0;
    return (
        p.NODE_ENV !== 'production' &&
            s & 4 &&
            Nr(e) &&
            ((e = R(e)),
            w(
                'Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.',
                `
Component that was made reactive: `,
                e
            )),
        I(e, t, n, r, o, s, i, !0)
    );
}
function Xl(e) {
    return e ? (Nr(e) || Qn in e ? se({}, e) : e) : null;
}
function ct(e, t, n = !1) {
    const {props: r, ref: o, patchFlag: i, children: s} = e,
        a = t ? zl(r || {}, t) : r;
    return {
        __v_isVNode: !0,
        __v_skip: !0,
        type: e.type,
        props: a,
        key: a && ds(a),
        ref:
            t && t.ref
                ? // #2078 in the case of <component :is="vnode" ref="extra"/>
                  // if the vnode itself already has a ref, cloneVNode will need to merge
                  // the refs so the single vnode can be set on multiple refs
                  n && o
                    ? M(o)
                        ? o.concat(Mn(t))
                        : [o, Mn(t)]
                    : Mn(t)
                : o,
        scopeId: e.scopeId,
        slotScopeIds: e.slotScopeIds,
        children: p.NODE_ENV !== 'production' && i === -1 && M(s) ? s.map(hs) : s,
        target: e.target,
        targetAnchor: e.targetAnchor,
        staticCount: e.staticCount,
        shapeFlag: e.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: t && e.type !== Oe ? (i === -1 ? 16 : i | 16) : i,
        dynamicProps: e.dynamicProps,
        dynamicChildren: e.dynamicChildren,
        appContext: e.appContext,
        dirs: e.dirs,
        transition: e.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: e.component,
        suspense: e.suspense,
        ssContent: e.ssContent && ct(e.ssContent),
        ssFallback: e.ssFallback && ct(e.ssFallback),
        el: e.el,
        anchor: e.anchor,
        ctx: e.ctx,
        ce: e.ce,
    };
}
function hs(e) {
    const t = ct(e);
    return (M(e.children) && (t.children = e.children.map(hs)), t);
}
function Ze(e = ' ', t = 0) {
    return pe(hn, null, e, t);
}
function _t(e = '', t = !1) {
    return t ? (te(), ut(De, null, e)) : pe(De, null, e);
}
function Ve(e) {
    return e == null || typeof e == 'boolean'
        ? pe(De)
        : M(e)
          ? pe(
                Oe,
                null,
                // #3666, avoid reference pollution when reusing vnode
                e.slice()
            )
          : typeof e == 'object'
            ? tt(e)
            : pe(hn, null, String(e));
}
function tt(e) {
    return (e.el === null && e.patchFlag !== -1) || e.memo ? e : ct(e);
}
function io(e, t) {
    let n = 0;
    const {shapeFlag: r} = e;
    if (t == null) t = null;
    else if (M(t)) n = 16;
    else if (typeof t == 'object')
        if (r & 65) {
            const o = t.default;
            o && (o._c && (o._d = !1), io(e, o()), o._c && (o._d = !0));
            return;
        } else {
            n = 32;
            const o = t._;
            !o && !(Qn in t)
                ? (t._ctx = le)
                : o === 3 && le && (le.slots._ === 1 ? (t._ = 1) : ((t._ = 2), (e.patchFlag |= 1024)));
        }
    else
        S(t)
            ? ((t = {default: t, _ctx: le}), (n = 32))
            : ((t = String(t)), r & 64 ? ((n = 16), (t = [Ze(t)])) : (n = 8));
    ((e.children = t), (e.shapeFlag |= n));
}
function zl(...e) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
        const r = e[n];
        for (const o in r)
            if (o === 'class') t.class !== r.class && (t.class = U([t.class, r.class]));
            else if (o === 'style') t.style = Gr([t.style, r.style]);
            else if (fn(o)) {
                const i = t[o],
                    s = r[o];
                s && i !== s && !(M(i) && i.includes(s)) && (t[o] = i ? [].concat(i, s) : s);
            } else o !== '' && (t[o] = r[o]);
    }
    return t;
}
function Ie(e, t, n, r = null) {
    Pe(e, t, 7, [n, r]);
}
const Jl = ns();
let Ql = 0;
function Zl(e, t, n) {
    const r = e.type,
        o = (t ? t.appContext : e.appContext) || Jl,
        i = {
            uid: Ql++,
            vnode: e,
            type: r,
            parent: t,
            appContext: o,
            root: null,
            // to be immediately set
            next: null,
            subTree: null,
            // will be set synchronously right after creation
            effect: null,
            update: null,
            // will be set synchronously right after creation
            scope: new Bs(
                !0
                /* detached */
            ),
            render: null,
            proxy: null,
            exposed: null,
            exposeProxy: null,
            withProxy: null,
            provides: t ? t.provides : Object.create(o.provides),
            accessCache: null,
            renderCache: [],
            // local resolved assets
            components: null,
            directives: null,
            // resolved props and emits options
            propsOptions: os(r, o),
            emitsOptions: Hi(r, o),
            // emit
            emit: null,
            // to be set immediately
            emitted: null,
            // props default value
            propsDefaults: Z,
            // inheritAttrs
            inheritAttrs: r.inheritAttrs,
            // state
            ctx: Z,
            data: Z,
            props: Z,
            attrs: Z,
            slots: Z,
            refs: Z,
            setupState: Z,
            setupContext: null,
            attrsProxy: null,
            slotsProxy: null,
            // suspense related
            suspense: n,
            suspenseId: n ? n.pendingId : 0,
            asyncDep: null,
            asyncResolved: !1,
            // lifecycle hooks
            // not using enums here because it results in computed properties
            isMounted: !1,
            isUnmounted: !1,
            isDeactivated: !1,
            bc: null,
            c: null,
            bm: null,
            m: null,
            bu: null,
            u: null,
            um: null,
            bum: null,
            da: null,
            a: null,
            rtg: null,
            rtc: null,
            ec: null,
            sp: null,
        };
    return (
        p.NODE_ENV !== 'production' ? (i.ctx = ml(i)) : (i.ctx = {_: i}),
        (i.root = t ? t.root : i),
        (i.emit = La.bind(null, i)),
        e.ce && e.ce(i),
        i
    );
}
let de = null,
    Ln,
    Ir;
{
    const e = Hr(),
        t = (n, r) => {
            let o;
            return (
                (o = e[n]) || (o = e[n] = []),
                o.push(r),
                (i) => {
                    o.length > 1 ? o.forEach((s) => s(i)) : o[0](i);
                }
            );
        };
    ((Ln = t('__VUE_INSTANCE_SETTERS__', (n) => (de = n))), (Ir = t('__VUE_SSR_SETTERS__', (n) => (Zn = n))));
}
const mn = (e) => {
        const t = de;
        return (
            Ln(e),
            e.scope.on(),
            () => {
                (e.scope.off(), Ln(t));
            }
        );
    },
    Ro = () => {
        (de && de.scope.off(), Ln(null));
    },
    eu = /* @__PURE__ */ Ke('slot,component');
function Ar(e, t) {
    const n = t.isNativeTag || ii;
    (eu(e) || n(e)) && w('Do not use built-in or reserved HTML elements as component id: ' + e);
}
function ms(e) {
    return e.vnode.shapeFlag & 4;
}
let Zn = !1;
function tu(e, t = !1) {
    t && Ir(t);
    const {props: n, children: r} = e.vnode,
        o = ms(e);
    (Cl(e, n, o, t), Al(e, r));
    const i = o ? nu(e, t) : void 0;
    return (t && Ir(!1), i);
}
function nu(e, t) {
    var n;
    const r = e.type;
    if (p.NODE_ENV !== 'production') {
        if ((r.name && Ar(r.name, e.appContext.config), r.components)) {
            const i = Object.keys(r.components);
            for (let s = 0; s < i.length; s++) Ar(i[s], e.appContext.config);
        }
        if (r.directives) {
            const i = Object.keys(r.directives);
            for (let s = 0; s < i.length; s++) zi(i[s]);
        }
        r.compilerOptions &&
            ru() &&
            w(
                '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
            );
    }
    ((e.accessCache = /* @__PURE__ */ Object.create(null)),
        (e.proxy = Ci(new Proxy(e.ctx, es))),
        p.NODE_ENV !== 'production' && gl(e));
    const {setup: o} = r;
    if (o) {
        const i = (e.setupContext = o.length > 1 ? iu(e) : null),
            s = mn(e);
        ft();
        const a = qe(o, e, 0, [p.NODE_ENV !== 'production' ? Ft(e.props) : e.props, i]);
        if ((dt(), s(), Lr(a))) {
            if ((a.then(Ro, Ro), t))
                return a
                    .then((u) => {
                        Wo(e, u, t);
                    })
                    .catch((u) => {
                        dn(u, e, 0);
                    });
            if (((e.asyncDep = a), p.NODE_ENV !== 'production' && !e.suspense)) {
                const u = (n = r.name) != null ? n : 'Anonymous';
                w(
                    `Component <${u}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
                );
            }
        } else Wo(e, a, t);
    } else gs(e, t);
}
function Wo(e, t, n) {
    (S(t)
        ? e.type.__ssrInlineRender
            ? (e.ssrRender = t)
            : (e.render = t)
        : ee(t)
          ? (p.NODE_ENV !== 'production' &&
                Jn(t) &&
                w('setup() should not return VNodes directly - return a render function instead.'),
            p.NODE_ENV !== 'production' && (e.devtoolsRawSetupState = t),
            (e.setupState = Pi(t)),
            p.NODE_ENV !== 'production' && vl(e))
          : p.NODE_ENV !== 'production' &&
            t !== void 0 &&
            w(`setup() should return an object. Received: ${t === null ? 'null' : typeof t}`),
        gs(e, n));
}
let Fr;
const ru = () => !Fr;
function gs(e, t, n) {
    const r = e.type;
    if (!e.render) {
        if (!t && Fr && !r.render) {
            const o = r.template || ro(e).template;
            if (o) {
                p.NODE_ENV !== 'production' && Ge(e, 'compile');
                const {isCustomElement: i, compilerOptions: s} = e.appContext.config,
                    {delimiters: a, compilerOptions: u} = r,
                    d = se(
                        se(
                            {
                                isCustomElement: i,
                                delimiters: a,
                            },
                            s
                        ),
                        u
                    );
                ((r.render = Fr(o, d)), p.NODE_ENV !== 'production' && Be(e, 'compile'));
            }
        }
        e.render = r.render || ae;
    }
    {
        const o = mn(e);
        ft();
        try {
            yl(e);
        } finally {
            (dt(), o());
        }
    }
    p.NODE_ENV !== 'production' &&
        !r.render &&
        e.render === ae &&
        !t &&
        (r.template
            ? w(
                  'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
              )
            : w('Component is missing template or render function.'));
}
function Lo(e) {
    return (
        e.attrsProxy ||
        (e.attrsProxy = new Proxy(
            e.attrs,
            p.NODE_ENV !== 'production'
                ? {
                      get(t, n) {
                          return (An(), me(e, 'get', '$attrs'), t[n]);
                      },
                      set() {
                          return (w('setupContext.attrs is readonly.'), !1);
                      },
                      deleteProperty() {
                          return (w('setupContext.attrs is readonly.'), !1);
                      },
                  }
                : {
                      get(t, n) {
                          return (me(e, 'get', '$attrs'), t[n]);
                      },
                  }
        ))
    );
}
function ou(e) {
    return (
        e.slotsProxy ||
        (e.slotsProxy = new Proxy(e.slots, {
            get(t, n) {
                return (me(e, 'get', '$slots'), t[n]);
            },
        }))
    );
}
function iu(e) {
    const t = (n) => {
        if (
            p.NODE_ENV !== 'production' &&
            (e.exposed && w('expose() should be called only once per setup().'), n != null)
        ) {
            let r = typeof n;
            (r === 'object' && (M(n) ? (r = 'array') : ge(n) && (r = 'ref')),
                r !== 'object' && w(`expose() should be passed a plain object, received ${r}.`));
        }
        e.exposed = n || {};
    };
    return p.NODE_ENV !== 'production'
        ? Object.freeze({
              get attrs() {
                  return Lo(e);
              },
              get slots() {
                  return ou(e);
              },
              get emit() {
                  return (n, ...r) => e.emit(n, ...r);
              },
              expose: t,
          })
        : {
              get attrs() {
                  return Lo(e);
              },
              slots: e.slots,
              emit: e.emit,
              expose: t,
          };
}
function er(e) {
    if (e.exposed)
        return (
            e.exposeProxy ||
            (e.exposeProxy = new Proxy(Pi(Ci(e.exposed)), {
                get(t, n) {
                    if (n in t) return t[n];
                    if (n in Ot) return Ot[n](e);
                },
                has(t, n) {
                    return n in t || n in Ot;
                },
            }))
        );
}
const su = /(?:^|[-_])(\w)/g,
    au = (e) => e.replace(su, (t) => t.toUpperCase()).replace(/[-_]/g, '');
function so(e, t = !0) {
    return S(e) ? e.displayName || e.name : e.name || (t && e.__name);
}
function tr(e, t, n = !1) {
    let r = so(t);
    if (!r && t.__file) {
        const o = t.__file.match(/([^/\\]+)\.\w+$/);
        o && (r = o[1]);
    }
    if (!r && e && e.parent) {
        const o = (i) => {
            for (const s in i) if (i[s] === t) return s;
        };
        r = o(e.components || e.parent.type.components) || o(e.appContext.components);
    }
    return r ? au(r) : n ? 'App' : 'Anonymous';
}
function vs(e) {
    return S(e) && '__vccOpts' in e;
}
const Tt = (e, t) => ha(e, t, Zn);
function mr(e) {
    return !!(e && e.__v_isShallow);
}
function lu() {
    if (p.NODE_ENV === 'production' || typeof window > 'u') return;
    const e = {style: 'color:#3ba776'},
        t = {style: 'color:#1677ff'},
        n = {style: 'color:#f5222d'},
        r = {style: 'color:#eb2f96'},
        o = {
            header(c) {
                return ee(c)
                    ? c.__isVue
                        ? ['div', e, 'VueInstance']
                        : ge(c)
                          ? ['div', {}, ['span', e, h(c)], '<', a(c.value), '>']
                          : Et(c)
                            ? [
                                  'div',
                                  {},
                                  ['span', e, mr(c) ? 'ShallowReactive' : 'Reactive'],
                                  '<',
                                  a(c),
                                  `>${lt(c) ? ' (readonly)' : ''}`,
                              ]
                            : lt(c)
                              ? ['div', {}, ['span', e, mr(c) ? 'ShallowReadonly' : 'Readonly'], '<', a(c), '>']
                              : null
                    : null;
            },
            hasBody(c) {
                return c && c.__isVue;
            },
            body(c) {
                if (c && c.__isVue) return ['div', {}, ...i(c.$)];
            },
        };
    function i(c) {
        const m = [];
        (c.type.props && c.props && m.push(s('props', R(c.props))),
            c.setupState !== Z && m.push(s('setup', c.setupState)),
            c.data !== Z && m.push(s('data', R(c.data))));
        const N = u(c, 'computed');
        N && m.push(s('computed', N));
        const T = u(c, 'inject');
        return (
            T && m.push(s('injected', T)),
            m.push([
                'div',
                {},
                [
                    'span',
                    {
                        style: r.style + ';opacity:0.66',
                    },
                    '$ (internal): ',
                ],
                ['object', {object: c}],
            ]),
            m
        );
    }
    function s(c, m) {
        return (
            (m = se({}, m)),
            Object.keys(m).length
                ? [
                      'div',
                      {style: 'line-height:1.25em;margin-bottom:0.6em'},
                      [
                          'div',
                          {
                              style: 'color:#476582',
                          },
                          c,
                      ],
                      [
                          'div',
                          {
                              style: 'padding-left:1.25em',
                          },
                          ...Object.keys(m).map((N) => ['div', {}, ['span', r, N + ': '], a(m[N], !1)]),
                      ],
                  ]
                : ['span', {}]
        );
    }
    function a(c, m = !0) {
        return typeof c == 'number'
            ? ['span', t, c]
            : typeof c == 'string'
              ? ['span', n, JSON.stringify(c)]
              : typeof c == 'boolean'
                ? ['span', r, c]
                : ee(c)
                  ? ['object', {object: m ? R(c) : c}]
                  : ['span', n, String(c)];
    }
    function u(c, m) {
        const N = c.type;
        if (S(N)) return;
        const T = {};
        for (const P in c.ctx) d(N, P, m) && (T[P] = c.ctx[P]);
        return T;
    }
    function d(c, m, N) {
        const T = c[N];
        if (
            (M(T) && T.includes(m)) ||
            (ee(T) && m in T) ||
            (c.extends && d(c.extends, m, N)) ||
            (c.mixins && c.mixins.some((P) => d(P, m, N)))
        )
            return !0;
    }
    function h(c) {
        return mr(c) ? 'ShallowRef' : c.effect ? 'ComputedRef' : 'Ref';
    }
    window.devtoolsFormatters ? window.devtoolsFormatters.push(o) : (window.devtoolsFormatters = [o]);
}
const Uo = '3.4.15',
    Dt = p.NODE_ENV !== 'production' ? w : ae;
var Ht = {};
const uu = 'http://www.w3.org/2000/svg',
    cu = 'http://www.w3.org/1998/Math/MathML',
    nt = typeof document < 'u' ? document : null,
    jo = nt && /* @__PURE__ */ nt.createElement('template'),
    fu = {
        insert: (e, t, n) => {
            t.insertBefore(e, n || null);
        },
        remove: (e) => {
            const t = e.parentNode;
            t && t.removeChild(e);
        },
        createElement: (e, t, n, r) => {
            const o =
                t === 'svg'
                    ? nt.createElementNS(uu, e)
                    : t === 'mathml'
                      ? nt.createElementNS(cu, e)
                      : nt.createElement(e, n ? {is: n} : void 0);
            return (e === 'select' && r && r.multiple != null && o.setAttribute('multiple', r.multiple), o);
        },
        createText: (e) => nt.createTextNode(e),
        createComment: (e) => nt.createComment(e),
        setText: (e, t) => {
            e.nodeValue = t;
        },
        setElementText: (e, t) => {
            e.textContent = t;
        },
        parentNode: (e) => e.parentNode,
        nextSibling: (e) => e.nextSibling,
        querySelector: (e) => nt.querySelector(e),
        setScopeId(e, t) {
            e.setAttribute(t, '');
        },
        // __UNSAFE__
        // Reason: innerHTML.
        // Static content here can only come from compiled templates.
        // As long as the user only uses trusted templates, this is safe.
        insertStaticContent(e, t, n, r, o, i) {
            const s = n ? n.previousSibling : t.lastChild;
            if (o && (o === i || o.nextSibling))
                for (; t.insertBefore(o.cloneNode(!0), n), !(o === i || !(o = o.nextSibling)););
            else {
                jo.innerHTML = r === 'svg' ? `<svg>${e}</svg>` : r === 'mathml' ? `<math>${e}</math>` : e;
                const a = jo.content;
                if (r === 'svg' || r === 'mathml') {
                    const u = a.firstChild;
                    for (; u.firstChild;) a.appendChild(u.firstChild);
                    a.removeChild(u);
                }
                t.insertBefore(a, n);
            }
            return [
                // first
                s ? s.nextSibling : t.firstChild,
                // last
                n ? n.previousSibling : t.lastChild,
            ];
        },
    },
    du = Symbol('_vtc');
function pu(e, t, n) {
    const r = e[du];
    (r && (t = (t ? [t, ...r] : [...r]).join(' ')),
        t == null ? e.removeAttribute('class') : n ? e.setAttribute('class', t) : (e.className = t));
}
const hu = Symbol('_vod'),
    mu = Symbol(Ht.NODE_ENV !== 'production' ? 'CSS_VAR_TEXT' : '');
function gu(e, t, n) {
    const r = e.style,
        o = r.display,
        i = re(n);
    if (n && !i) {
        if (t && !re(t)) for (const s in t) n[s] == null && Rr(r, s, '');
        for (const s in n) Rr(r, s, n[s]);
    } else if (i) {
        if (t !== n) {
            const s = r[mu];
            (s && (n += ';' + s), (r.cssText = n));
        }
    } else t && e.removeAttribute('style');
    hu in e && (r.display = o);
}
const vu = /[^\\];\s*$/,
    Ho = /\s*!important$/;
function Rr(e, t, n) {
    if (M(n)) n.forEach((r) => Rr(e, t, r));
    else if (
        (n == null && (n = ''),
        Ht.NODE_ENV !== 'production' &&
            vu.test(n) &&
            Dt(`Unexpected semicolon at the end of '${t}' style value: '${n}'`),
        t.startsWith('--'))
    )
        e.setProperty(t, n);
    else {
        const r = _u(e, t);
        Ho.test(n) ? e.setProperty(st(r), n.replace(Ho, ''), 'important') : (e[r] = n);
    }
}
const Go = ['Webkit', 'Moz', 'ms'],
    gr = {};
function _u(e, t) {
    const n = gr[t];
    if (n) return n;
    let r = Ue(t);
    if (r !== 'filter' && r in e) return (gr[t] = r);
    r = $t(r);
    for (let o = 0; o < Go.length; o++) {
        const i = Go[o] + r;
        if (i in e) return (gr[t] = i);
    }
    return t;
}
const Bo = 'http://www.w3.org/1999/xlink';
function yu(e, t, n, r, o) {
    if (r && t.startsWith('xlink:'))
        n == null ? e.removeAttributeNS(Bo, t.slice(6, t.length)) : e.setAttributeNS(Bo, t, n);
    else {
        const i = Gs(t);
        n == null || (i && !ui(n)) ? e.removeAttribute(t) : e.setAttribute(t, i ? '' : n);
    }
}
function bu(e, t, n, r, o, i, s) {
    if (t === 'innerHTML' || t === 'textContent') {
        (r && s(r, o, i), (e[t] = n ?? ''));
        return;
    }
    const a = e.tagName;
    if (
        t === 'value' &&
        a !== 'PROGRESS' && // custom elements may use _value internally
        !a.includes('-')
    ) {
        e._value = n;
        const d = a === 'OPTION' ? e.getAttribute('value') : e.value,
            h = n ?? '';
        (d !== h && (e.value = h), n == null && e.removeAttribute(t));
        return;
    }
    let u = !1;
    if (n === '' || n == null) {
        const d = typeof e[t];
        d === 'boolean'
            ? (n = ui(n))
            : n == null && d === 'string'
              ? ((n = ''), (u = !0))
              : d === 'number' && ((n = 0), (u = !0));
    }
    try {
        e[t] = n;
    } catch (d) {
        Ht.NODE_ENV !== 'production' &&
            !u &&
            Dt(`Failed setting prop "${t}" on <${a.toLowerCase()}>: value ${n} is invalid.`, d);
    }
    u && e.removeAttribute(t);
}
function wu(e, t, n, r) {
    e.addEventListener(t, n, r);
}
function Eu(e, t, n, r) {
    e.removeEventListener(t, n, r);
}
const Yo = Symbol('_vei');
function Nu(e, t, n, r, o = null) {
    const i = e[Yo] || (e[Yo] = {}),
        s = i[t];
    if (r && s) s.value = r;
    else {
        const [a, u] = Ou(t);
        if (r) {
            const d = (i[t] = Cu(r, o));
            wu(e, a, d, u);
        } else s && (Eu(e, a, s, u), (i[t] = void 0));
    }
}
const qo = /(?:Once|Passive|Capture)$/;
function Ou(e) {
    let t;
    if (qo.test(e)) {
        t = {};
        let r;
        for (; (r = e.match(qo));) ((e = e.slice(0, e.length - r[0].length)), (t[r[0].toLowerCase()] = !0));
    }
    return [e[2] === ':' ? e.slice(3) : st(e.slice(2)), t];
}
let vr = 0;
const Du = /* @__PURE__ */ Promise.resolve(),
    $u = () => vr || (Du.then(() => (vr = 0)), (vr = Date.now()));
function Cu(e, t) {
    const n = (r) => {
        if (!r._vts) r._vts = Date.now();
        else if (r._vts <= n.attached) return;
        Pe(Tu(r, n.value), t, 5, [r]);
    };
    return ((n.value = e), (n.attached = $u()), n);
}
function Tu(e, t) {
    if (M(t)) {
        const n = e.stopImmediatePropagation;
        return (
            (e.stopImmediatePropagation = () => {
                (n.call(e), (e._stopped = !0));
            }),
            t.map((r) => (o) => !o._stopped && r && r(o))
        );
    } else return t;
}
const Ko = (e) =>
        e.charCodeAt(0) === 111 &&
        e.charCodeAt(1) === 110 && // lowercase letter
        e.charCodeAt(2) > 96 &&
        e.charCodeAt(2) < 123,
    xu = (e, t, n, r, o, i, s, a, u) => {
        const d = o === 'svg';
        t === 'class'
            ? pu(e, r, d)
            : t === 'style'
              ? gu(e, n, r)
              : fn(t)
                ? Pn(t) || Nu(e, t, n, r, s)
                : (t[0] === '.' ? ((t = t.slice(1)), !0) : t[0] === '^' ? ((t = t.slice(1)), !1) : Vu(e, t, r, d))
                  ? bu(e, t, r, i, s, a, u)
                  : (t === 'true-value' ? (e._trueValue = r) : t === 'false-value' && (e._falseValue = r),
                    yu(e, t, r, d));
    };
function Vu(e, t, n, r) {
    if (r) return !!(t === 'innerHTML' || t === 'textContent' || (t in e && Ko(t) && S(n)));
    if (
        t === 'spellcheck' ||
        t === 'draggable' ||
        t === 'translate' ||
        t === 'form' ||
        (t === 'list' && e.tagName === 'INPUT') ||
        (t === 'type' && e.tagName === 'TEXTAREA')
    )
        return !1;
    if (t === 'width' || t === 'height') {
        const o = e.tagName;
        if (o === 'IMG' || o === 'VIDEO' || o === 'CANVAS' || o === 'SOURCE') return !1;
    }
    return Ko(t) && re(n) ? !1 : t in e;
}
const Mu = /* @__PURE__ */ se({patchProp: xu}, fu);
let Xo;
function Pu() {
    return Xo || (Xo = Wl(Mu));
}
const Su = (...e) => {
    const t = Pu().createApp(...e);
    Ht.NODE_ENV !== 'production' && (Iu(t), Au(t));
    const {mount: n} = t;
    return (
        (t.mount = (r) => {
            const o = Fu(r);
            if (!o) return;
            const i = t._component;
            (!S(i) && !i.render && !i.template && (i.template = o.innerHTML), (o.innerHTML = ''));
            const s = n(o, !1, ku(o));
            return (o instanceof Element && (o.removeAttribute('v-cloak'), o.setAttribute('data-v-app', '')), s);
        }),
        t
    );
};
function ku(e) {
    if (e instanceof SVGElement) return 'svg';
    if (typeof MathMLElement == 'function' && e instanceof MathMLElement) return 'mathml';
}
function Iu(e) {
    Object.defineProperty(e.config, 'isNativeTag', {
        value: (t) => Ls(t) || Us(t) || js(t),
        writable: !1,
    });
}
function Au(e) {
    {
        const t = e.config.isCustomElement;
        Object.defineProperty(e.config, 'isCustomElement', {
            get() {
                return t;
            },
            set() {
                Dt('The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.');
            },
        });
        const n = e.config.compilerOptions,
            r =
                'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
        Object.defineProperty(e.config, 'compilerOptions', {
            get() {
                return (Dt(r), n);
            },
            set() {
                Dt(r);
            },
        });
    }
}
function Fu(e) {
    if (re(e)) {
        const t = document.querySelector(e);
        return (
            Ht.NODE_ENV !== 'production' &&
                !t &&
                Dt(`Failed to mount app: mount target selector "${e}" returned null.`),
            t
        );
    }
    return (
        Ht.NODE_ENV !== 'production' &&
            window.ShadowRoot &&
            e instanceof window.ShadowRoot &&
            e.mode === 'closed' &&
            Dt('mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'),
        e
    );
}
var Ru = {};
function Wu() {
    lu();
}
Ru.NODE_ENV !== 'production' && Wu();
const $e = (e, t) => {
        const n = e.__vccOpts || e;
        for (const [r, o] of t) n[r] = o;
        return n;
    },
    Lu = {
        name: 'IPaginateNext',
    },
    Uu = {
        width: '24',
        height: '25',
        viewBox: '0 0 24 25',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    ju = /* @__PURE__ */ I(
        'path',
        {
            d: 'M10 7.22168L15 12.2217L10 17.2217',
            stroke: 'currentColor',
            'stroke-linecap': 'round',
        },
        null,
        -1
    ),
    Hu = [ju];
function Gu(e, t, n, r, o, i) {
    return (te(), fe('svg', Uu, Hu));
}
const _s = /* @__PURE__ */ $e(Lu, [['render', Gu]]),
    Bu = '_root_1s9hm_1',
    Yu = '_dark_1s9hm_12',
    qu = '_text_1s9hm_18',
    Ku = '_link_1s9hm_25',
    Xu = {
        root: Bu,
        dark: Yu,
        text: qu,
        link: Ku,
    },
    zu = /* @__PURE__ */ I('span', null, 'Подробнее', -1),
    Ju = {
        __name: 'BnplWidgetOne',
        props: {
            params: Object,
        },
        setup(e) {
            const t = e;
            return (n, r) => (
                te(),
                fe(
                    'div',
                    {
                        class: U([n.$style.root, t.params.isDarkTheme && n.$style.dark]),
                    },
                    [
                        I(
                            'span',
                            {
                                class: U(n.$style.text),
                            },
                            'давай делить',
                            2
                        ),
                        I(
                            'div',
                            {
                                class: U(n.$style.link),
                            },
                            [zu, pe(_s)],
                            2
                        ),
                    ],
                    2
                )
            );
        },
    },
    Qu = {
        $style: Xu,
    },
    Zu = /* @__PURE__ */ $e(Ju, [['__cssModules', Qu]]);
function Un(e) {
    '@babel/helpers - typeof';
    return (
        (Un =
            typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol'
                ? function (t) {
                      return typeof t;
                  }
                : function (t) {
                      return t && typeof Symbol == 'function' && t.constructor === Symbol && t !== Symbol.prototype
                          ? 'symbol'
                          : typeof t;
                  }),
        Un(e)
    );
}
function xt(e) {
    if (e === null || e === !0 || e === !1) return NaN;
    var t = Number(e);
    return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function _e(e, t) {
    if (t.length < e)
        throw new TypeError(e + ' argument' + (e > 1 ? 's' : '') + ' required, but only ' + t.length + ' present');
}
function je(e) {
    _e(1, arguments);
    var t = Object.prototype.toString.call(e);
    return e instanceof Date || (Un(e) === 'object' && t === '[object Date]')
        ? new Date(e.getTime())
        : typeof e == 'number' || t === '[object Number]'
          ? new Date(e)
          : ((typeof e == 'string' || t === '[object String]') &&
                typeof console < 'u' &&
                (console.warn(
                    "Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"
                ),
                console.warn(new Error().stack)),
            /* @__PURE__ */ new Date(NaN));
}
function ec(e, t) {
    _e(2, arguments);
    var n = je(e).getTime(),
        r = xt(t);
    return new Date(n + r);
}
var tc = {};
function nr() {
    return tc;
}
function nc(e) {
    var t = new Date(
        Date.UTC(
            e.getFullYear(),
            e.getMonth(),
            e.getDate(),
            e.getHours(),
            e.getMinutes(),
            e.getSeconds(),
            e.getMilliseconds()
        )
    );
    return (t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime());
}
function rc(e) {
    return (
        _e(1, arguments),
        e instanceof Date || (Un(e) === 'object' && Object.prototype.toString.call(e) === '[object Date]')
    );
}
function oc(e) {
    if ((_e(1, arguments), !rc(e) && typeof e != 'number')) return !1;
    var t = je(e);
    return !isNaN(Number(t));
}
function ic(e, t) {
    _e(2, arguments);
    var n = xt(t);
    return ec(e, -n);
}
var sc = 864e5;
function ac(e) {
    _e(1, arguments);
    var t = je(e),
        n = t.getTime();
    (t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0));
    var r = t.getTime(),
        o = n - r;
    return Math.floor(o / sc) + 1;
}
function jn(e) {
    _e(1, arguments);
    var t = 1,
        n = je(e),
        r = n.getUTCDay(),
        o = (r < t ? 7 : 0) + r - t;
    return (n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n);
}
function ys(e) {
    _e(1, arguments);
    var t = je(e),
        n = t.getUTCFullYear(),
        r = /* @__PURE__ */ new Date(0);
    (r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0));
    var o = jn(r),
        i = /* @__PURE__ */ new Date(0);
    (i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0));
    var s = jn(i);
    return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function lc(e) {
    _e(1, arguments);
    var t = ys(e),
        n = /* @__PURE__ */ new Date(0);
    (n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0));
    var r = jn(n);
    return r;
}
var uc = 6048e5;
function cc(e) {
    _e(1, arguments);
    var t = je(e),
        n = jn(t).getTime() - lc(t).getTime();
    return Math.round(n / uc) + 1;
}
function Gt(e, t) {
    var n, r, o, i, s, a, u, d;
    _e(1, arguments);
    var h = nr(),
        c = xt(
            (n =
                (r =
                    (o =
                        (i = t?.weekStartsOn) !== null && i !== void 0
                            ? i
                            : t == null ||
                                (s = t.locale) === null ||
                                s === void 0 ||
                                (a = s.options) === null ||
                                a === void 0
                              ? void 0
                              : a.weekStartsOn) !== null && o !== void 0
                        ? o
                        : h.weekStartsOn) !== null && r !== void 0
                    ? r
                    : (u = h.locale) === null || u === void 0 || (d = u.options) === null || d === void 0
                      ? void 0
                      : d.weekStartsOn) !== null && n !== void 0
                ? n
                : 0
        );
    if (!(c >= 0 && c <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var m = je(e),
        N = m.getUTCDay(),
        T = (N < c ? 7 : 0) + N - c;
    return (m.setUTCDate(m.getUTCDate() - T), m.setUTCHours(0, 0, 0, 0), m);
}
function bs(e, t) {
    var n, r, o, i, s, a, u, d;
    _e(1, arguments);
    var h = je(e),
        c = h.getUTCFullYear(),
        m = nr(),
        N = xt(
            (n =
                (r =
                    (o =
                        (i = t?.firstWeekContainsDate) !== null && i !== void 0
                            ? i
                            : t == null ||
                                (s = t.locale) === null ||
                                s === void 0 ||
                                (a = s.options) === null ||
                                a === void 0
                              ? void 0
                              : a.firstWeekContainsDate) !== null && o !== void 0
                        ? o
                        : m.firstWeekContainsDate) !== null && r !== void 0
                    ? r
                    : (u = m.locale) === null || u === void 0 || (d = u.options) === null || d === void 0
                      ? void 0
                      : d.firstWeekContainsDate) !== null && n !== void 0
                ? n
                : 1
        );
    if (!(N >= 1 && N <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var T = /* @__PURE__ */ new Date(0);
    (T.setUTCFullYear(c + 1, 0, N), T.setUTCHours(0, 0, 0, 0));
    var P = Gt(T, t),
        L = /* @__PURE__ */ new Date(0);
    (L.setUTCFullYear(c, 0, N), L.setUTCHours(0, 0, 0, 0));
    var X = Gt(L, t);
    return h.getTime() >= P.getTime() ? c + 1 : h.getTime() >= X.getTime() ? c : c - 1;
}
function fc(e, t) {
    var n, r, o, i, s, a, u, d;
    _e(1, arguments);
    var h = nr(),
        c = xt(
            (n =
                (r =
                    (o =
                        (i = t?.firstWeekContainsDate) !== null && i !== void 0
                            ? i
                            : t == null ||
                                (s = t.locale) === null ||
                                s === void 0 ||
                                (a = s.options) === null ||
                                a === void 0
                              ? void 0
                              : a.firstWeekContainsDate) !== null && o !== void 0
                        ? o
                        : h.firstWeekContainsDate) !== null && r !== void 0
                    ? r
                    : (u = h.locale) === null || u === void 0 || (d = u.options) === null || d === void 0
                      ? void 0
                      : d.firstWeekContainsDate) !== null && n !== void 0
                ? n
                : 1
        ),
        m = bs(e, t),
        N = /* @__PURE__ */ new Date(0);
    (N.setUTCFullYear(m, 0, c), N.setUTCHours(0, 0, 0, 0));
    var T = Gt(N, t);
    return T;
}
var dc = 6048e5;
function pc(e, t) {
    _e(1, arguments);
    var n = je(e),
        r = Gt(n, t).getTime() - fc(n, t).getTime();
    return Math.round(r / dc) + 1;
}
function J(e, t) {
    for (var n = e < 0 ? '-' : '', r = Math.abs(e).toString(); r.length < t;) r = '0' + r;
    return n + r;
}
var hc = {
    // Year
    y: function (t, n) {
        var r = t.getUTCFullYear(),
            o = r > 0 ? r : 1 - r;
        return J(n === 'yy' ? o % 100 : o, n.length);
    },
    // Month
    M: function (t, n) {
        var r = t.getUTCMonth();
        return n === 'M' ? String(r + 1) : J(r + 1, 2);
    },
    // Day of the month
    d: function (t, n) {
        return J(t.getUTCDate(), n.length);
    },
    // AM or PM
    a: function (t, n) {
        var r = t.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch (n) {
            case 'a':
            case 'aa':
                return r.toUpperCase();
            case 'aaa':
                return r;
            case 'aaaaa':
                return r[0];
            case 'aaaa':
            default:
                return r === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function (t, n) {
        return J(t.getUTCHours() % 12 || 12, n.length);
    },
    // Hour [0-23]
    H: function (t, n) {
        return J(t.getUTCHours(), n.length);
    },
    // Minute
    m: function (t, n) {
        return J(t.getUTCMinutes(), n.length);
    },
    // Second
    s: function (t, n) {
        return J(t.getUTCSeconds(), n.length);
    },
    // Fraction of second
    S: function (t, n) {
        var r = n.length,
            o = t.getUTCMilliseconds(),
            i = Math.floor(o * Math.pow(10, r - 3));
        return J(i, n.length);
    },
};
const Qe = hc;
var kt = {
        am: 'am',
        pm: 'pm',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night',
    },
    mc = {
        // Era
        G: function (t, n, r) {
            var o = t.getUTCFullYear() > 0 ? 1 : 0;
            switch (n) {
                case 'G':
                case 'GG':
                case 'GGG':
                    return r.era(o, {
                        width: 'abbreviated',
                    });
                case 'GGGGG':
                    return r.era(o, {
                        width: 'narrow',
                    });
                case 'GGGG':
                default:
                    return r.era(o, {
                        width: 'wide',
                    });
            }
        },
        // Year
        y: function (t, n, r) {
            if (n === 'yo') {
                var o = t.getUTCFullYear(),
                    i = o > 0 ? o : 1 - o;
                return r.ordinalNumber(i, {
                    unit: 'year',
                });
            }
            return Qe.y(t, n);
        },
        // Local week-numbering year
        Y: function (t, n, r, o) {
            var i = bs(t, o),
                s = i > 0 ? i : 1 - i;
            if (n === 'YY') {
                var a = s % 100;
                return J(a, 2);
            }
            return n === 'Yo'
                ? r.ordinalNumber(s, {
                      unit: 'year',
                  })
                : J(s, n.length);
        },
        // ISO week-numbering year
        R: function (t, n) {
            var r = ys(t);
            return J(r, n.length);
        },
        // Extended year. This is a single number designating the year of this calendar system.
        // The main difference between `y` and `u` localizers are B.C. years:
        // | Year | `y` | `u` |
        // |------|-----|-----|
        // | AC 1 |   1 |   1 |
        // | BC 1 |   1 |   0 |
        // | BC 2 |   2 |  -1 |
        // Also `yy` always returns the last two digits of a year,
        // while `uu` pads single digit years to 2 characters and returns other years unchanged.
        u: function (t, n) {
            var r = t.getUTCFullYear();
            return J(r, n.length);
        },
        // Quarter
        Q: function (t, n, r) {
            var o = Math.ceil((t.getUTCMonth() + 1) / 3);
            switch (n) {
                case 'Q':
                    return String(o);
                case 'QQ':
                    return J(o, 2);
                case 'Qo':
                    return r.ordinalNumber(o, {
                        unit: 'quarter',
                    });
                case 'QQQ':
                    return r.quarter(o, {
                        width: 'abbreviated',
                        context: 'formatting',
                    });
                case 'QQQQQ':
                    return r.quarter(o, {
                        width: 'narrow',
                        context: 'formatting',
                    });
                case 'QQQQ':
                default:
                    return r.quarter(o, {
                        width: 'wide',
                        context: 'formatting',
                    });
            }
        },
        // Stand-alone quarter
        q: function (t, n, r) {
            var o = Math.ceil((t.getUTCMonth() + 1) / 3);
            switch (n) {
                case 'q':
                    return String(o);
                case 'qq':
                    return J(o, 2);
                case 'qo':
                    return r.ordinalNumber(o, {
                        unit: 'quarter',
                    });
                case 'qqq':
                    return r.quarter(o, {
                        width: 'abbreviated',
                        context: 'standalone',
                    });
                case 'qqqqq':
                    return r.quarter(o, {
                        width: 'narrow',
                        context: 'standalone',
                    });
                case 'qqqq':
                default:
                    return r.quarter(o, {
                        width: 'wide',
                        context: 'standalone',
                    });
            }
        },
        // Month
        M: function (t, n, r) {
            var o = t.getUTCMonth();
            switch (n) {
                case 'M':
                case 'MM':
                    return Qe.M(t, n);
                case 'Mo':
                    return r.ordinalNumber(o + 1, {
                        unit: 'month',
                    });
                case 'MMM':
                    return r.month(o, {
                        width: 'abbreviated',
                        context: 'formatting',
                    });
                case 'MMMMM':
                    return r.month(o, {
                        width: 'narrow',
                        context: 'formatting',
                    });
                case 'MMMM':
                default:
                    return r.month(o, {
                        width: 'wide',
                        context: 'formatting',
                    });
            }
        },
        // Stand-alone month
        L: function (t, n, r) {
            var o = t.getUTCMonth();
            switch (n) {
                case 'L':
                    return String(o + 1);
                case 'LL':
                    return J(o + 1, 2);
                case 'Lo':
                    return r.ordinalNumber(o + 1, {
                        unit: 'month',
                    });
                case 'LLL':
                    return r.month(o, {
                        width: 'abbreviated',
                        context: 'standalone',
                    });
                case 'LLLLL':
                    return r.month(o, {
                        width: 'narrow',
                        context: 'standalone',
                    });
                case 'LLLL':
                default:
                    return r.month(o, {
                        width: 'wide',
                        context: 'standalone',
                    });
            }
        },
        // Local week of year
        w: function (t, n, r, o) {
            var i = pc(t, o);
            return n === 'wo'
                ? r.ordinalNumber(i, {
                      unit: 'week',
                  })
                : J(i, n.length);
        },
        // ISO week of year
        I: function (t, n, r) {
            var o = cc(t);
            return n === 'Io'
                ? r.ordinalNumber(o, {
                      unit: 'week',
                  })
                : J(o, n.length);
        },
        // Day of the month
        d: function (t, n, r) {
            return n === 'do'
                ? r.ordinalNumber(t.getUTCDate(), {
                      unit: 'date',
                  })
                : Qe.d(t, n);
        },
        // Day of year
        D: function (t, n, r) {
            var o = ac(t);
            return n === 'Do'
                ? r.ordinalNumber(o, {
                      unit: 'dayOfYear',
                  })
                : J(o, n.length);
        },
        // Day of week
        E: function (t, n, r) {
            var o = t.getUTCDay();
            switch (n) {
                case 'E':
                case 'EE':
                case 'EEE':
                    return r.day(o, {
                        width: 'abbreviated',
                        context: 'formatting',
                    });
                case 'EEEEE':
                    return r.day(o, {
                        width: 'narrow',
                        context: 'formatting',
                    });
                case 'EEEEEE':
                    return r.day(o, {
                        width: 'short',
                        context: 'formatting',
                    });
                case 'EEEE':
                default:
                    return r.day(o, {
                        width: 'wide',
                        context: 'formatting',
                    });
            }
        },
        // Local day of week
        e: function (t, n, r, o) {
            var i = t.getUTCDay(),
                s = (i - o.weekStartsOn + 8) % 7 || 7;
            switch (n) {
                case 'e':
                    return String(s);
                case 'ee':
                    return J(s, 2);
                case 'eo':
                    return r.ordinalNumber(s, {
                        unit: 'day',
                    });
                case 'eee':
                    return r.day(i, {
                        width: 'abbreviated',
                        context: 'formatting',
                    });
                case 'eeeee':
                    return r.day(i, {
                        width: 'narrow',
                        context: 'formatting',
                    });
                case 'eeeeee':
                    return r.day(i, {
                        width: 'short',
                        context: 'formatting',
                    });
                case 'eeee':
                default:
                    return r.day(i, {
                        width: 'wide',
                        context: 'formatting',
                    });
            }
        },
        // Stand-alone local day of week
        c: function (t, n, r, o) {
            var i = t.getUTCDay(),
                s = (i - o.weekStartsOn + 8) % 7 || 7;
            switch (n) {
                case 'c':
                    return String(s);
                case 'cc':
                    return J(s, n.length);
                case 'co':
                    return r.ordinalNumber(s, {
                        unit: 'day',
                    });
                case 'ccc':
                    return r.day(i, {
                        width: 'abbreviated',
                        context: 'standalone',
                    });
                case 'ccccc':
                    return r.day(i, {
                        width: 'narrow',
                        context: 'standalone',
                    });
                case 'cccccc':
                    return r.day(i, {
                        width: 'short',
                        context: 'standalone',
                    });
                case 'cccc':
                default:
                    return r.day(i, {
                        width: 'wide',
                        context: 'standalone',
                    });
            }
        },
        // ISO day of week
        i: function (t, n, r) {
            var o = t.getUTCDay(),
                i = o === 0 ? 7 : o;
            switch (n) {
                case 'i':
                    return String(i);
                case 'ii':
                    return J(i, n.length);
                case 'io':
                    return r.ordinalNumber(i, {
                        unit: 'day',
                    });
                case 'iii':
                    return r.day(o, {
                        width: 'abbreviated',
                        context: 'formatting',
                    });
                case 'iiiii':
                    return r.day(o, {
                        width: 'narrow',
                        context: 'formatting',
                    });
                case 'iiiiii':
                    return r.day(o, {
                        width: 'short',
                        context: 'formatting',
                    });
                case 'iiii':
                default:
                    return r.day(o, {
                        width: 'wide',
                        context: 'formatting',
                    });
            }
        },
        // AM or PM
        a: function (t, n, r) {
            var o = t.getUTCHours(),
                i = o / 12 >= 1 ? 'pm' : 'am';
            switch (n) {
                case 'a':
                case 'aa':
                    return r.dayPeriod(i, {
                        width: 'abbreviated',
                        context: 'formatting',
                    });
                case 'aaa':
                    return r
                        .dayPeriod(i, {
                            width: 'abbreviated',
                            context: 'formatting',
                        })
                        .toLowerCase();
                case 'aaaaa':
                    return r.dayPeriod(i, {
                        width: 'narrow',
                        context: 'formatting',
                    });
                case 'aaaa':
                default:
                    return r.dayPeriod(i, {
                        width: 'wide',
                        context: 'formatting',
                    });
            }
        },
        // AM, PM, midnight, noon
        b: function (t, n, r) {
            var o = t.getUTCHours(),
                i;
            switch ((o === 12 ? (i = kt.noon) : o === 0 ? (i = kt.midnight) : (i = o / 12 >= 1 ? 'pm' : 'am'), n)) {
                case 'b':
                case 'bb':
                    return r.dayPeriod(i, {
                        width: 'abbreviated',
                        context: 'formatting',
                    });
                case 'bbb':
                    return r
                        .dayPeriod(i, {
                            width: 'abbreviated',
                            context: 'formatting',
                        })
                        .toLowerCase();
                case 'bbbbb':
                    return r.dayPeriod(i, {
                        width: 'narrow',
                        context: 'formatting',
                    });
                case 'bbbb':
                default:
                    return r.dayPeriod(i, {
                        width: 'wide',
                        context: 'formatting',
                    });
            }
        },
        // in the morning, in the afternoon, in the evening, at night
        B: function (t, n, r) {
            var o = t.getUTCHours(),
                i;
            switch (
                (o >= 17 ? (i = kt.evening) : o >= 12 ? (i = kt.afternoon) : o >= 4 ? (i = kt.morning) : (i = kt.night),
                n)
            ) {
                case 'B':
                case 'BB':
                case 'BBB':
                    return r.dayPeriod(i, {
                        width: 'abbreviated',
                        context: 'formatting',
                    });
                case 'BBBBB':
                    return r.dayPeriod(i, {
                        width: 'narrow',
                        context: 'formatting',
                    });
                case 'BBBB':
                default:
                    return r.dayPeriod(i, {
                        width: 'wide',
                        context: 'formatting',
                    });
            }
        },
        // Hour [1-12]
        h: function (t, n, r) {
            if (n === 'ho') {
                var o = t.getUTCHours() % 12;
                return (
                    o === 0 && (o = 12),
                    r.ordinalNumber(o, {
                        unit: 'hour',
                    })
                );
            }
            return Qe.h(t, n);
        },
        // Hour [0-23]
        H: function (t, n, r) {
            return n === 'Ho'
                ? r.ordinalNumber(t.getUTCHours(), {
                      unit: 'hour',
                  })
                : Qe.H(t, n);
        },
        // Hour [0-11]
        K: function (t, n, r) {
            var o = t.getUTCHours() % 12;
            return n === 'Ko'
                ? r.ordinalNumber(o, {
                      unit: 'hour',
                  })
                : J(o, n.length);
        },
        // Hour [1-24]
        k: function (t, n, r) {
            var o = t.getUTCHours();
            return (
                o === 0 && (o = 24),
                n === 'ko'
                    ? r.ordinalNumber(o, {
                          unit: 'hour',
                      })
                    : J(o, n.length)
            );
        },
        // Minute
        m: function (t, n, r) {
            return n === 'mo'
                ? r.ordinalNumber(t.getUTCMinutes(), {
                      unit: 'minute',
                  })
                : Qe.m(t, n);
        },
        // Second
        s: function (t, n, r) {
            return n === 'so'
                ? r.ordinalNumber(t.getUTCSeconds(), {
                      unit: 'second',
                  })
                : Qe.s(t, n);
        },
        // Fraction of second
        S: function (t, n) {
            return Qe.S(t, n);
        },
        // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
        X: function (t, n, r, o) {
            var i = o._originalDate || t,
                s = i.getTimezoneOffset();
            if (s === 0) return 'Z';
            switch (n) {
                case 'X':
                    return Jo(s);
                case 'XXXX':
                case 'XX':
                    return gt(s);
                case 'XXXXX':
                case 'XXX':
                default:
                    return gt(s, ':');
            }
        },
        // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
        x: function (t, n, r, o) {
            var i = o._originalDate || t,
                s = i.getTimezoneOffset();
            switch (n) {
                case 'x':
                    return Jo(s);
                case 'xxxx':
                case 'xx':
                    return gt(s);
                case 'xxxxx':
                case 'xxx':
                default:
                    return gt(s, ':');
            }
        },
        // Timezone (GMT)
        O: function (t, n, r, o) {
            var i = o._originalDate || t,
                s = i.getTimezoneOffset();
            switch (n) {
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + zo(s, ':');
                case 'OOOO':
                default:
                    return 'GMT' + gt(s, ':');
            }
        },
        // Timezone (specific non-location)
        z: function (t, n, r, o) {
            var i = o._originalDate || t,
                s = i.getTimezoneOffset();
            switch (n) {
                case 'z':
                case 'zz':
                case 'zzz':
                    return 'GMT' + zo(s, ':');
                case 'zzzz':
                default:
                    return 'GMT' + gt(s, ':');
            }
        },
        // Seconds timestamp
        t: function (t, n, r, o) {
            var i = o._originalDate || t,
                s = Math.floor(i.getTime() / 1e3);
            return J(s, n.length);
        },
        // Milliseconds timestamp
        T: function (t, n, r, o) {
            var i = o._originalDate || t,
                s = i.getTime();
            return J(s, n.length);
        },
    };
function zo(e, t) {
    var n = e > 0 ? '-' : '+',
        r = Math.abs(e),
        o = Math.floor(r / 60),
        i = r % 60;
    if (i === 0) return n + String(o);
    var s = t || '';
    return n + String(o) + s + J(i, 2);
}
function Jo(e, t) {
    if (e % 60 === 0) {
        var n = e > 0 ? '-' : '+';
        return n + J(Math.abs(e) / 60, 2);
    }
    return gt(e, t);
}
function gt(e, t) {
    var n = t || '',
        r = e > 0 ? '-' : '+',
        o = Math.abs(e),
        i = J(Math.floor(o / 60), 2),
        s = J(o % 60, 2);
    return r + i + n + s;
}
var Qo = function (t, n) {
        switch (t) {
            case 'P':
                return n.date({
                    width: 'short',
                });
            case 'PP':
                return n.date({
                    width: 'medium',
                });
            case 'PPP':
                return n.date({
                    width: 'long',
                });
            case 'PPPP':
            default:
                return n.date({
                    width: 'full',
                });
        }
    },
    ws = function (t, n) {
        switch (t) {
            case 'p':
                return n.time({
                    width: 'short',
                });
            case 'pp':
                return n.time({
                    width: 'medium',
                });
            case 'ppp':
                return n.time({
                    width: 'long',
                });
            case 'pppp':
            default:
                return n.time({
                    width: 'full',
                });
        }
    },
    gc = function (t, n) {
        var r = t.match(/(P+)(p+)?/) || [],
            o = r[1],
            i = r[2];
        if (!i) return Qo(t, n);
        var s;
        switch (o) {
            case 'P':
                s = n.dateTime({
                    width: 'short',
                });
                break;
            case 'PP':
                s = n.dateTime({
                    width: 'medium',
                });
                break;
            case 'PPP':
                s = n.dateTime({
                    width: 'long',
                });
                break;
            case 'PPPP':
            default:
                s = n.dateTime({
                    width: 'full',
                });
                break;
        }
        return s.replace('{{date}}', Qo(o, n)).replace('{{time}}', ws(i, n));
    },
    vc = {
        p: ws,
        P: gc,
    },
    _c = ['D', 'DD'],
    yc = ['YY', 'YYYY'];
function bc(e) {
    return _c.indexOf(e) !== -1;
}
function wc(e) {
    return yc.indexOf(e) !== -1;
}
function Zo(e, t, n) {
    if (e === 'YYYY')
        throw new RangeError(
            'Use `yyyy` instead of `YYYY` (in `'
                .concat(t, '`) for formatting years to the input `')
                .concat(n, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md')
        );
    if (e === 'YY')
        throw new RangeError(
            'Use `yy` instead of `YY` (in `'
                .concat(t, '`) for formatting years to the input `')
                .concat(n, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md')
        );
    if (e === 'D')
        throw new RangeError(
            'Use `d` instead of `D` (in `'
                .concat(t, '`) for formatting days of the month to the input `')
                .concat(n, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md')
        );
    if (e === 'DD')
        throw new RangeError(
            'Use `dd` instead of `DD` (in `'
                .concat(t, '`) for formatting days of the month to the input `')
                .concat(n, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md')
        );
}
var Ec = {
        lessThanXSeconds: {
            one: 'less than a second',
            other: 'less than {{count}} seconds',
        },
        xSeconds: {
            one: '1 second',
            other: '{{count}} seconds',
        },
        halfAMinute: 'half a minute',
        lessThanXMinutes: {
            one: 'less than a minute',
            other: 'less than {{count}} minutes',
        },
        xMinutes: {
            one: '1 minute',
            other: '{{count}} minutes',
        },
        aboutXHours: {
            one: 'about 1 hour',
            other: 'about {{count}} hours',
        },
        xHours: {
            one: '1 hour',
            other: '{{count}} hours',
        },
        xDays: {
            one: '1 day',
            other: '{{count}} days',
        },
        aboutXWeeks: {
            one: 'about 1 week',
            other: 'about {{count}} weeks',
        },
        xWeeks: {
            one: '1 week',
            other: '{{count}} weeks',
        },
        aboutXMonths: {
            one: 'about 1 month',
            other: 'about {{count}} months',
        },
        xMonths: {
            one: '1 month',
            other: '{{count}} months',
        },
        aboutXYears: {
            one: 'about 1 year',
            other: 'about {{count}} years',
        },
        xYears: {
            one: '1 year',
            other: '{{count}} years',
        },
        overXYears: {
            one: 'over 1 year',
            other: 'over {{count}} years',
        },
        almostXYears: {
            one: 'almost 1 year',
            other: 'almost {{count}} years',
        },
    },
    Nc = function (t, n, r) {
        var o,
            i = Ec[t];
        return (
            typeof i == 'string' ? (o = i) : n === 1 ? (o = i.one) : (o = i.other.replace('{{count}}', n.toString())),
            r != null && r.addSuffix ? (r.comparison && r.comparison > 0 ? 'in ' + o : o + ' ago') : o
        );
    };
const Oc = Nc;
function Ut(e) {
    return function () {
        var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
            n = t.width ? String(t.width) : e.defaultWidth,
            r = e.formats[n] || e.formats[e.defaultWidth];
        return r;
    };
}
var Dc = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy',
    },
    $c = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a',
    },
    Cc = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}',
    },
    Tc = {
        date: Ut({
            formats: Dc,
            defaultWidth: 'full',
        }),
        time: Ut({
            formats: $c,
            defaultWidth: 'full',
        }),
        dateTime: Ut({
            formats: Cc,
            defaultWidth: 'full',
        }),
    };
const xc = Tc;
var Vc = {
        lastWeek: "'last' eeee 'at' p",
        yesterday: "'yesterday at' p",
        today: "'today at' p",
        tomorrow: "'tomorrow at' p",
        nextWeek: "eeee 'at' p",
        other: 'P',
    },
    Mc = function (t, n, r, o) {
        return Vc[t];
    };
const Pc = Mc;
function Re(e) {
    return function (t, n) {
        var r = n != null && n.context ? String(n.context) : 'standalone',
            o;
        if (r === 'formatting' && e.formattingValues) {
            var i = e.defaultFormattingWidth || e.defaultWidth,
                s = n != null && n.width ? String(n.width) : i;
            o = e.formattingValues[s] || e.formattingValues[i];
        } else {
            var a = e.defaultWidth,
                u = n != null && n.width ? String(n.width) : e.defaultWidth;
            o = e.values[u] || e.values[a];
        }
        var d = e.argumentCallback ? e.argumentCallback(t) : t;
        return o[d];
    };
}
var Sc = {
        narrow: ['B', 'A'],
        abbreviated: ['BC', 'AD'],
        wide: ['Before Christ', 'Anno Domini'],
    },
    kc = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'],
    },
    Ic = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        wide: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ],
    },
    Ac = {
        narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    },
    Fc = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night',
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night',
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night',
        },
    },
    Rc = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night',
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night',
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night',
        },
    },
    Wc = function (t, n) {
        var r = Number(t),
            o = r % 100;
        if (o > 20 || o < 10)
            switch (o % 10) {
                case 1:
                    return r + 'st';
                case 2:
                    return r + 'nd';
                case 3:
                    return r + 'rd';
            }
        return r + 'th';
    },
    Lc = {
        ordinalNumber: Wc,
        era: Re({
            values: Sc,
            defaultWidth: 'wide',
        }),
        quarter: Re({
            values: kc,
            defaultWidth: 'wide',
            argumentCallback: function (t) {
                return t - 1;
            },
        }),
        month: Re({
            values: Ic,
            defaultWidth: 'wide',
        }),
        day: Re({
            values: Ac,
            defaultWidth: 'wide',
        }),
        dayPeriod: Re({
            values: Fc,
            defaultWidth: 'wide',
            formattingValues: Rc,
            defaultFormattingWidth: 'wide',
        }),
    };
const Uc = Lc;
function We(e) {
    return function (t) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
            r = n.width,
            o = (r && e.matchPatterns[r]) || e.matchPatterns[e.defaultMatchWidth],
            i = t.match(o);
        if (!i) return null;
        var s = i[0],
            a = (r && e.parsePatterns[r]) || e.parsePatterns[e.defaultParseWidth],
            u = Array.isArray(a)
                ? Hc(a, function (c) {
                      return c.test(s);
                  })
                : jc(a, function (c) {
                      return c.test(s);
                  }),
            d;
        ((d = e.valueCallback ? e.valueCallback(u) : u), (d = n.valueCallback ? n.valueCallback(d) : d));
        var h = t.slice(s.length);
        return {
            value: d,
            rest: h,
        };
    };
}
function jc(e, t) {
    for (var n in e) if (e.hasOwnProperty(n) && t(e[n])) return n;
}
function Hc(e, t) {
    for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
}
function Es(e) {
    return function (t) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
            r = t.match(e.matchPattern);
        if (!r) return null;
        var o = r[0],
            i = t.match(e.parsePattern);
        if (!i) return null;
        var s = e.valueCallback ? e.valueCallback(i[0]) : i[0];
        s = n.valueCallback ? n.valueCallback(s) : s;
        var a = t.slice(o.length);
        return {
            value: s,
            rest: a,
        };
    };
}
var Gc = /^(\d+)(th|st|nd|rd)?/i,
    Bc = /\d+/i,
    Yc = {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i,
    },
    qc = {
        any: [/^b/i, /^(a|c)/i],
    },
    Kc = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i,
    },
    Xc = {
        any: [/1/i, /2/i, /3/i, /4/i],
    },
    zc = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
    },
    Jc = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i],
    },
    Qc = {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
    },
    Zc = {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
    },
    ef = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
    },
    tf = {
        any: {
            am: /^a/i,
            pm: /^p/i,
            midnight: /^mi/i,
            noon: /^no/i,
            morning: /morning/i,
            afternoon: /afternoon/i,
            evening: /evening/i,
            night: /night/i,
        },
    },
    nf = {
        ordinalNumber: Es({
            matchPattern: Gc,
            parsePattern: Bc,
            valueCallback: function (t) {
                return parseInt(t, 10);
            },
        }),
        era: We({
            matchPatterns: Yc,
            defaultMatchWidth: 'wide',
            parsePatterns: qc,
            defaultParseWidth: 'any',
        }),
        quarter: We({
            matchPatterns: Kc,
            defaultMatchWidth: 'wide',
            parsePatterns: Xc,
            defaultParseWidth: 'any',
            valueCallback: function (t) {
                return t + 1;
            },
        }),
        month: We({
            matchPatterns: zc,
            defaultMatchWidth: 'wide',
            parsePatterns: Jc,
            defaultParseWidth: 'any',
        }),
        day: We({
            matchPatterns: Qc,
            defaultMatchWidth: 'wide',
            parsePatterns: Zc,
            defaultParseWidth: 'any',
        }),
        dayPeriod: We({
            matchPatterns: ef,
            defaultMatchWidth: 'any',
            parsePatterns: tf,
            defaultParseWidth: 'any',
        }),
    };
const rf = nf;
var of = {
    code: 'en-US',
    formatDistance: Oc,
    formatLong: xc,
    formatRelative: Pc,
    localize: Uc,
    match: rf,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1,
    },
};
const sf = of;
var af = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
    lf = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
    uf = /^'([^]*?)'?$/,
    cf = /''/g,
    ff = /[a-zA-Z]/;
function df(e, t, n) {
    var r, o, i, s, a, u, d, h, c, m, N, T, P, L, X, j, A, F;
    _e(2, arguments);
    var B = String(t),
        Y = nr(),
        C = (r = (o = n?.locale) !== null && o !== void 0 ? o : Y.locale) !== null && r !== void 0 ? r : sf,
        K = xt(
            (i =
                (s =
                    (a =
                        (u = n?.firstWeekContainsDate) !== null && u !== void 0
                            ? u
                            : n == null ||
                                (d = n.locale) === null ||
                                d === void 0 ||
                                (h = d.options) === null ||
                                h === void 0
                              ? void 0
                              : h.firstWeekContainsDate) !== null && a !== void 0
                        ? a
                        : Y.firstWeekContainsDate) !== null && s !== void 0
                    ? s
                    : (c = Y.locale) === null || c === void 0 || (m = c.options) === null || m === void 0
                      ? void 0
                      : m.firstWeekContainsDate) !== null && i !== void 0
                ? i
                : 1
        );
    if (!(K >= 1 && K <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var Q = xt(
        (N =
            (T =
                (P =
                    (L = n?.weekStartsOn) !== null && L !== void 0
                        ? L
                        : n == null ||
                            (X = n.locale) === null ||
                            X === void 0 ||
                            (j = X.options) === null ||
                            j === void 0
                          ? void 0
                          : j.weekStartsOn) !== null && P !== void 0
                    ? P
                    : Y.weekStartsOn) !== null && T !== void 0
                ? T
                : (A = Y.locale) === null || A === void 0 || (F = A.options) === null || F === void 0
                  ? void 0
                  : F.weekStartsOn) !== null && N !== void 0
            ? N
            : 0
    );
    if (!(Q >= 0 && Q <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!C.localize) throw new RangeError('locale must contain localize property');
    if (!C.formatLong) throw new RangeError('locale must contain formatLong property');
    var ue = je(e);
    if (!oc(ue)) throw new RangeError('Invalid time value');
    var ye = nc(ue),
        Ce = ic(ue, ye),
        Vt = {
            firstWeekContainsDate: K,
            weekStartsOn: Q,
            locale: C,
            _originalDate: ue,
        },
        gn = B.match(lf)
            .map(function (ie) {
                var oe = ie[0];
                if (oe === 'p' || oe === 'P') {
                    var W = vc[oe];
                    return W(ie, C.formatLong);
                }
                return ie;
            })
            .join('')
            .match(af)
            .map(function (ie) {
                if (ie === "''") return "'";
                var oe = ie[0];
                if (oe === "'") return pf(ie);
                var W = mc[oe];
                if (W)
                    return (
                        !(n != null && n.useAdditionalWeekYearTokens) && wc(ie) && Zo(ie, t, String(e)),
                        !(n != null && n.useAdditionalDayOfYearTokens) && bc(ie) && Zo(ie, t, String(e)),
                        W(Ce, ie, C.localize, Vt)
                    );
                if (oe.match(ff))
                    throw new RangeError('Format string contains an unescaped latin alphabet character `' + oe + '`');
                return ie;
            })
            .join('');
    return gn;
}
function pf(e) {
    var t = e.match(uf);
    return t ? t[1].replace(cf, "'") : e;
}
function ei(e, t, n) {
    _e(2, arguments);
    var r = Gt(e, n),
        o = Gt(t, n);
    return r.getTime() === o.getTime();
}
function Zt(e, t) {
    if (e.one !== void 0 && t === 1) return e.one;
    var n = t % 10,
        r = t % 100;
    return n === 1 && r !== 11
        ? e.singularNominative.replace('{{count}}', String(t))
        : n >= 2 && n <= 4 && (r < 10 || r > 20)
          ? e.singularGenitive.replace('{{count}}', String(t))
          : e.pluralGenitive.replace('{{count}}', String(t));
}
function we(e) {
    return function (t, n) {
        return n != null && n.addSuffix
            ? n.comparison && n.comparison > 0
                ? e.future
                    ? Zt(e.future, t)
                    : 'через ' + Zt(e.regular, t)
                : e.past
                  ? Zt(e.past, t)
                  : Zt(e.regular, t) + ' назад'
            : Zt(e.regular, t);
    };
}
var hf = {
        lessThanXSeconds: we({
            regular: {
                one: 'меньше секунды',
                singularNominative: 'меньше {{count}} секунды',
                singularGenitive: 'меньше {{count}} секунд',
                pluralGenitive: 'меньше {{count}} секунд',
            },
            future: {
                one: 'меньше, чем через секунду',
                singularNominative: 'меньше, чем через {{count}} секунду',
                singularGenitive: 'меньше, чем через {{count}} секунды',
                pluralGenitive: 'меньше, чем через {{count}} секунд',
            },
        }),
        xSeconds: we({
            regular: {
                singularNominative: '{{count}} секунда',
                singularGenitive: '{{count}} секунды',
                pluralGenitive: '{{count}} секунд',
            },
            past: {
                singularNominative: '{{count}} секунду назад',
                singularGenitive: '{{count}} секунды назад',
                pluralGenitive: '{{count}} секунд назад',
            },
            future: {
                singularNominative: 'через {{count}} секунду',
                singularGenitive: 'через {{count}} секунды',
                pluralGenitive: 'через {{count}} секунд',
            },
        }),
        halfAMinute: function (t, n) {
            return n != null && n.addSuffix
                ? n.comparison && n.comparison > 0
                    ? 'через полминуты'
                    : 'полминуты назад'
                : 'полминуты';
        },
        lessThanXMinutes: we({
            regular: {
                one: 'меньше минуты',
                singularNominative: 'меньше {{count}} минуты',
                singularGenitive: 'меньше {{count}} минут',
                pluralGenitive: 'меньше {{count}} минут',
            },
            future: {
                one: 'меньше, чем через минуту',
                singularNominative: 'меньше, чем через {{count}} минуту',
                singularGenitive: 'меньше, чем через {{count}} минуты',
                pluralGenitive: 'меньше, чем через {{count}} минут',
            },
        }),
        xMinutes: we({
            regular: {
                singularNominative: '{{count}} минута',
                singularGenitive: '{{count}} минуты',
                pluralGenitive: '{{count}} минут',
            },
            past: {
                singularNominative: '{{count}} минуту назад',
                singularGenitive: '{{count}} минуты назад',
                pluralGenitive: '{{count}} минут назад',
            },
            future: {
                singularNominative: 'через {{count}} минуту',
                singularGenitive: 'через {{count}} минуты',
                pluralGenitive: 'через {{count}} минут',
            },
        }),
        aboutXHours: we({
            regular: {
                singularNominative: 'около {{count}} часа',
                singularGenitive: 'около {{count}} часов',
                pluralGenitive: 'около {{count}} часов',
            },
            future: {
                singularNominative: 'приблизительно через {{count}} час',
                singularGenitive: 'приблизительно через {{count}} часа',
                pluralGenitive: 'приблизительно через {{count}} часов',
            },
        }),
        xHours: we({
            regular: {
                singularNominative: '{{count}} час',
                singularGenitive: '{{count}} часа',
                pluralGenitive: '{{count}} часов',
            },
        }),
        xDays: we({
            regular: {
                singularNominative: '{{count}} день',
                singularGenitive: '{{count}} дня',
                pluralGenitive: '{{count}} дней',
            },
        }),
        aboutXWeeks: we({
            regular: {
                singularNominative: 'около {{count}} недели',
                singularGenitive: 'около {{count}} недель',
                pluralGenitive: 'около {{count}} недель',
            },
            future: {
                singularNominative: 'приблизительно через {{count}} неделю',
                singularGenitive: 'приблизительно через {{count}} недели',
                pluralGenitive: 'приблизительно через {{count}} недель',
            },
        }),
        xWeeks: we({
            regular: {
                singularNominative: '{{count}} неделя',
                singularGenitive: '{{count}} недели',
                pluralGenitive: '{{count}} недель',
            },
        }),
        aboutXMonths: we({
            regular: {
                singularNominative: 'около {{count}} месяца',
                singularGenitive: 'около {{count}} месяцев',
                pluralGenitive: 'около {{count}} месяцев',
            },
            future: {
                singularNominative: 'приблизительно через {{count}} месяц',
                singularGenitive: 'приблизительно через {{count}} месяца',
                pluralGenitive: 'приблизительно через {{count}} месяцев',
            },
        }),
        xMonths: we({
            regular: {
                singularNominative: '{{count}} месяц',
                singularGenitive: '{{count}} месяца',
                pluralGenitive: '{{count}} месяцев',
            },
        }),
        aboutXYears: we({
            regular: {
                singularNominative: 'около {{count}} года',
                singularGenitive: 'около {{count}} лет',
                pluralGenitive: 'около {{count}} лет',
            },
            future: {
                singularNominative: 'приблизительно через {{count}} год',
                singularGenitive: 'приблизительно через {{count}} года',
                pluralGenitive: 'приблизительно через {{count}} лет',
            },
        }),
        xYears: we({
            regular: {
                singularNominative: '{{count}} год',
                singularGenitive: '{{count}} года',
                pluralGenitive: '{{count}} лет',
            },
        }),
        overXYears: we({
            regular: {
                singularNominative: 'больше {{count}} года',
                singularGenitive: 'больше {{count}} лет',
                pluralGenitive: 'больше {{count}} лет',
            },
            future: {
                singularNominative: 'больше, чем через {{count}} год',
                singularGenitive: 'больше, чем через {{count}} года',
                pluralGenitive: 'больше, чем через {{count}} лет',
            },
        }),
        almostXYears: we({
            regular: {
                singularNominative: 'почти {{count}} год',
                singularGenitive: 'почти {{count}} года',
                pluralGenitive: 'почти {{count}} лет',
            },
            future: {
                singularNominative: 'почти через {{count}} год',
                singularGenitive: 'почти через {{count}} года',
                pluralGenitive: 'почти через {{count}} лет',
            },
        }),
    },
    mf = function (t, n, r) {
        return hf[t](n, r);
    };
const gf = mf;
var vf = {
        full: "EEEE, d MMMM y 'г.'",
        long: "d MMMM y 'г.'",
        medium: "d MMM y 'г.'",
        short: 'dd.MM.y',
    },
    _f = {
        full: 'H:mm:ss zzzz',
        long: 'H:mm:ss z',
        medium: 'H:mm:ss',
        short: 'H:mm',
    },
    yf = {
        any: '{{date}}, {{time}}',
    },
    bf = {
        date: Ut({
            formats: vf,
            defaultWidth: 'full',
        }),
        time: Ut({
            formats: _f,
            defaultWidth: 'full',
        }),
        dateTime: Ut({
            formats: yf,
            defaultWidth: 'any',
        }),
    };
const wf = bf;
var ao = ['воскресенье', 'понедельник', 'вторник', 'среду', 'четверг', 'пятницу', 'субботу'];
function Ef(e) {
    var t = ao[e];
    switch (e) {
        case 0:
            return "'в прошлое " + t + " в' p";
        case 1:
        case 2:
        case 4:
            return "'в прошлый " + t + " в' p";
        case 3:
        case 5:
        case 6:
            return "'в прошлую " + t + " в' p";
    }
}
function ti(e) {
    var t = ao[e];
    return e === 2 ? "'во " + t + " в' p" : "'в " + t + " в' p";
}
function Nf(e) {
    var t = ao[e];
    switch (e) {
        case 0:
            return "'в следующее " + t + " в' p";
        case 1:
        case 2:
        case 4:
            return "'в следующий " + t + " в' p";
        case 3:
        case 5:
        case 6:
            return "'в следующую " + t + " в' p";
    }
}
var Of = {
        lastWeek: function (t, n, r) {
            var o = t.getUTCDay();
            return ei(t, n, r) ? ti(o) : Ef(o);
        },
        yesterday: "'вчера в' p",
        today: "'сегодня в' p",
        tomorrow: "'завтра в' p",
        nextWeek: function (t, n, r) {
            var o = t.getUTCDay();
            return ei(t, n, r) ? ti(o) : Nf(o);
        },
        other: 'P',
    },
    Df = function (t, n, r, o) {
        var i = Of[t];
        return typeof i == 'function' ? i(n, r, o) : i;
    };
const $f = Df;
var Cf = {
        narrow: ['до н.э.', 'н.э.'],
        abbreviated: ['до н. э.', 'н. э.'],
        wide: ['до нашей эры', 'нашей эры'],
    },
    Tf = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
        wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал'],
    },
    xf = {
        narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
        abbreviated: ['янв.', 'фев.', 'март', 'апр.', 'май', 'июнь', 'июль', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
        wide: [
            'январь',
            'февраль',
            'март',
            'апрель',
            'май',
            'июнь',
            'июль',
            'август',
            'сентябрь',
            'октябрь',
            'ноябрь',
            'декабрь',
        ],
    },
    Vf = {
        narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
        abbreviated: ['янв.', 'фев.', 'мар.', 'апр.', 'мая', 'июн.', 'июл.', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
        wide: [
            'января',
            'февраля',
            'марта',
            'апреля',
            'мая',
            'июня',
            'июля',
            'августа',
            'сентября',
            'октября',
            'ноября',
            'декабря',
        ],
    },
    Mf = {
        narrow: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
        short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
        abbreviated: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'суб'],
        wide: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
    },
    Pf = {
        narrow: {
            am: 'ДП',
            pm: 'ПП',
            midnight: 'полн.',
            noon: 'полд.',
            morning: 'утро',
            afternoon: 'день',
            evening: 'веч.',
            night: 'ночь',
        },
        abbreviated: {
            am: 'ДП',
            pm: 'ПП',
            midnight: 'полн.',
            noon: 'полд.',
            morning: 'утро',
            afternoon: 'день',
            evening: 'веч.',
            night: 'ночь',
        },
        wide: {
            am: 'ДП',
            pm: 'ПП',
            midnight: 'полночь',
            noon: 'полдень',
            morning: 'утро',
            afternoon: 'день',
            evening: 'вечер',
            night: 'ночь',
        },
    },
    Sf = {
        narrow: {
            am: 'ДП',
            pm: 'ПП',
            midnight: 'полн.',
            noon: 'полд.',
            morning: 'утра',
            afternoon: 'дня',
            evening: 'веч.',
            night: 'ночи',
        },
        abbreviated: {
            am: 'ДП',
            pm: 'ПП',
            midnight: 'полн.',
            noon: 'полд.',
            morning: 'утра',
            afternoon: 'дня',
            evening: 'веч.',
            night: 'ночи',
        },
        wide: {
            am: 'ДП',
            pm: 'ПП',
            midnight: 'полночь',
            noon: 'полдень',
            morning: 'утра',
            afternoon: 'дня',
            evening: 'вечера',
            night: 'ночи',
        },
    },
    kf = function (t, n) {
        var r = Number(t),
            o = n?.unit,
            i;
        return (
            o === 'date' ? (i = '-е') : o === 'week' || o === 'minute' || o === 'second' ? (i = '-я') : (i = '-й'),
            r + i
        );
    },
    If = {
        ordinalNumber: kf,
        era: Re({
            values: Cf,
            defaultWidth: 'wide',
        }),
        quarter: Re({
            values: Tf,
            defaultWidth: 'wide',
            argumentCallback: function (t) {
                return t - 1;
            },
        }),
        month: Re({
            values: xf,
            defaultWidth: 'wide',
            formattingValues: Vf,
            defaultFormattingWidth: 'wide',
        }),
        day: Re({
            values: Mf,
            defaultWidth: 'wide',
        }),
        dayPeriod: Re({
            values: Pf,
            defaultWidth: 'any',
            formattingValues: Sf,
            defaultFormattingWidth: 'wide',
        }),
    };
const Af = If;
var Ff = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i,
    Rf = /\d+/i,
    Wf = {
        narrow: /^((до )?н\.?\s?э\.?)/i,
        abbreviated: /^((до )?н\.?\s?э\.?)/i,
        wide: /^(до нашей эры|нашей эры|наша эра)/i,
    },
    Lf = {
        any: [/^д/i, /^н/i],
    },
    Uf = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
        wide: /^[1234](-?[ыои]?й?)? квартал/i,
    },
    jf = {
        any: [/1/i, /2/i, /3/i, /4/i],
    },
    Hf = {
        narrow: /^[яфмаисонд]/i,
        abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
        wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i,
    },
    Gf = {
        narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
        any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i],
    },
    Bf = {
        narrow: /^[впсч]/i,
        short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
        abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
        wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i,
    },
    Yf = {
        narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
        any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i],
    },
    qf = {
        narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
        abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
        wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i,
    },
    Kf = {
        any: {
            am: /^дп/i,
            pm: /^пп/i,
            midnight: /^полн/i,
            noon: /^полд/i,
            morning: /^у/i,
            afternoon: /^д[ен]/i,
            evening: /^в/i,
            night: /^н/i,
        },
    },
    Xf = {
        ordinalNumber: Es({
            matchPattern: Ff,
            parsePattern: Rf,
            valueCallback: function (t) {
                return parseInt(t, 10);
            },
        }),
        era: We({
            matchPatterns: Wf,
            defaultMatchWidth: 'wide',
            parsePatterns: Lf,
            defaultParseWidth: 'any',
        }),
        quarter: We({
            matchPatterns: Uf,
            defaultMatchWidth: 'wide',
            parsePatterns: jf,
            defaultParseWidth: 'any',
            valueCallback: function (t) {
                return t + 1;
            },
        }),
        month: We({
            matchPatterns: Hf,
            defaultMatchWidth: 'wide',
            parsePatterns: Gf,
            defaultParseWidth: 'any',
        }),
        day: We({
            matchPatterns: Bf,
            defaultMatchWidth: 'wide',
            parsePatterns: Yf,
            defaultParseWidth: 'any',
        }),
        dayPeriod: We({
            matchPatterns: qf,
            defaultMatchWidth: 'wide',
            parsePatterns: Kf,
            defaultParseWidth: 'any',
        }),
    };
const zf = Xf;
var Jf = {
    code: 'ru',
    formatDistance: gf,
    formatLong: wf,
    formatRelative: $f,
    localize: Af,
    match: zf,
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1,
    },
};
const Qf = Jf,
    Zf = (e) =>
        new Intl.NumberFormat('ru-RU', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(e),
    ed = (e) =>
        new Intl.NumberFormat('ru-RU', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(e),
    rr = (e) => (Number.isInteger(e) ? ed(e) : Zf(e)),
    td = (e) => df(new Date(e), 'd MMMM', {locale: Qf}),
    nd = {
        name: 'IInfo',
    },
    rd = {
        width: '17',
        height: '18',
        viewBox: '0 0 17 18',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    od = /* @__PURE__ */ I(
        'path',
        {
            d: 'M7.999 6.334a.833.833 0 100-1.667.833.833 0 000 1.667z',
            fill: 'currentColor',
        },
        null,
        -1
    ),
    id = /* @__PURE__ */ I(
        'path',
        {
            d: 'M8 8v5',
            stroke: 'currentColor',
            'stroke-width': '1.5',
            'stroke-linecap': 'round',
        },
        null,
        -1
    ),
    sd = /* @__PURE__ */ I(
        'path',
        {
            d: 'M2.813 14.186a7.333 7.333 0 1110.371-10.37 7.333 7.333 0 01-10.37 10.37',
            stroke: 'currentColor',
            'stroke-width': '1.5',
        },
        null,
        -1
    ),
    ad = [od, id, sd];
function ld(e, t, n, r, o, i) {
    return (te(), fe('svg', rd, ad));
}
const Ns = /* @__PURE__ */ $e(nd, [['render', ld]]),
    ud = '_root_16fmr_1',
    cd = '_dark_16fmr_10',
    fd = '_text_16fmr_15',
    dd = '_link_16fmr_22',
    pd = {
        root: ud,
        dark: cd,
        text: fd,
        link: dd,
    },
    hd = {
        __name: 'BnplWidgetTwo',
        props: {
            params: Object,
        },
        setup(e) {
            const t = e,
                n = Tt(() => `4 платежа по ${rr(Math.round(t.params.price / 4))} ₽`);
            return (r, o) => (
                te(),
                fe(
                    'div',
                    {
                        class: U([r.$style.root, t.params.isDarkTheme && r.$style.dark]),
                    },
                    [
                        I(
                            'span',
                            {
                                class: U(r.$style.text),
                            },
                            'давай делить',
                            2
                        ),
                        I(
                            'div',
                            {
                                class: U(r.$style.link),
                            },
                            [I('span', null, jt(n.value), 1), pe(Ns)],
                            2
                        ),
                    ],
                    2
                )
            );
        },
    },
    md = {
        $style: pd,
    },
    gd = /* @__PURE__ */ $e(hd, [['__cssModules', md]]),
    vd = '_root_1u9kw_1',
    _d = '_dark_1u9kw_11',
    yd = '_text_1u9kw_17',
    bd = '_link_1u9kw_24',
    wd = {
        root: vd,
        dark: _d,
        text: yd,
        link: bd,
    },
    Ed = {
        __name: 'BnplWidgetThree',
        props: {
            params: Object,
        },
        setup(e) {
            const t = e,
                n = Tt(() => `4 платежа по ${rr(Math.round(t.params.price / 4))} ₽`);
            return (r, o) => (
                te(),
                fe(
                    'div',
                    {
                        class: U([r.$style.root, t.params.isDarkTheme && r.$style.dark]),
                    },
                    [
                        I(
                            'span',
                            {
                                class: U(r.$style.text),
                            },
                            'давай делить',
                            2
                        ),
                        I(
                            'div',
                            {
                                class: U(r.$style.link),
                            },
                            [I('span', null, jt(n.value), 1), pe(Ns)],
                            2
                        ),
                    ],
                    2
                )
            );
        },
    },
    Nd = {
        $style: wd,
    },
    Od = /* @__PURE__ */ $e(Ed, [['__cssModules', Nd]]),
    Dd = {
        name: 'IChart',
    },
    $d = {
        fill: 'none',
        height: '68',
        viewBox: '0 0 68 68',
        width: '68',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    Cd = /* @__PURE__ */ I(
        'circle',
        {
            cx: '34',
            cy: '34',
            fill: '#9E6FC3',
            r: '34',
        },
        null,
        -1
    ),
    Td = /* @__PURE__ */ I(
        'path',
        {
            d: 'M45.1306 35.969C44.1464 41.1627 39.5861 45.1024 34.1102 45.1024C27.9248 45.1024 22.8896 40.0633 22.8896 33.8732C22.8896 28.3817 26.8377 23.8064 32.0446 22.8329V19.9011C25.2355 20.9089 20 26.7898 20 33.8789C20 41.6666 26.3284 47.9999 34.1102 47.9999C41.1767 47.9999 47.0474 42.7775 48.0659 35.9747H45.1306V35.969Z',
            fill: 'white',
        },
        null,
        -1
    ),
    xd = /* @__PURE__ */ I(
        'path',
        {
            d: 'M50 32.121C50 32.6077 49.9771 33.0887 49.9256 33.564H35.8898L34.4479 32.121V18.0744C34.9228 18.0229 35.4034 18 35.8898 18C36.3762 18 36.8625 18.0229 37.3317 18.0744C43.9634 18.7501 49.2504 24.0469 49.9256 30.6779C49.9771 31.1532 50 31.6285 50 32.121Z',
            fill: 'white',
        },
        null,
        -1
    ),
    Vd = [Cd, Td, xd];
function Md(e, t, n, r, o, i) {
    return (te(), fe('svg', $d, Vd));
}
const Pd = /* @__PURE__ */ $e(Dd, [['render', Md]]),
    Sd = '_root_1cs5x_1',
    kd = '_dark_1cs5x_13',
    Id = '_container_1cs5x_19',
    Ad = '_text_1cs5x_25',
    Fd = '_sumPay_1cs5x_32',
    Rd = '_link_1cs5x_39',
    Wd = {
        root: Sd,
        dark: kd,
        container: Id,
        text: Ad,
        sumPay: Fd,
        link: Rd,
    },
    Ld = {
        __name: 'BnplWidgetFour',
        props: {
            params: Object,
        },
        setup(e) {
            const t = e,
                n = Tt(() => `4 платежа по ${rr(Math.round(t.params.price / 4))} ₽`);
            return (r, o) => (
                te(),
                fe(
                    'div',
                    {
                        class: U([r.$style.root, t.params.isDarkTheme && r.$style.dark]),
                    },
                    [
                        pe(Pd),
                        I(
                            'div',
                            {
                                class: U(r.$style.container),
                            },
                            [
                                I(
                                    'span',
                                    {
                                        class: U(r.$style.text),
                                    },
                                    'давай делить',
                                    2
                                ),
                                I(
                                    'span',
                                    {
                                        class: U(r.$style.sumPay),
                                    },
                                    jt(n.value),
                                    3
                                ),
                                I(
                                    'span',
                                    {
                                        class: U(r.$style.link),
                                    },
                                    'Подробнее',
                                    2
                                ),
                            ],
                            2
                        ),
                    ],
                    2
                )
            );
        },
    },
    Ud = {
        $style: Wd,
    },
    jd = /* @__PURE__ */ $e(Ld, [['__cssModules', Ud]]),
    Hd = {
        name: 'IChartSmall',
    },
    Gd = {
        fill: 'none',
        height: '20',
        viewBox: '0 0 16 20',
        width: '16',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    Bd = /* @__PURE__ */ I(
        'path',
        {
            d: 'M13.403 12.0835C12.8781 14.8535 10.4459 16.9546 7.52546 16.9546C4.22659 16.9546 1.54111 14.2671 1.54111 10.9657C1.54111 8.03692 3.64677 5.59676 6.42381 5.07757V3.51392C2.7923 4.05142 0 7.1879 0 10.9688C0 15.1222 3.37517 18.5 7.52546 18.5C11.2943 18.5 14.4253 15.7147 14.9685 12.0865H13.403V12.0835Z',
            fill: 'currentColor',
        },
        null,
        -1
    ),
    Yd = /* @__PURE__ */ I(
        'path',
        {
            d: 'M16 10.0312C16 10.2908 15.9878 10.5473 15.9603 10.8008H8.47454L7.70551 10.0312V2.5397C7.9588 2.51222 8.21514 2.5 8.47454 2.5C8.73393 2.5 8.99332 2.51222 9.24356 2.5397C12.7805 2.90008 15.6002 5.72504 15.9603 9.26159C15.9878 9.51508 16 9.76857 16 10.0312Z',
            fill: 'currentColor',
        },
        null,
        -1
    ),
    qd = [Bd, Yd];
function Kd(e, t, n, r, o, i) {
    return (te(), fe('svg', Gd, qd));
}
const Xd = /* @__PURE__ */ $e(Hd, [['render', Kd]]),
    zd = '_root_1a58k_1',
    Jd = '_dark_1a58k_5',
    Qd = '_line_1a58k_9',
    Zd = '_sum_1a58k_15',
    ep = '_active_1a58k_22',
    tp = {
        root: zd,
        dark: Jd,
        line: Qd,
        sum: Zd,
        active: ep,
    },
    np = {
        __name: 'ScheduleItem',
        props: {
            item: Object,
            isDarkTheme: Boolean,
        },
        setup(e) {
            return (t, n) => (
                te(),
                fe(
                    'div',
                    {
                        class: U([t.$style.root, e.item.isActive && t.$style.active, e.isDarkTheme && t.$style.dark]),
                    },
                    [
                        I(
                            'div',
                            {
                                class: U(t.$style.line),
                            },
                            null,
                            2
                        ),
                        I('div', null, jt(e.item.date), 1),
                        I(
                            'div',
                            {
                                class: U(t.$style.sum),
                            },
                            jt(e.item.sum),
                            3
                        ),
                    ],
                    2
                )
            );
        },
    },
    rp = {
        $style: tp,
    },
    op = /* @__PURE__ */ $e(np, [['__cssModules', rp]]),
    ip = '_root_w28u7_1',
    sp = '_dark_w28u7_9',
    ap = '_icon_w28u7_14',
    lp = '_title_container_w28u7_18',
    up = '_title_w28u7_18',
    cp = '_schedule_w28u7_33',
    fp = {
        root: ip,
        dark: sp,
        icon: ap,
        title_container: lp,
        title: up,
        schedule: cp,
    },
    dp = /* @__PURE__ */ I('span', null, 'давай делить', -1),
    ni = 4,
    pp = {
        __name: 'BnplWidgetFive',
        props: {
            params: Object,
        },
        setup(e) {
            const t = e,
                n = Tt(() => o(/* @__PURE__ */ new Date(), 4, !0)),
                r = Tt(() => `${rr(t.params.price)} ₽`);
            function o(i, s, a = !1) {
                if (s <= 0) return [];
                const u = a ? 'Сегодня' : td(i).slice(0, 6),
                    d = new Date(i.getTime() + 2 * 7 * 24 * 60 * 60 * 1e3),
                    h = Math.round(t.params.price / ni),
                    c = t.params.price - h * (ni - 1),
                    m = c % 1 !== 0 ? c.toFixed(2) : c,
                    N = s > 1 ? `${h} ₽` : `${m} ₽`;
                return [
                    {
                        date: u,
                        sum: N,
                        isActive: a,
                    },
                    ...o(d, s - 1),
                ];
            }
            return (i, s) => (
                te(),
                fe(
                    'div',
                    {
                        class: U([i.$style.root, t.params.isDarkTheme && i.$style.dark]),
                    },
                    [
                        I(
                            'div',
                            {
                                class: U(i.$style.title_container),
                            },
                            [
                                I(
                                    'div',
                                    {
                                        class: U(i.$style.title),
                                    },
                                    [
                                        pe(
                                            Xd,
                                            {
                                                class: U(i.$style.icon),
                                            },
                                            null,
                                            8,
                                            ['class']
                                        ),
                                        dp,
                                    ],
                                    2
                                ),
                                I('div', null, jt(r.value), 1),
                            ],
                            2
                        ),
                        I(
                            'div',
                            {
                                class: U(i.$style.schedule),
                            },
                            [
                                (te(!0),
                                fe(
                                    Oe,
                                    null,
                                    pl(
                                        n.value,
                                        (a, u) => (
                                            te(),
                                            ut(
                                                op,
                                                {
                                                    key: u,
                                                    'is-dark-theme': t.params.isDarkTheme,
                                                    item: a,
                                                },
                                                null,
                                                8,
                                                ['is-dark-theme', 'item']
                                            )
                                        )
                                    ),
                                    128
                                )),
                            ],
                            2
                        ),
                    ],
                    2
                )
            );
        },
    },
    hp = {
        $style: fp,
    },
    Os = /* @__PURE__ */ $e(pp, [['__cssModules', hp]]),
    mp = '_wide_15mzm_1',
    gp = {
        wide: mp,
    },
    vp = /* @__PURE__ */ el({
        components: {
            BnplWidgetOne: Zu,
            BnplWidgetTwo: gd,
            BnplWidgetThree: Od,
            BnplWidgetFour: jd,
            BnplWidgetFive: Os,
        },
        props: {
            dataParams: {
                type: Object,
            },
        },
        setup(e) {
            const t = Yt(window.widgetParams || e.dataParams || {});
            return (
                (window.updateWidgetParams = (n) => {
                    Object.assign(t, n);
                }),
                {
                    params: t,
                }
            );
        },
    });
function _p(e, t, n, r, o, i) {
    return e.params
        ? (te(),
          ut(
              Ya(e.params.view),
              {
                  key: 0,
                  class: U([e.params?.wide && e.$style.wide]),
                  params: e.params,
              },
              null,
              8,
              ['class', 'params']
          ))
        : _t('', !0);
}
const yp = {
        $style: gp,
    },
    bp = /* @__PURE__ */ $e(vp, [
        ['render', _p],
        ['__cssModules', yp],
    ]),
    wp = {},
    Ep = {
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    Np = /* @__PURE__ */ I(
        'path',
        {
            d: 'M4 20L20 4',
            stroke: 'currentColor',
            'stroke-width': '2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
        },
        null,
        -1
    ),
    Op = /* @__PURE__ */ I(
        'path',
        {
            d: 'M20 20L4 4',
            stroke: 'currentColor',
            'stroke-width': '2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
        },
        null,
        -1
    ),
    Dp = [Np, Op];
function $p(e, t) {
    return (te(), fe('svg', Ep, Dp));
}
const Cp = /* @__PURE__ */ $e(wp, [['render', $p]]),
    Tp = '_root_1hact_1',
    xp = '_dark_1hact_16',
    Vp = '_inner_1hact_16',
    Mp = '_description_1hact_17',
    Pp = '_title_1hact_18',
    Sp = '_header_1hact_19',
    kp = '_content_1hact_20',
    Ip = '_container_1hact_67',
    Ap = '_footer_1hact_88',
    Fp = '_close_1hact_94',
    Rp = {
        root: Tp,
        dark: xp,
        inner: Vp,
        description: Mp,
        title: Pp,
        header: Sp,
        content: kp,
        'buttons-inner': '_buttons-inner_1hact_21',
        container: Ip,
        footer: Ap,
        close: Fp,
    },
    Wp = {
        __name: 'ModalWindow',
        props: {
            isDarkTheme: Boolean,
        },
        emits: ['close'],
        setup(e, {emit: t}) {
            const n = t,
                r = e;
            function o() {
                n('close');
            }
            return (i, s) => {
                const a = qa('click-outside');
                return (
                    te(),
                    ut(Yl, {to: 'body'}, [
                        I(
                            'div',
                            {
                                class: U([i.$style.root, r.isDarkTheme && i.$style.dark]),
                            },
                            [
                                I(
                                    'div',
                                    {
                                        class: U(i.$style.container),
                                    },
                                    [
                                        Za(
                                            (te(),
                                            fe(
                                                'div',
                                                {
                                                    class: U(i.$style.inner),
                                                },
                                                [
                                                    I(
                                                        'div',
                                                        {
                                                            class: U(i.$style.close),
                                                            onClick: o,
                                                        },
                                                        [pe(Cp)],
                                                        2
                                                    ),
                                                    i.$slots.header
                                                        ? (te(),
                                                          fe(
                                                              'div',
                                                              {
                                                                  key: 0,
                                                                  class: U(i.$style.header),
                                                              },
                                                              [zt(i.$slots, 'header')],
                                                              2
                                                          ))
                                                        : _t('', !0),
                                                    i.$slots.title
                                                        ? (te(),
                                                          fe(
                                                              'div',
                                                              {
                                                                  key: 1,
                                                                  class: U(i.$style.title),
                                                              },
                                                              [zt(i.$slots, 'title')],
                                                              2
                                                          ))
                                                        : _t('', !0),
                                                    i.$slots.description
                                                        ? (te(),
                                                          fe(
                                                              'div',
                                                              {
                                                                  key: 2,
                                                                  class: U(i.$style.description),
                                                              },
                                                              [zt(i.$slots, 'description')],
                                                              2
                                                          ))
                                                        : _t('', !0),
                                                    I('div', null, [
                                                        I(
                                                            'div',
                                                            {
                                                                class: U(i.$style.content),
                                                            },
                                                            [zt(i.$slots, 'default')],
                                                            2
                                                        ),
                                                    ]),
                                                    I(
                                                        'div',
                                                        {
                                                            class: U(i.$style.footer),
                                                        },
                                                        [
                                                            i.$slots.buttons
                                                                ? (te(),
                                                                  fe(
                                                                      'div',
                                                                      {
                                                                          key: 0,
                                                                          class: U(i.$style['buttons-inner']),
                                                                      },
                                                                      [zt(i.$slots, 'buttons')],
                                                                      2
                                                                  ))
                                                                : _t('', !0),
                                                        ],
                                                        2
                                                    ),
                                                ],
                                                2
                                            )),
                                            [[a, o]]
                                        ),
                                    ],
                                    2
                                ),
                            ],
                            2
                        ),
                    ])
                );
            };
        },
    },
    Lp = {
        $style: Rp,
    },
    Up = /* @__PURE__ */ $e(Wp, [['__cssModules', Lp]]);
var jp = {
    VITE_PUBLIC_PATH: '/',
    VITE_BASE_URL: 'https://davay-delit.ru',
    BASE_URL: '/',
    MODE: 'production',
    DEV: !1,
    PROD: !0,
    SSR: !1,
};
const {VITE_BASE_URL: ri} = jp,
    Hp = {
        VITE_BASE_URL: ri,
        VITE_LANDING_BASE_URL: `${ri}/landing`,
    },
    Gp = '_link_bih1d_1',
    Bp = '_white_bih1d_15',
    Yp = '_widget_bih1d_19',
    qp = {
        link: Gp,
        white: Bp,
        widget: Yp,
    },
    Kp = /* @__PURE__ */ I('br', null, null, -1),
    Xp = /* @__PURE__ */ I('br', null, null, -1),
    zp = /* @__PURE__ */ I('br', null, null, -1),
    Jp = ['href'],
    Qp = {
        __name: 'BnplWidgetModal',
        props: {
            dataParams: Object,
        },
        setup(e) {
            const t = e,
                n = Vi(window.widgetParams),
                r = Tt(() => n.value ?? Yt({...(t.dataParams || {})}));
            return (o, i) => (
                te(),
                ut(
                    Up,
                    {
                        'is-dark-theme': r.value.isDarkTheme,
                        onClose: i[0] || (i[0] = (s) => o.$emit('close')),
                    },
                    hl(
                        {
                            title: At(() => [Ze('Сумма покупки легко '), Kp, Ze(' делится на 4 равных платежа ')]),
                            description: At(() => [
                                Ze(
                                    ' Оплати сразу только первую часть, а остальные спишутся по графику автоматически! '
                                ),
                            ]),
                            default: At(() => [
                                r.value.price
                                    ? (te(),
                                      ut(
                                          Os,
                                          {
                                              key: 0,
                                              class: U(o.$style.widget),
                                              params: r.value,
                                          },
                                          null,
                                          8,
                                          ['class', 'params']
                                      ))
                                    : _t('', !0),
                                Ze(' Нам не нужны детальные данные паспорта. Только ФИО и дата рождения. '),
                                Xp,
                                zp,
                                Ze(
                                    ' Платежи будут списываться автоматически с прикрепленной карты, но ты всегда можешь зайти в личный кабинет и оплатить досрочно. '
                                ),
                            ]),
                            buttons: At(() => [
                                I(
                                    'a',
                                    {
                                        class: U([o.$style.link, r.value.isDarkTheme && o.$style.white]),
                                        href: Mi(Hp).VITE_BASE_URL,
                                        target: '_blank',
                                    },
                                    [Ze(' Подробнее на сайте сервиса '), pe(_s)],
                                    10,
                                    Jp
                                ),
                            ]),
                            _: 2,
                        },
                        [
                            r.value.price
                                ? void 0
                                : {
                                      name: 'header',
                                      fn: At(() => [Ze('давай делить')]),
                                      key: '0',
                                  },
                        ]
                    ),
                    1032,
                    ['is-dark-theme']
                )
            );
        },
    },
    Zp = {
        $style: qp,
    },
    eh = /* @__PURE__ */ $e(Qp, [['__cssModules', Zp]]),
    th = {
        __name: 'App',
        props: {
            price: Number,
            view: String,
            isDarkTheme: Boolean,
            wide: Boolean,
        },
        setup(e) {
            const t = Vi(!1),
                r = Yt({...e});
            return (o, i) => (
                te(),
                fe(
                    Oe,
                    null,
                    [
                        pe(
                            bp,
                            {
                                'data-params': r,
                                class: 'bnpl-widget',
                                onClick: i[0] || (i[0] = (s) => (t.value = !0)),
                            },
                            null,
                            8,
                            ['data-params']
                        ),
                        t.value
                            ? (te(),
                              ut(
                                  eh,
                                  {
                                      key: 0,
                                      'data-params': r,
                                      onClose: i[1] || (i[1] = (s) => (t.value = !1)),
                                  },
                                  null,
                                  8,
                                  ['data-params']
                              ))
                            : _t('', !0),
                    ],
                    64
                )
            );
        },
    };
var nh =
    typeof globalThis < 'u'
        ? globalThis
        : typeof window < 'u'
          ? window
          : typeof global < 'u'
            ? global
            : typeof self < 'u'
              ? self
              : {};
function rh(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, 'default') ? e.default : e;
}
var Ds = {exports: {}};
(function (e, t) {
    (function (n, r) {
        e.exports = r();
    })(nh, function () {
        var n = '__v-click-outside',
            r = typeof window < 'u',
            o = typeof navigator < 'u',
            i = r && ('ontouchstart' in window || (o && navigator.msMaxTouchPoints > 0)) ? ['touchstart'] : ['click'],
            s = function (h) {
                var c = h.event,
                    m = h.handler;
                (0, h.middleware)(c) && m(c);
            },
            a = function (h, c) {
                var m = (function (j) {
                        var A = typeof j == 'function';
                        if (!A && typeof j != 'object')
                            throw new Error('v-click-outside: Binding value must be a function or an object');
                        return {
                            handler: A ? j : j.handler,
                            middleware:
                                j.middleware ||
                                function (F) {
                                    return F;
                                },
                            events: j.events || i,
                            isActive: j.isActive !== !1,
                            detectIframe: j.detectIframe !== !1,
                            capture: !!j.capture,
                        };
                    })(c.value),
                    N = m.handler,
                    T = m.middleware,
                    P = m.detectIframe,
                    L = m.capture;
                if (m.isActive) {
                    if (
                        ((h[n] = m.events.map(function (j) {
                            return {
                                event: j,
                                srcTarget: document.documentElement,
                                handler: function (A) {
                                    return (function (F) {
                                        var B = F.el,
                                            Y = F.event,
                                            C = F.handler,
                                            K = F.middleware,
                                            Q = Y.path || (Y.composedPath && Y.composedPath());
                                        (Q ? Q.indexOf(B) < 0 : !B.contains(Y.target)) &&
                                            s({event: Y, handler: C, middleware: K});
                                    })({el: h, event: A, handler: N, middleware: T});
                                },
                                capture: L,
                            };
                        })),
                        P)
                    ) {
                        var X = {
                            event: 'blur',
                            srcTarget: window,
                            handler: function (j) {
                                return (function (A) {
                                    var F = A.el,
                                        B = A.event,
                                        Y = A.handler,
                                        C = A.middleware;
                                    setTimeout(function () {
                                        var K = document.activeElement;
                                        K &&
                                            K.tagName === 'IFRAME' &&
                                            !F.contains(K) &&
                                            s({event: B, handler: Y, middleware: C});
                                    }, 0);
                                })({el: h, event: j, handler: N, middleware: T});
                            },
                            capture: L,
                        };
                        h[n] = [].concat(h[n], [X]);
                    }
                    h[n].forEach(function (j) {
                        var A = j.event,
                            F = j.srcTarget,
                            B = j.handler;
                        return setTimeout(function () {
                            h[n] && F.addEventListener(A, B, L);
                        }, 0);
                    });
                }
            },
            u = function (h) {
                ((h[n] || []).forEach(function (c) {
                    return c.srcTarget.removeEventListener(c.event, c.handler, c.capture);
                }),
                    delete h[n]);
            },
            d = r
                ? {
                      beforeMount: a,
                      updated: function (h, c) {
                          var m = c.value,
                              N = c.oldValue;
                          JSON.stringify(m) !== JSON.stringify(N) && (u(h), a(h, {value: m}));
                      },
                      unmounted: u,
                  }
                : {};
        return {
            install: function (h) {
                h.directive('click-outside', d);
            },
            directive: d,
        };
    });
})(Ds);
var oh = Ds.exports;
const ih = /* @__PURE__ */ rh(oh);
document.querySelectorAll('#otp-widget-bnpl').forEach((e) => {
    let t = null;
    const n = (i) => {
        (t && t.unmount(), (t = Su(th, i)), t.use(ih), t.mount(e));
    };
    let r = JSON.parse(e.dataset.params || '{}');
    (n(r),
        new MutationObserver((i) => {
            i.forEach((s) => {
                if (s.type === 'attributes' && s.attributeName === 'data-params') {
                    const a = JSON.parse(e.dataset.params || '{}');
                    n(a);
                }
            });
        }).observe(e, {
            attributes: !0,
            attributeFilter: ['data-params'],
        }));
});
